<template>
  <div id="studentpaymentplan">
    <div class="col-lg-12">
      <div v-if="showTourDropdown">
        <template>
          <el-select v-on:change="studentPaymentPlanTourStart(tourPageControl)" v-model="tourPageControl" clearable placeholder="Select Tour">
            <el-option v-for="item in TourOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </template>
      </div>
      <div class="payment-title-wrap container mt-2">
        <h5 class="text-left payment-title" id="StudentInformation">
          <b>{{ lang('Payment') }}{{ lang('Page') }}</b>
        </h5>
      </div>
      <div class="payment-header">
        <div class="container">
          <div class="payment-student-info">
            <div class="payment-student-object">
              <h4>{{ inputStudentName }}</h4>
              <span>{{ lang('Student') }}{{ lang('Name') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ inputStudentNO }}</h4>
              <span>{{ lang('Student') }}{{ lang('NO') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ inputMealPreferences }}</h4>
              <span>{{ lang('Meal Preferences') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ inputStudentClassBatch }}</h4>
              <span>{{ lang('Class') }}/{{ lang('Programme') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ inputPayeeName }}</h4>
              <span>{{ lang('Payee') }}{{ lang('Name') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="payment-header">
        <div class="container">
          <div class="payment-student-info">
            <div class="payment-student-object">
              <h4>{{ FrequentPayments }}</h4>
              <span>{{ lang('Payment') }}{{ lang('Frequency') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ Cda }}</h4>
              <span>{{ lang('CDA') }}</span>
            </div>
            <div class="payment-student-object">
              <h4>{{ SubsidyDesc }}</h4>
              <span>{{ lang('Subsidy Description') }}</span>
            </div>
            <div class="payment-student-object">
            </div>
            <div class="payment-student-object">
            </div>
          </div>
        </div>
      </div>
      <div class="student-course-list container mt-5">
        <template>
          <div>
            <b-card no-body>
              <b-tabs content-class="mt-3" pills card>
                <b-tab :title="lang('Siblings')" active>
                  <div v-if="siblingListTableInt.length > 0" class="datatable_group">
                    <data-tables layout="table" :data="siblingListTableInt" :action-col="siblingListAction">
                      <el-table-column v-for="siblingItem in siblingListTableList" :prop="siblingItem.prop" :label="siblingItem.label" :key="siblingItem.prop">
                      </el-table-column>
                    </data-tables>
                  </div>
                  <div v-else class="siblingNoRecordArea">
                    <label style="text-align: center">{{ lang('No') }}{{ lang('Siblings') }}...</label>
                  </div>
                </b-tab>
                <b-tab :title="lang('Parent') + '' + lang('Info')">
                  <div v-if="parentListTableInt.length > 0" class="datatable_group">
                    <b>{{ lang('Family') }} {{ lang('Number') }}: {{ familyNumber }}</b>
                    <data-tables layout="table" :data="parentListTableInt">
                      <el-table-column v-for="Item in parentListTable" :prop="Item.prop" :label="Item.label" :key="Item.prop"> </el-table-column>
                    </data-tables>
                  </div>
                  <div v-else class="parentNoRecordArea">
                    <label>{{ lang('Parent') }} {{ lang('info not found') }}...</label>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </template>

        <div class="row payment-list-header">
          <div class="col-lg-6">
            <h5 class="text-left payment-title" id="Payment_List">
              <b>{{ lang('Payment') }}{{ lang('List') }}</b>
            </h5>
          </div>
          <div class="col-lg-6 text-right">
            <div class="paymentList-button-group">
              <span>{{ lang('Generate') }} / {{ lang('Preview') }}</span>
              <el-button-group v-if="PaymentListInt.length > 0">
                <el-button data-v-step="app01" v-on:click="showGenerateInvoice" :disabled="btnInvRecDisabled" type="primary" size="small">
                  <i class="material-icons"> attach_money </i> {{ lang('Invoice') }}
                </el-button>

                <el-button v-if="1 === 2" data-v-step="gr01" v-on:click="showGenerateReceipt" :disabled="btnInvRecDisabled" type="primary" size="small">
                  <i class="material-icons"> receipt </i> {{ lang('Receipt') }}
                </el-button>
              </el-button-group>
            </div>
          </div>
        </div>

        <div class="empty-list_icon" v-if="PaymentListInt && PaymentListInt.length < 1">
          <div class="mb-3">
            <img src="../assets/notfound-icon.png" />
            <strong class="">{{ lang('No Data Found') }}...</strong>
          </div>
          <el-button-group :disabled="AuditDisabled">
            <el-button v-on:click="showGenerateInvoice" :disabled="btnInvRecDisabled" type="primary" size="small">
              {{ lang('Generate') }}/{{ lang('Preview') }} {{ lang('Invoice') }}
            </el-button>
            <el-button v-on:click="showGenerateReceipt" :disabled="btnInvRecDisabled" type="primary" size="small">
              {{ lang('Generate') }}/{{ lang('Preview') }} {{ lang('Receipt') }}
            </el-button>
          </el-button-group>
        </div>
        <div v-if="PaymentListInt.length > 0" class="datatable_group">
          <data-tables :data="PaymentListInt" :filters="PaymentListFilters" layout="table">
            <el-table-column v-for="PaymentItem in PaymentList" :prop="PaymentItem.prop" :label="PaymentItem.label" :key="PaymentItem.prop"> </el-table-column>
            <el-table-column :label="lang('CN/Receipt')" min-width="70px">
              <template slot-scope="scope">
                <div class="receiptScope" v-for="item in splitReceiptList(scope.row.recNameList)" v-bind:key="item.ID">
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="lang('Action')" min-width="70px">
              <template slot-scope="scope">
                <div>
                  <a href="#" class="payment-icon paymentIcon-transaction" @click="showTransaction(scope.row)">
                    <el-tooltip class="item" effect="dark" :content="lang('Show') + ' ' + lang('Transaction')" placement="top-start">
                      <i class="el-icon-sort"></i>
                    </el-tooltip>
                  </a>
                  <a
                    href="#"
                    class="payment-icon paymentIcon-transaction"
                    data-v-step="rfMaster01"
                    @click="showRefund(scope.row)"
                    v-if="scope.row.refundFlag == 'Yes' && AuditDisabled == false"
                  >
                    <el-tooltip class="item" effect="dark" :content="lang('Show') + ' ' + lang('Refund')" placement="top-start">
                      <i class="material-icons" style="color: darkcyan"> payment </i>
                    </el-tooltip>
                  </a>
                  <a
                    href="#"
                    v-if="scope.row.generateReceiptFlag == 'Yes' && btnDisabled == false && AuditDisabled == false"
                    class="payment-icon paymentIcon-receipt"
                    @click="showGenerateReceiptByHistory(scope.row)"
                  >
                    <el-tooltip class="item" effect="dark" :content="lang('Generate') + ' ' + lang('Receipt')" placement="top-start">
                      <i class="material-icons"> receipt </i>
                    </el-tooltip>
                  </a>
                  <a
                    href="#"
                    v-if="scope.row.generateCNFlag == 'Yes' && btnDisabled == false && AuditDisabled == false"
                    class="payment-icon paymentIcon-CreditNote"
                    @click="showGenerateCreditNote(scope.row)"
                    data-v-step="gcn01"
                  >
                    <el-tooltip class="item" effect="dark" :content="lang('Generate') + ' ' + lang('Credit Note')" placement="top-start">
                      <i class="fa fa-money" aria-hidden="true"></i>
                    </el-tooltip>
                  </a>
                  <a
                    href="#"
                    v-if="scope.row.reInvoiceFlag == 'Yes' && btnDisabled == false && AuditDisabled == false"
                    class="payment-icon paymentIcon-Invoice"
                    @click="showReInvoice(scope.row)"
                  >
                    <el-tooltip class="item" effect="dark" :content="lang('Re-Invoice')" placement="top-start">
                      <i class="material-icons"> attach_money </i>
                    </el-tooltip>
                  </a>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>

    <b-modal
      id="viewTransactionModal"
      size="xl"
      :title="lang('Transactions History')"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="viewTransactionShowModal"
    >
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="studentReceiptGenerationByTransactionHistoryListInt.length > 0">
            <data-tables :data="studentReceiptGenerationByTransactionHistoryListInt" layout="table">
              <el-table-column :label="lang('Document') + '' + lang('Number')" min-width="35px">
                <template slot-scope="scope">
                  <a href="#" style="color: blue" @click="getTransactionDocumentPdf(scope.row)">{{ scope.row.DocumentNo }}</a>
                </template>
              </el-table-column>
              <el-table-column
                v-for="item in studentReceiptGenerationByTransactionHistoryList"
                min-width="25px"
                :prop="item.prop"
                :label="item.label"
                :key="item.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column :label="lang('Docs Type')" min-width="35px">
                <template slot-scope="scope">
                  <div v-if="scope.row.IH_IsRebate === 'Y' && scope.row.IH_IsRebateUtilized === 'Y' && scope.row.rebateUtilizeBy">
                    <b>Refund</b>(UtilizeBy: {{ scope.row.rebateUtilizeBy }})
                  </div>
                  <div v-else>
                    <b>{{ scope.row.DocumentType }}</b>
                    <div v-if="scope.row.rebateUtilizeFrom">(rebateUtilizeFrom:{{ scope.row.rebateUtilizeFrom }})</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="lang('Payment') + ' ' + lang('Reminder')" min-width="58px">
                <template slot-scope="scope">
                  <div class="paymentList-button-group" v-if="scope.row.DocumentType == 'Invoice'">
                    <el-button-group v-if="PaymentListInt.length > 0">
                      <el-button
                        v-on:click="showPaymentReminder('1st', scope.row.DocumentNo, scope.row.InvRecDate)"
                        :disabled="btnDisabled"
                        type="primary"
                        size="small"
                      >
                        <i class="tiny material-icons" style="color: red"> add_alert </i> 1
                      </el-button>

                      <el-button
                        v-on:click="showPaymentReminder('2nd', scope.row.DocumentNo, scope.row.InvRecDate)"
                        :disabled="btnDisabled"
                        type="primary"
                        size="small"
                      >
                        <i class="tiny material-icons" style="color: red"> add_alert </i> 2
                      </el-button>

                      <el-button
                        v-on:click="showPaymentReminder('3rd', scope.row.DocumentNo, scope.row.InvRecDate)"
                        :disabled="btnDisabled"
                        type="primary"
                        size="small"
                      >
                        <i class="tiny material-icons" style="color: red"> add_alert </i> 3
                      </el-button>
                    </el-button-group>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :label="lang('Sent')" min-width="28px">
                <template slot-scope="scope">
                  <div v-if="scope.row.reminderStage === '1'">1st Reminder</div>
                  <div v-if="scope.row.reminderStage === '2'">2nd Reminder</div>
                  <div v-if="scope.row.reminderStage === '3'">3rd Reminder</div>
                </template>
              </el-table-column>

              <el-table-column :label="lang('Reprint')" min-width="25px">
                <template slot-scope="scope">
                  <el-button-group v-if="scope.row.DocumentType !== 'Credit Note' && scope.row.DocumentType !== 'Refund'">
                    <el-button v-on:click="showReprint(scope.row)" size="small" type="danger" icon="el-icon-printer">
                      <i class="tiny material-icons"> </i>{{ scope.row.DocumentType }}
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </data-tables>

            <br />
            <div v-if="isAllowRebateTagFlag">
              <div v-for="items in studentRebateTagListInt" :key="items.ID">
                <button
                  v-on:click="tagRebateController(items.ID_Item_Description + '' + items.IH_Invoice_No, items.PK_Invoice_ID)"
                  class="btn btn-primary waves-effect waves-light"
                >
                  Tag {{ items.ID_Item_Description }} - {{ items.IH_Invoice_No }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="newApplyPaymentPlanModal"
      size="lg"
      :title="lang('Apply Payment Plan')"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="newApplyPaymentPlanShowModal"
    >
      <div class="row ml-2 mr-2">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="row">
            <div class="col-lg-6">
              <label>* {{ lang('Payment Plan') }}</label>
            </div>
            <div class="col-lg-6" data-v-step="ppBmodal02">
              <el-button @click="viewPaymentPlan" type="info" rounded size="mini" class="custom-info-elbutton float-right" v-if="ddlPaymentPlan !== null">
                {{ lang('View Payment Plan') }} <i class="fa fa-eye" aria-hidden="true"></i
              ></el-button>
            </div>
          </div>
          <el-select class="float-left fullwidth" v-model="ddlPaymentPlan" data-v-step="ppBmodal01">
            <el-option
              v-for="item in paymentPlanList"
              :key="item.PK_Course_Fee_Scheme_ID"
              :label="item.PPM_Fee_Scheme_Name"
              :value="item.PK_Course_Fee_Scheme_ID"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>{{ lang('Start') }} {{ lang('Date') }}</label>
          <input type="text" class="form-control" v-model="inputPaymentPlanStartDate" readonly="readonly" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-show="isProRateFeesEligible">
          <label>
            <input type="checkbox" class="form-control" v-model="cbProRateFees" :disabled="disabledCbProRateFees" @change="cbProRateFeesClick()" />
            {{ lang('Pro-Rate Fees') }}
            <span>
              <span>
                <svg class="checkmark" viewBox="0 0 24 24">
                  <path class="checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                </svg>
              </span>
            </span>
          </label>
          <input type="text" class="form-control EligibleColor" v-model="inputEligible" v-show="isProRateFeesEligible" readonly="readonly" />
          <label><span v-show="isDdlProRateFeesRequired">* </span>Rule to Apply</label>
          <el-select
            v-model="ddlPaymentPlanRuleApplyProRateFees"
            ref="ddlPaymentPlanRuleApplyProRateFees"
            class="fullwidth"
            :disabled="disablePaymentPlanRuleProRateFees"
            @change="onchangePaymentPlanRuleProRateFees()"
          >
            <el-option v-for="item in paymentPlanRuleApplyProRateFeesList" :key="item.PK_PPR_ID" :label="item.PPR_Name" :value="item.PK_PPR_ID"> </el-option>
          </el-select>
          <input
            type="text"
            class="form-control"
            v-model="inputPaymentPlanRuleProRateAmount"
            v-show="isInputPaymentPlanRuleProRateAmount"
            readonly="readonly"
          />
          <label>Level Start Date</label>
          <input type="text" class="form-control" v-model="inputPaymentPlanLevelStartDate" readonly="readonly" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="isPostRateFeesEligible">
          <label>
            <input type="checkbox" class="form-control" v-model="cbPostRateFees" :disabled="disabledCbPostRateFees" @change="cbPostRateFeesClick()" />
            Post-Rate Fees
            <span>
              <span>
                <svg class="checkmark" viewBox="0 0 24 24">
                  <path class="checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                </svg>
              </span>
            </span>
          </label>
          <input type="text" class="form-control EligibleColor" v-model="inputEligible" v-show="isPostRateFeesEligible" readonly="readonly" />
          <label>Rule to Apply</label>
          <el-select v-model="ddlPaymentPlanRuleApplyPostRateFees" class="fullwidth" :disabled="disablePaymentPlanRulePostRateFees">
            <el-option v-for="item in paymentPlanRuleApplyPostRateFeesList" :key="item.PK_PPR_ID" :label="item.PPR_Name" :value="item.PK_PPR_ID"> </el-option>
          </el-select>
          <!--todo: to check what value for level end date-->
          <label>Level End Date</label>
          <input type="text" class="form-control" v-model="inputPaymentPlanLevelEndDate" readonly="readonly" />
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <b-btn @click="closePaymentPlanModal()" class="float-left btn-secondary">Cancel</b-btn>
        </div>
        <div class="col-lg-6">
          <button
            v-on:click="savePaymentPlanClick()"
            data-v-step="ppBmodal03"
            class="btn btn-primary waves-effect waves-light float-right"
            :disabled="AuditDisabled"
          >
            Add Payment Plan
          </button>
        </div>

        <v-tour name="ppModalTourName" :steps="ppModalTourSteps" :options="MasterPageTourOptions" :callbacks="ppModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToInvModalPPTour()" class="v-step__button">Previous step</button>
                    <button @click="tour.nextStep" class="v-step__button">Next step</button>
                  </div>
                </template>

                <template v-if="tour.currentStep === 2">
                  <div slot="actions">
                    <button @click="tour.previousStep" class="v-step__button">Previous</button>
                    <button @click="ppModalTourStop()" class="v-step__button">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <b-modal
      id="newApplyDiscountPlanModal"
      size="lg"
      :title="lang('Add Discount Plan')"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="newApplyDiscountPlanShowModal"
    >
      <div class="row ml-2 mr-2">
        <div></div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div v-if="isSiblingDiscountEligible">
            <label>
              <input
                type="checkbox"
                class="form-control"
                v-model="cbSiblingDiscount"
                :disabled="disabledCbSiblingDiscount"
                @change="cbSiblingDiscountClick()"
              />
              {{ lang('Sibling Discount') }}
              <span>
                <span>
                  <svg class="checkmark" viewBox="0 0 24 24">
                    <path class="checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59" data-v-step="sdmodal02"></path>
                  </svg>
                </span>
              </span>
            </label>

            <input type="text" class="form-control EligibleColor" v-model="inputEligible" readonly="readonly" data-v-step="sdmodal01" />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label><span v-show="isDdlSiblingDiscRequired">* </span>Rule to Apply</label>
          <el-select
            v-model="ddlPaymentPlanRuleApplySiblings"
            class="fullwidth"
            data-v-step="sdmodal03"
            :disabled="disablePaymentPlanRuleApplySiblings"
            @change="onchangePaymentPlanRuleSiblings()"
          >
            <el-option v-for="item in paymentPlanRuleApplySiblingsList" :key="item.PK_PPR_ID" :label="item.PPR_Name" :value="item.PK_PPR_ID"> </el-option>
          </el-select>
          <input
            type="text"
            class="form-control"
            v-model="inputPaymentPlanRuleSiblingsAmount"
            v-show="isInputPaymentPlanRuleSiblingsAmount"
            readonly="readonly"
          />
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div><label>List of Siblings</label></div>
          <div>
            <div v-if="siblingListTableInt.length > 0" class="datatable_group">
              <data-tables :data="siblingListTableInt">
                <el-table-column v-for="siblingItem in siblingListTableList" :prop="siblingItem.prop" :label="siblingItem.label" :key="siblingItem.prop">
                </el-table-column>
              </data-tables>
            </div>
            <div v-else class="siblingNoRecordArea">
              <label>No Sibling...</label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div v-if="isStaffDiscountEligible">
            <label>
              <input type="checkbox" class="form-control" v-model="cbStaffDiscount" :disabled="disabledCbStaffDiscount" @change="cbStaffDiscountClick()" />
              Staff Discount
              <span>
                <span>
                  <svg class="checkmark" viewBox="0 0 24 24">
                    <path class="checkmark-path" fill="none" stroke="white" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                  </svg>
                </span>
              </span>
            </label>
            <input type="text" class="form-control EligibleColor" v-model="inputEligible" readonly="readonly" />
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb3">
              <label><span v-show="isDdlStaffDiscRequired">* </span>Rule to Apply</label>
              <el-select
                v-model="ddlPaymentPlanRuleApplyStaff"
                class="fullwidth"
                :disabled="disablePaymentPlanRuleApplyStaff"
                @change="onchangePaymentPlanRuleStaff()"
              >
                <el-option v-for="item in ddlPaymentPlanRuleApplyStaffList" :key="item.staffContactID" :label="item.staffName" :value="item.staffContactID">
                </el-option>
              </el-select>
              <input
                type="text"
                class="form-control"
                v-model="inputPaymentPlanRuleStaffAmount"
                v-show="isInputPaymentPlanRuleStaffAmount"
                readonly="readonly"
              />
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb3">
              <label>Staff Name</label>
              <input type="text" class="form-control" v-model="inputStaffName" readonly="readonly" />
            </div>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="addDiscountPlanClick()" data-v-step="sdmodal04" class="btn btn-primary waves-effect waves-light" :disabled="AuditDisabled">
            Add Discount Plan
          </button>
        </div>
        <v-tour name="sdModalTourName" :steps="sdModalTourSteps" :options="MasterPageTourOptions" :callbacks="sdModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToInvModalSDTour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 3">
                  <div slot="actions">
                    <button class="v-step__button" @click="tour.previousStep">Previous</button>
                    <button class="v-step__button" @click="sdModalTourStop()">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <b-modal id="viewPaymentPlanModal" size="lg" :title="lang('View Payment Plan')" ok-only ok-variant="secondary" hide-footer ref="viewPaymentPlanShowModal">
      <h5 class="text-left payment-title mt-2">{{ lang('Payment Plan Details') }}</h5>
      <small class="small-grey-text">{{ lang('Creation Date') }}: {{ inputViewPaymentPlanCreationDate }}</small>
      <small class="small-grey-text">{{ lang('Creation By') }}: {{ inputViewPaymentPlanCreationBy }}</small>
      <div class="payment-modal-info">
        <div class="payment-modal-object">
          <h4>{{ lang('Level') }}</h4>
          <span>{{ inputViewPaymentPlanLevel }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Fee Scheme Name') }}</h4>
          <span>{{ inputViewPaymentPlanFeeSchemeName }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Validity Starts On') }}</h4>
          <span>{{ inputViewPaymentPlanValidityStart }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Validity Ends On') }}</h4>
          <span>{{ inputViewPaymentPlanValidityEnd }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Tax Applicable') }}</h4>
          <span>{{ inputViewPaymentPlanTaxApplicable }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Tax') }}</h4>
          <span>{{ inputViewPaymentPlanTax }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Center') }}</h4>
          <span>{{ inputViewPaymentPlanCenter }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Currency') }}</h4>
          <span>{{ inputViewPaymentPlanCurrency }}</span>
        </div>
        <div class="payment-modal-object">
          <h4>{{ lang('Status') }}</h4>
          <span>{{ inputViewPaymentPlanStatus }}</span>
        </div>
      </div>
      <div v-if="itemPaymentPlanDetailsInt.length > 0">
        <data-tables :data="itemPaymentPlanDetailsInt">
          <el-table-column
            v-for="itemPaymentPlanDetailsListItem in itemPaymentPlanDetailsList"
            :prop="itemPaymentPlanDetailsListItem.prop"
            :label="itemPaymentPlanDetailsListItem.label"
            :key="itemPaymentPlanDetailsListItem.prop"
            sortable="custom"
          >
          </el-table-column>
        </data-tables>
      </div>
    </b-modal>
    <b-modal id="newAddItemModal" size="lg" :title="lang('Add Item')" ok-only ok-variant="secondary" hide-footer ref="newAddItemShowModal">
      <div class="row ml-2 mr-2">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
          <label>* Item</label>
          <el-select v-model="ddlAddItem" class="fullwidth" @change="onchangeAddItem()" data-v-step="aimodal01">
            <el-option v-for="item in addItemList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
          <div><label></label></div>
          <input type="text" v-show="isInputAddItemDirect" class="form-control" v-model="inputAddItemDirect" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddItemPaymentDate"
              format="dd/MM/yyyy"
              data-v-step="aimodal02"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Amount</label>
          <input
            v-if="isJPNSchool"
            type="text"
            class="form-control"
            v-model="inputAddItemAmount"
            @keypress="onlyNumberJPN($event, inputAddItemAmount)"
            data-v-step="aimodal03"
          />
          <input v-else type="text" class="form-control" v-model="inputAddItemAmount" @keypress="onlyNumber($event, inputAddItemAmount)" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Currency</label>
          <input type="text" class="form-control" v-model="ddlAddItemCurrency" disabled />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Schedule</label>
          <el-select v-model="ddlAddItemPaymentSchedule" class="fullwidth" @change="onchangeAddItemPaymentSchedule()" data-v-step="aimodal04">
            <el-option v-for="item in addItemPaymentScheduleList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Item Type</label>
          <el-select v-model="ddlAddItemPaymentItemType" class="fullwidth" data-v-step="aimodal05">
            <el-option v-for="item in addItemPaymentItemTypeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label><span v-show="isRecurringRequired">* </span>Recurring</label>
          <el-select v-model="ddlAddItemRecurring" class="fullwidth" :disabled="disabledRecurring">
            <el-option v-for="item in addItemRecurringList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Description</label>
          <input type="text" class="form-control" v-model="inputAddItemDescription" :disabled="disableOneTime" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>From Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddItemFromDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
              :disabled="disableOneTime"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>To Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddItemToDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
              :disabled="disableOneTime"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="closeAddItemModalClick()" class="btn btn-secondary close-modal-btn float-left">Close</button>
        </div>
        <div class="col-lg-6" data-v-step="aimodal06">
          <button v-on:click="saveItemClick()" class="btn btn-primary waves-effect waves-light float-right" :disabled="AuditDisabled">Add</button>
        </div>

        <v-tour name="aiModalTourName" :steps="aiModalTourSteps" :options="MasterPageTourOptions" :callbacks="aiModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToInvModalAITour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 5">
                  <div slot="actions">
                    <button class="v-step__button" @click="tour.previousStep">Previous</button>
                    <button class="v-step__button" @click="aiModalTourStop()">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <b-modal id="creditNoteModal" size="lg" :title="lang('Credit Note')" ok-only ok-variant="secondary" hide-footer ref="creditNoteModal">
      <div class="row ml-2 mr-2">
        <div>
          <h5>{{ lang('History Detail') }}</h5>
        </div>
        <div class="col-lg-12">
          <div v-if="studentReceiptGenerationByTransactionHistoryListInt.length > 0" class="datatable_group">
            <data-tables :data="studentReceiptGenerationByTransactionHistoryListInt">
              <el-table-column v-for="item in studentReceiptGenerationByTransactionHistoryList" :prop="item.prop" :label="item.label" :key="item.prop">
              </el-table-column>
              <el-table-column :label="lang('Docs Type')" min-width="65">
                <template slot-scope="scope">
                  <div v-if="scope.row.IH_IsRebate === 'Y' && scope.row.IH_IsRebateUtilized === 'Y' && scope.row.rebateUtilizeFrom">
                    <b>{{ scope.row.DocumentType }}</b
                    >(UtilizeFrom:{{ scope.row.rebateUtilizeFrom }})
                  </div>
                  <div v-else>{{ scope.row.DocumentType }}</div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
          <br />
          <div v-if="studentReceiptLeftOverPaymentListInt.length > 0" class="datatable_group">
            <data-tables
              :data="studentReceiptLeftOverPaymentListInt"
              @selection-change="changeSelection"
              data-v-step="cr01"
              v-bind:class="{ divBorderClass: studentCreditNoteListAreaBorder }"
            >
              ref="ReceiptGenerationByTransactionHistoryTable">
              <el-table-column width="45">
                <el-checkbox :value="true"></el-checkbox>
              </el-table-column>

              <el-table-column v-for="item in studentReceiptLeftOverPaymentList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
            </data-tables>
          </div>
          <br />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
          <label>{{ lang('Remarks for parents') }}*</label>
          <b-form-textarea
            id="cnRemarks"
            rows="3"
            class="textArea"
            v-model="taCnRemarks"
            placeholder="Please enter comment"
            :state="taCnRemarks.length >= 1"
            data-v-step="cr02"
          ></b-form-textarea>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
          <label
            ><b style="color: red">{{ lang('Remarks') }}(Internal)</b></label
          >
          <b-form-textarea rows="3" class="textArea" v-model="inputInternalCNRemarks" placeholder="Please enter internal comments(Optional)"></b-form-textarea>
        </div>
        <div class="col-lg-12">
          <label v-if="isEligibleForFullRefundCN" style="color: red; border: 1px solid red" class="float-right">Fully CN please click here!</label>
        </div>
        <div class="col-lg-12">
          <button
            v-if="isEligibleForFullRefundCN"
            v-on:click="generateCNClick('Y')"
            class="btn btn-warning waves-effect waves-light float-right"
            :disabled="AuditDisabled"
          >
            {{ lang('Generate Full') }} {{ lang('CN') }}
          </button>
          <button v-on:click="generateCNClick('N')" data-v-step="cr03" class="btn btn-primary waves-effect waves-light float-right" :disabled="AuditDisabled">
            {{ lang('Generate') }} {{ lang('CN') }}
          </button>
        </div>

        <v-tour name="cnModalTourName" :steps="CnModalTourSteps" :options="MasterPageTourOptions" :callbacks="CnModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterCNPageTour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 2">
                  <div slot="actions">
                    <div slot="actions">
                      <button @click="tour.previousStep" class="v-step__button">Previous</button>
                      <button @click="cnModalTourStop()" class="v-step__button">Finish</button>
                    </div>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <b-modal
      id="generateReceiptModal"
      size="xl"
      :title="lang('Generate') + ' ' + lang('Receipt')"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="generateReceiptModal"
    >
      <h5 class="text-left payment-title">{{ lang('RECEIPTS') }}</h5>
      <div class="row mt-3">
        <div class="col-lg-6">
          <label>{{ lang('Payment') }} {{ lang('Mode') }}</label>
          <select v-model="ddlPaymentMode" v-on:click="validatePaymentMode()" data-v-step="grmodal01" class="form-control pro-edt-select form-control-primary">
            <option v-for="item in paymentModeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
          </select>
        </div>
        <div class="col-lg-6" v-if="this.ddlPaymentMode != 'CASH'">
          <label>{{ lang('Cheque/DD No') }}&{{ lang('Bank Name') }}</label>
          <input type="text" class="form-control" v-model="inputChequeNoBankName" data-v-step="grmodal02" />
        </div>
        <div class="col-lg-6">
          <label>{{ lang('Receipt') }} {{ lang('Date') }}</label>
          <div class="date">
            <el-date-picker
              v-model="inputReceiptDate"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              placeholder="Pick a day"
              :picker-options="datePicker"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6">
          <label>{{ lang('Remarks') }}(Remarks for parents)</label>
          <input type="text" class="form-control" v-model="inputRemarks" data-v-step="grmodal03" />
        </div>
        <div class="col-lg-6">
          <label style="color: red"
            ><b>{{ lang('Remarks') }}(Internal)</b></label
          >
          <input type="text" class="form-control" v-model="inputInternalReceiptRemarks" />
        </div>
        <div class="col-lg-6">
          <el-checkbox
            v-model="requiredInvoice"
            :label="lang('Does this receipt required Invoice') + '??'"
            class="float-left"
            data-v-step="grmodal04"
          ></el-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 actionDiv mb-3">
          <el-button-group>
            <el-button type="primary" variant="primary" v-on:click="addItemClick()">
              {{ lang('Add Item') }}
            </el-button>
          </el-button-group>
        </div>
        <div
          v-if="studentReceiptGenerationListInt.length > 0"
          class="datatable_group col-lg-12"
          v-bind:class="{ divBorderClass: studentReceiptListAreaBorder }"
        >
          <data-tables
            :data="studentReceiptGenerationListInt"
            layout="table"
            @selection-change="changeSelection"
            data-v-step="grmodal05"
            :action-col="studentReceiptItemListAction"
            ref="receiptGenerationTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column v-for="item in studentReceiptGenerationList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
            <el-table-column :label="lang('Pay Amount')" min-width="100px">
              <template slot-scope="scope">
                <el-input-number controls-position="right" v-model="scope.row.newPayAmount" :placeholder="lang('Amount')"></el-input-number>
              </template>
            </el-table-column>
          </data-tables>
          <hr />
        </div>
        <hr />
      </div>
      <div class="row actionDiv">
        <div class="col-lg-6">
          <b-btn @click="closeModal" class="float-left btn-secondary">{{ lang('Cancel') }}</b-btn>
        </div>
        <div class="col-lg-6">
          <el-button-group>
            <el-button type="primary" v-on:click="previewReceiptClick()">
              <span data-v-step="grmodal06">{{ lang('Preview') }}</span>
            </el-button>
            <el-button type="primary" v-on:click="generateReceiptClick('AdhocReceipt')" :disabled="AuditDisabled">
              <span data-v-step="grmodal07">{{ lang('Generate') }}</span>
            </el-button>
          </el-button-group>
        </div>

        <v-tour name="grModalTourName" :steps="grModalTourSteps" :options="MasterPageTourOptions" :callbacks="grModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous</button>
                    <button v-if="ddlPaymentMode !== 'CASH'" @click="tour.nextStep" class="v-step__button">Next</button>
                    <button v-else @click="RecModalGRTourNextSteps()" class="v-step__button">Next</button>
                  </div>
                </template>

                <template v-if="tour.currentStep === 6">
                  <div slot="actions">
                    <button @click="tour.previousStep" class="v-step__button">Previous</button>
                    <button @click="grModalTourStop()" class="v-step__button">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <v-tour name="grModalTourCuztomizeName" :steps="grModalTourCuztomizeSteps" :options="MasterPageTourOptions" :callbacks="grModalTourCuztomizeCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>

                <template v-if="tour.currentStep === 5">
                  <div slot="actions">
                    <button @click="tour.previousStep" class="v-step__button">Previous</button>
                    <button @click="grModalTourStop()" class="v-step__button">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <b-modal
      id="generateInvoiceModal"
      size="xl"
      :title="lang('Generate') + ' ' + lang('Invoice')"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="generateInvoiceModal"
    >
      <div class="row">
        <div class="col-lg-6">
          <h5 class="text-left payment-title">{{ lang('INVOICING') }}</h5>
        </div>

        <v-tour name="InvModalPPTourName" :steps="InvModalPPTourSteps" :options="MasterPageTourOptions" :callbacks="InvModalPPTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous step</button>
                    <button @click="tour.nextStep" class="v-step__button">Next step</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <v-tour name="InvModalSDTourName" :steps="InvModalSDTourSteps" :options="MasterPageTourOptions" :callbacks="InvModalSDTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous step</button>
                    <button @click="tour.nextStep" class="v-step__button">Next step</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <v-tour name="InvModalAITourName" :steps="InvModalAITourSteps" :options="MasterPageTourOptions" :callbacks="InvModalAITourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous step</button>
                    <button @click="tour.nextStep" class="v-step__button">Next step</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <v-tour name="InvModalGITourName" :steps="InvModalGITourSteps" :options="MasterPageTourOptions" :callbacks="InvModalGITourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 2">
                  <div slot="actions">
                    <div slot="actions">
                      <button @click="tour.previousStep" class="v-step__button">Previous</button>
                      <button @click="tour.nextStep" class="v-step__button">Next</button>
                    </div>
                  </div>
                </template>
                <template v-if="tour.currentStep === 3">
                  <div slot="actions">
                    <div slot="actions">
                      <button @click="tour.previousStep" class="v-step__button">Previous</button>
                      <button @click="giModalTourStop()" class="v-step__button">Finish</button>
                    </div>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>

        <div data-v-step="InvApp03"></div>
        <div data-v-step="InvSd04"></div>
        <div data-v-step="InvAi02"></div>
        <div data-v-step="InvGi05"></div>

        <div class="col-lg-6">
          <el-checkbox
            v-model="cbPrintMonthlyBreakdown"
            :label="lang('Print monthly breakdown')"
            border
            data-v-step="InvGi01"
            class="float-right"
          ></el-checkbox>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-6">
          <div class="date">
            <label>* {{ lang('Payment Due Date') }}</label>
            <el-date-picker
              data-v-step="InvApp01"
              v-model="inputPaymentDueDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6">
          <label>{{ lang('Remarks') }}</label>
          <input data-v-step="InvSd02" type="text" class="form-control" v-model="inputRemarks" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 actionDiv mb-3" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between">
          <div style="display: flex; gap: 20px; margin-right: auto" v-if="!isJPNSchool && !isBhutanSchool">
            <label style="display: flex !important; align-items: center; gap: 5px; font-weight: normal">
              <input v-model="gstRate" value="7" name="gst_rate" type="radio" /><span>7% GST</span>
            </label>
            <label style="display: flex !important; align-items: center; gap: 5px; font-weight: normal">
              <input v-model="gstRate" value="8" name="gst_rate" type="radio" /><span>8% GST</span>
            </label>
            <label style="display: flex !important; align-items: center; gap: 5px; font-weight: normal">
              <input v-model="gstRate" value="9" name="gst_rate" type="radio" /><span>9% GST</span>
            </label>
          </div>
          <el-button-group>
            <el-button type="primary" variant="primary" v-on:click="showSubsidyDiscountClick()" v-if="isSubsidyDiscountEligible">
              {{ lang('Apply Subsidy Discount') }}
            </el-button>
            <el-button
              type="primary"
              variant="primary"
              v-on:click="showDiscountPlanClick()"
              data-v-step="InvSd03"
              v-if="isSiblingDiscountEligible || isStaffDiscountEligible"
            >
              {{ lang('Apply Discount plan') }}
            </el-button>
            <el-button type="primary" variant="primary" v-on:click="applyPaymentPlanClick()" data-v-step="InvApp02">
              {{ lang('Apply Payment Plan') }}
            </el-button>
            <el-button type="primary" variant="primary" v-on:click="autoApplyPlanClick()" v-if="showCalculateFPS">
              {{ lang('Auto Payment Plan') }}
            </el-button>
            <el-button type="primary" variant="primary" v-on:click="addItemClick()" data-v-step="InvAi01">
              {{ lang('Add Item') }}
            </el-button>
            <el-button type="primary" variant="primary" v-on:click="calculateFPSClick()" v-if="showCalculateFPS">
              {{ lang('Calculate FPS') }}
            </el-button>
          </el-button-group>
        </div>
        <div v-if="InvoiceOverPaymentItemInt.length > 0" class="datatable_group col-lg-12">
          <label>{{ lang('Over Payment') }}</label>
          <data-tables :data="InvoiceOverPaymentItemInt" layout="table">
            <el-table-column v-for="item in InvoiceOverPaymentItemList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
          </data-tables>
        </div>
        <div
          v-if="studentInvoiceGenerationListInt.length > 0"
          class="datatable_group col-lg-12"
          data-v-step="InvGi02"
          v-bind:class="{ divBorderClass: studentInvoiceListAreaBorder }"
        >
          <data-tables
            :data="studentInvoiceGenerationListInt"
            layout="table"
            @selection-change="changeSelection"
            :action-col="studentInvoiceItemListAction"
            ref="invoiceGenerationTable"
          >
            <el-table-column type="selection" width="55" :selectable="canSelectRow"> </el-table-column>
            <el-table-column v-for="item in studentInvoiceGenerationList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>

            <el-table-column v-if="isJPNSchool" :label="lang('Amount')" min-width="80px">
              <template slot-scope="scope">
                <label type="number" :placeholder="'Amount'">{{ scope.row.newAmount }}</label>
              </template>
            </el-table-column>
            <el-table-column v-else :label="lang('Amount')" min-width="80px">
              <template slot-scope="scope">
                <el-input-number
                  controls-position="right"
                  v-model="scope.row.newAmount"
                  class="disabledKeyboardInput"
                  v-on:change="updateAmountClick(scope.row.newAmount, scope.row.newGSTAmount, scope.row)"
                  :min="adjustmentMin(scope.row.SPPD_PaymentAmount)"
                  :max="adjustmentMax(scope.row.SPPD_PaymentAmount)"
                  :step="0.01"
                  :placeholder="'Amount'"
                ></el-input-number>
              </template>
            </el-table-column>

            <el-table-column v-if="isJPNSchool" :label="lang('GST Value')" min-width="80px">
              <template slot-scope="scope">
                <label :placeholder="'GST'">{{ scope.row.newGSTAmount }}</label>
              </template>
            </el-table-column>
            <el-table-column v-else-if="!isBhutanSchool" :label="lang('GST Value')" min-width="80px">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.newGSTAmount"
                  class="disabledKeyboardInput"
                  controls-position="right"
                  v-on:change="updateTotalClick(scope.row.newGSTAmount, scope.row.newAmount, scope.row)"
                  :min="adjustmentMin(scope.row.SPPD_GstValue)"
                  :max="adjustmentMax(scope.row.SPPD_GstValue)"
                  :step="0.01"
                  :placeholder="'GST'"
                ></el-input-number>
              </template>
            </el-table-column>

            <el-table-column :label="'Total Amount'" min-width="80px">
              <template slot-scope="scope">
                {{ scope.row.SPPD_TotalValue }}
              </template>
            </el-table-column>
          </data-tables>
          <br />
        </div>
        <div v-if="studentRefundRebateListInt.length > 0" class="datatable_group col-lg-12" v-bind:class="{ divBorderClass: studentInvoiceListAreaBorder }">
          <label style="color: red"><b>Rebate item *</b></label>
          <data-tables :data="studentRefundRebateListInt" layout="table" @selection-change="rebateSelection" ref="invoiceGenerationTable">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column v-for="item in studentRefundRebateList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
          </data-tables>
          <hr />
          <br />
        </div>
      </div>
      <div class="row actionDiv">
        <div class="col-lg-6">
          <b-btn @click="closeModal" class="float-left btn-secondary">{{ lang('Cancel') }}</b-btn>
        </div>
        <div class="col-lg-6">
          <el-button-group>
            <el-button type="primary" v-on:click="invoiceClickController('previewInv', '')" data-v-step="InvGi03">
              <span>{{ lang('Preview') }}</span>
            </el-button>
            <el-button type="primary" v-on:click="invoiceClickController('generateInv', '')" data-v-step="InvGi04" :disabled="AuditDisabled">
              <span>{{ lang('Generate') }}</span>
            </el-button>
          </el-button-group>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="showGenerateReceiptByHistoryModal"
      size="xl"
      :title="lang('Generate Receipt Detail(With Transaction History)')"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="showGenerateReceiptByHistoryModal"
    >
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div>
          <h5>{{ lang('Transaction History Detail') }}</h5>
        </div>
        <div v-if="studentReceiptGenerationByTransactionHistoryListInt.length > 0" class="datatable_group">
          <data-tables :data="studentReceiptGenerationByTransactionHistoryListInt" layout="table" ref="ReceiptGenerationByTransactionHistoryTable">
            <el-table-column v-for="item in studentReceiptGenerationByTransactionHistoryList" :prop="item.prop" :label="item.label" :key="item.prop">
            </el-table-column>
            <el-table-column :label="lang('Docs Type')" min-width="65">
              <template slot-scope="scope">
                <div v-if="scope.row.IH_IsRebate === 'Y' && scope.row.IH_IsRebateUtilized === 'Y' && scope.row.rebateUtilizeFrom">
                  <b>{{ scope.row.DocumentType }}</b
                  >(UtilizeFrom: {{ scope.row.rebateUtilizeFrom }})
                </div>
                <div v-else>{{ scope.row.DocumentType }}</div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
        <br />
        <hr />

        <div>
          <h5>{{ lang('Left Over Payment') }}</h5>
        </div>
        <K2Row align="center" v-if="showReceiptGstOptions">
          GST
          <K2Radio v-model="receiptGSTRate" :passValue="receiptGSTRate" :list="['7%', '8%', '9%']" />
        </K2Row>
        <div v-if="studentReceiptLeftOverPaymentListInt.length > 0" class="datatable_group">
          <data-tables
            :data="studentReceiptLeftOverPaymentListInt"
            layout="table"
            @selection-change="countReceiptTotalValue"
            :row-key="getRowKeys"
            ref="ReceiptLeftOverPaymentTable"
          >
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column v-for="item in studentReceiptLeftOverPaymentList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
            <el-table-column :label="lang('Pay Amount')" min-width="100px">
              <template #default="scope">
                <div>
                  <el-input-number
                    v-model="scope.row.newPayAmount"
                    controls-position="right"
                    v-on:change="changeReceiptPayAmount(scope.row)"
                    :placeholder="lang('Amount')"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
          </data-tables>
          <hr />

          <div class="row">
            <div style="width: 65%"></div>
            <div style="width: 15%">
              <label>{{ lang('Total Amount') }}: </label>
            </div>
            <div style="width: 20%">
              <el-input-number
                controls-position="right"
                v-model.number.lazy="selectedleftOverReceiptTotal"
                v-on:change="reverseReceiptTotalCount(selectedleftOverReceiptTotal)"
                placeholder="Total Sum"
              ></el-input-number>
            </div>
          </div>
        </div>
        <br />

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h5 class="text-left">{{ lang('RECEIPTS') }}</h5>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>{{ lang('Payment') }} {{ lang('Mode') }} *</label>
          <select v-model="ddlPaymentMode" v-on:click="validatePaymentMode()" class="form-control pro-edt-select form-control-primary">
            <option v-for="item in paymentModeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
          </select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="ddlPaymentMode != 'CASH'">
          <label>{{ lang('Cheque/DD No') }}& {{ lang('Bank Name') }}</label>
          <input type="text" class="form-control" v-model="inputChequeNoBankName" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>{{ lang('Receipt') }} {{ lang('Date') }} *</label>
          <div class="date">
            <el-date-picker
              v-model="inputReceiptDate"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              placeholder="Pick a day"
              :picker-options="datePicker"
            ></el-date-picker>
          </div>
        </div>
        <br />
        <div class="col-lg-6">
          <label>{{ lang('Remarks') }}(Remarks for parents)</label>
          <input type="text" class="form-control" v-model="inputRemarks" />
        </div>
        <div class="col-lg-6">
          <label
            ><b style="color: red">{{ lang('Remarks') }}(Internal)</b></label
          >
          <input type="text" class="form-control" v-model="inputInternalReceiptRemarks" />
        </div>
        <div class="col-lg-12 actionDiv">
          <el-button-group>
            <el-button type="primary" variant="primary" v-on:click="previewLeftOverReceiptClick()">
              <b
                ><h5>{{ lang('Preview') }}</h5></b
              >
            </el-button>
          </el-button-group>
          <el-button-group>
            <el-button type="primary" variant="primary" v-on:click="generateLeftOverReceiptClick()" :disabled="AuditDisabled">
              <b
                ><h5>{{ lang('Generate') }}</h5></b
              >
            </el-button>
          </el-button-group>
        </div>
      </div>
    </b-modal>
    <b-modal id="showReInvoiceModal" size="lg" :title="lang('Re-Invoice')" ok-only ok-variant="secondary" ok-title="Cancel" ref="showReInvoiceModal">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="col-lg-12 actionDiv">
            <K2Row align="center" v-if="showRefundGstOptions">
              GST
              <K2Radio v-model="reInvoiceGSTRate" :passValue="reInvoiceGSTRate" :list="['7%', '8%', '9%']" @input="handleReInvoiceGSTChange" />
            </K2Row>
            <el-button-group>
              <el-button type="primary" variant="primary" v-on:click="addItemClick()">
                {{ lang('Add Item') }}
              </el-button>
            </el-button-group>
          </div>
          <div v-if="ReInvoiceListInt.length > 0">
            <data-tables :data="ReInvoiceListInt" @selection-change="changeSelection" layout="table">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column v-for="item in ReInvoiceList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
              <el-table-column :label="lang('Pay Amount') + '' + lang('Included GST')" min-width="100px">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.newPayAmount"
                    @change="() => handleReInvoiceAmountChange(scope.row)"
                    controls-position="right"
                    placeholder="Amount"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="isReinvoiceItem" min-width="80px">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.isReinvoiceItem" type="text" disabled></el-input>
                </template>
              </el-table-column>
            </data-tables>
            <br /><br />
            <div v-if="isRebateReInvoiceListInt.length > 0" class="datatable_group col-lg-12" v-bind:class="{ divBorderClass: studentInvoiceListAreaBorder }">
              <label style="color: red"><b>Rebate item *</b></label>
              <data-tables :data="isRebateReInvoiceListInt" layout="table" @selection-change="rebateSelection" ref="invoiceGenerationTable">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column v-for="item in isRebateReInvoiceList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
              </data-tables>
              <hr />
              <br />
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h5 class="text-left">{{ lang('INVOICING') }}</h5>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <label>* {{ lang('Payment Due Date') }}</label>
              <div class="date">
                <el-date-picker
                  v-model="inputPaymentDueDate"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  type="date"
                  placeholder="Pick a day"
                ></el-date-picker>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <label>{{ lang('Remarks') }}</label>
              <input type="text" class="form-control" v-model="inputRemarks" />
            </div>
            <div class="col-lg-12 actionDiv">
              <el-button-group>
                <el-button type="primary" variant="primary" v-on:click="invoiceClickController('previewInv', 'reinvoice')">
                  <b
                    ><h5>{{ lang('Preview') }}</h5></b
                  >
                </el-button>
              </el-button-group>
              <el-button-group>
                <el-button type="primary" variant="primary" v-on:click="invoiceClickController('generateInv', 'reinvoice')" :disabled="AuditDisabled">
                  <b
                    ><h5>{{ lang('Generate') }}</h5></b
                  >
                </el-button>
              </el-button-group>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="showOverPaymentConfirmationModal" size="sm" hide-footer :title="lang('OVERPAYMENT')" ref="showOverPaymentConfirmationModal">
      <div class="d-block text-center">
        <h3>{{ lang('There are') }} {{ overPaymentItemsCount }} {{ lang('overpayment items in your selection') }}! {{ lang('Proceed') }}?</h3>
      </div>
      <b-button class="mt-2" variant="success" block v-on:click="overPaymentClick('Yes')">{{ lang('Yes') }} </b-button>
      <b-button class="mt-2" variant="danger" block v-on:click="overPaymentClick('No')">{{ lang('No ') }}</b-button>
    </b-modal>
    <b-modal id="showPaymentReminderModal" size="lg" title="" ok-only ok-variant="secondary" ok-title="Cancel" ref="showPaymentReminderModal">
      <label>{{ lblPaymentReminder }} {{ lang('Payment') }} {{ lang('Reminder') }}</label>

      <div class="row ml-1 mr-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <el-button type="danger" class="float-right" v-on:click="PrintReminder()"><i class="material-icons"> print </i>Print Reminder </el-button>
          <br />
        </div>
      </div>

      <div class="row ml-1 mr-1">
        <div v-if="lblPaymentReminder == '1st'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>* {{ lang('Please select if you want to change reminder due date') }}</label>
          <el-date-picker
            v-model="inputInvoiceReminderDueDate"
            type="date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
            :change="onClickReplaceInvoiceReminderDueDate()"
            placeholder="Pick a day"
          >
          </el-date-picker>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>{{ lang('Email To') }}:</label>
          <input disabled type="text" class="form-control" v-model="inputEmailTo" />
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>{{ lang('Title') }}</label>
          <input disabled type="text" class="form-control" v-model="inputEmailSubject" />
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>{{ lang('Description') }}</label>
          <span
            id="reminderTextArea"
            style="white-space: pre-line; background: #ebebeb80; display: block; padding: 20px; border-radius: 6px"
            class="print-container"
            v-html="inputEmailMessage"
          ></span>
        </div>
      </div>

      <div v-if="showReminderSendButton && schUniversity === 'UTY201300000061'">
        <button v-on:click="sendEmailReminderClick()" class="btn btn-primary waves-effect waves-light float-right" :disabled="AuditDisabled">
          {{ lang('Send') }}
        </button>
      </div>
    </b-modal>

    <b-modal id="viewRefundModal" size="xl" :title="lang('Refund')" ok-only ok-variant="secondary" ok-title="Cancel" ref="viewRefundModal">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="refundListInt.length > 0" class="datatable_group col-lg-12">
            <K2Row align="center" v-if="showRefundGstOptions">
              GST
              <K2Radio v-model="refundGstRate" :passValue="refundGstRate" :list="['7%', '8%', '9%']" @input="handleRefundGSTChange" />
            </K2Row>
            <data-tables
              :data="refundListInt"
              layout="table"
              ref="refundGenerationTable"
              data-v-step="rf01"
              v-bind:class="{ divBorderClass: studentRefundListAreaBorder }"
              @selection-change="changeSelection"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column v-for="item in refundList" min-width="50px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
              </el-table-column>
              <el-table-column :label="lang('Refund') + ' ' + lang('Amount')" min-width="40px">
                <template slot-scope="scope">
                  <el-input-number
                    controls-position="right"
                    v-model="scope.row.newRefundAmount"
                    placeholder="Amount"
                    :step="0.01"
                    @change="() => handleRefundAmountChange(scope.row)"
                    :precision="2"
                  ></el-input-number>
                </template>
              </el-table-column>
            </data-tables>
            <hr />

            <div class="row ml-2 mr-2">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                <label
                  ><b style="color: red">*{{ lang('Remarks for parents') }}(Mandatory)</b></label
                >
                <el-input data-v-step="rf02" type="text" v-model="inputRefundRemarks" :disabled="isSchoolFeeRebateDisabled"></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
                <label
                  ><b>{{ lang('Remarks') }} (internal)</b></label
                >
                <el-input data-v-step="rf02" type="text" v-model="inputInternalRefundRemarks"></el-input>
              </div>
              <div v-if="showRebateDropdown === true" class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
                <label
                  ><b>{{ lang('Is School Fees Rebate??') }}</b></label
                >
                <el-select
                  class="float-left fullwidth"
                  v-model="SchoolFeeRebateValue"
                  @change="onchangeRebateSelection()"
                  clearable
                  placeholder="Please select"
                >
                  <el-option v-for="item in schoolFeesRebateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3"></div>
              <hr class="custom-hr mt-4" />
              <div class="col-lg-6">
                <!--                                <el-button-group>-->
                <!--                                    <el-button class="btn btn-secondary close-modal-btn float-left" type="primary"-->
                <!--                                               v-on:click="generateRefundClick()" :disabled="AuditDisabled">-->
                <!--                                        <span data-v-step="rf03">{{lang("Refund")}}!</span>-->
                <!--                                    </el-button>-->
                <el-button
                  class="btn btn-secondary close-modal-btn float-left"
                  type="primary"
                  plain
                  v-on:click="refundClickController('preview')"
                  :disabled="AuditDisabled"
                >
                  <span data-v-step="rf03">{{ lang('Preview') }}</span>
                </el-button>
                <el-button
                  class="btn btn-secondary close-modal-btn float-left"
                  type="primary"
                  v-on:click="refundClickController('generate')"
                  :disabled="AuditDisabled"
                >
                  <span data-v-step="rf03">{{ lang('Refund') }}!</span>
                </el-button>
                <!--                                </el-button-group>-->
              </div>
            </div>
          </div>
        </div>

        <v-tour name="rfModalTourName" :steps="rfModalTourSteps" :options="MasterPageTourOptions" :callbacks="rfModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToMasterPageTour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>

                <template v-if="tour.currentStep === 2">
                  <div slot="actions">
                    <button @click="tour.previousStep" class="v-step__button">Previous</button>
                    <button @click="rfModalTourStop()" class="v-step__button">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>
    <!--        <b-modal id="showSiblingConfirmationModal" hide-footer :title="lang('Sibling')+''+lang('Found')"-->
    <!--                 ref="showSiblingConfirmationModal">-->
    <!--            <div class="d-block text-center">-->
    <!--                <h3>There are {{siblingItemsCount}} siblings items in your selection! Proceed?</h3>-->
    <!--            </div>-->
    <!--            <b-button class="mt-2" variant="success" block v-on:click="SiblingConfirmationClick('Yes')">Yes</b-button>-->
    <!--            <b-button class="mt-2" variant="danger" block v-on:click="SiblingConfirmationClick('No')">No</b-button>-->
    <!--        </b-modal>-->

    <b-modal
      id="showReprintModal"
      hide-footer
      :title="lang('Reprint') + ' ' + lang('Invoice') + '/' + lang('Receipt')"
      ok-only
      ok-variant="secondary"
      ref="showReprintModal"
    >
      <div>
        <div class="addAreaDiv">
          <div class="">
            <h5 class="text-left student-form__title">{{ lang('Overview') }}</h5>
          </div>
          <div class="row form-group__wrapper">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <label>{{ lang('Invoice To') }}:</label>
              <input type="text" class="form-control" v-model="reprintPayeeName" disabled />
            </div>
            <!--                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
            <!--                            <label>{{lang("Student Name")}}:</label>-->
            <!--                            <input type="text" class="form-control"-->
            <!--                                   v-model="reprintStudentName" disabled>-->
            <!--                        </div>-->
            <!--                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
            <!--                            <label>{{lang("Student")}}{{reprintIDType}} {{lang("NO")}}:</label>-->
            <!--                            <input type="text" class="form-control"-->
            <!--                                   v-model="reprintStudentIDNumber" disabled>-->
            <!--                        </div>-->
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <label>{{ lang('Address') }}:</label>
              <input type="text" class="form-control" v-model="reprintAddress" disabled />
            </div>
          </div>

          <br />
          <hr />
          <div>
            <div class="datatable_group">
              <b>{{ lang('Reprint') }}{{ lang('History') }}</b>
              <data-tables layout="table" :data="reprintHistoryListInt">
                <el-table-column label="Version" min-width="30px">
                  <!--                                    Ver:{{0}}-->
                  <!--                                    {{reprintIndex+1}}-->
                  <template slot-scope="scope">
                    <div v-if="scope.$index == 0">Original</div>
                    <div v-else>Ver:{{ scope.$index }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="lang('Document') + '' + lang('Number')" min-width="95px">
                  <template slot-scope="scope">
                    <a
                      href="#"
                      style="color: blue"
                      @click="getReprintDocument(scope.row.InvRecID, scope.row.att_Aut_RN, scope.row.DocumentType, scope.row.DocumentNo)"
                      >{{ scope.row.DocumentNo }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column v-for="Item in reprintHistoryList" :prop="Item.prop" :label="Item.label" :key="Item.prop"> </el-table-column>
              </data-tables>
            </div>
          </div>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :span="6" :offset="1">
          <el-button-group>
            <el-button v-on:click="rePrintClick()" type="primary" variant="primary" :disabled="AuditDisabled">
              {{ lang('Reprint') }}
            </el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </b-modal>

    <b-modal
      id="showSiblingConfirmationModal"
      :title="lang('Sibling') + '' + lang('Found')"
      ref="showSiblingConfirmationModal"
      @ok="SiblingConfirmationClick"
      :ok-title="lang('Yes')"
      :cancel-title="lang('No')"
    >
      <div class="d-block text-center">
        <h3>There are {{ siblingItemsCount }} siblings items in your selection! Proceed?</h3>
      </div>

      <div>
        <div v-if="siblingListTableInt.length > 0" class="datatable_group">
          <data-tables layout="table" :data="siblingListTableInt">
            <el-table-column v-for="siblingItem in siblingListTableList" :prop="siblingItem.prop" :label="siblingItem.label" :key="siblingItem.prop">
            </el-table-column>
          </data-tables>
        </div>
        <div v-else class="siblingNoRecordArea">
          <label style="text-align: center">{{ lang('No') }}{{ lang('Siblings') }}...</label>
        </div>
      </div>
    </b-modal>

    <b-modal id="showSubsidyDiscountModal" size="lg" :title="lang('Add Subsidy')" ok-only ok-variant="secondary" hide-footer ref="showSubsidyDiscountModal">
      <div class="row ml-2 mr-2">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb3">
          <label>* Item</label>
          <el-select v-model="ddlAddSubsidyItem" class="fullwidth">
            <el-option v-for="item in addSubsidyItemList" v-bind:value="item">{{ item }} </el-option>
          </el-select>
          <div><label></label></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddSubsidyItemPaymentDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Amount</label>
          <input
            v-if="isJPNSchool"
            type="text"
            class="form-control"
            v-model="inputAddSubsidyItemAmount"
            @keypress="onlyNumberJPN($event, inputAddSubsidyItemAmount)"
          />
          <input v-else type="text" class="form-control" v-model="inputAddSubsidyItemAmount" @keypress="onlyNumber($event, inputAddSubsidyItemAmount)" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Currency</label>
          <input type="text" class="form-control" v-model="ddlAddSubsidyItemCurrency" disabled />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Schedule</label>
          <el-select v-model="ddlAddSubsidyItemPaymentSchedule" class="fullwidth" @change="onchangeAddSubsidyItemPaymentSchedule()">
            <el-option v-for="item in addItemPaymentScheduleList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>* Payment Item Type</label>
          <el-select v-model="ddlAddSubsidyItemPaymentItemType" class="fullwidth">
            <el-option v-for="item in addItemPaymentItemTypeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label><span v-show="isSubsidyRecurringRequired">* </span>Recurring</label>
          <el-select v-model="ddlAddSubsidyItemRecurring" class="fullwidth" :disabled="disabledSubsidyRecurring">
            <el-option v-for="item in addItemRecurringList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }} </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Description</label>
          <input type="text" class="form-control" v-model="inputAddSubsidyItemDescription" :disabled="disableSubsidyOneTime" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>From Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddSubsidyItemFromDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
              :disabled="disableSubsidyOneTime"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>To Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputAddSubsidyItemToDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
              :disabled="disableSubsidyOneTime"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="closeSubsidyDiscountModalClick()" class="btn btn-secondary close-modal-btn float-left">Close</button>
        </div>
        <div class="col-lg-6" data-v-step="aimodal06">
          <button v-on:click="saveSubsidyItemClick()" class="btn btn-primary waves-effect waves-light float-right" :disabled="AuditDisabled">Add</button>
        </div>

        <v-tour name="aiModalTourName" :steps="aiModalTourSteps" :options="MasterPageTourOptions" :callbacks="aiModalTourCallbacks">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <button @click="backToInvModalAITour()" class="v-step__button">Previous</button>
                    <button @click="tour.nextStep" class="v-step__button">Next</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 5">
                  <div slot="actions">
                    <button class="v-step__button" @click="tour.previousStep">Previous</button>
                    <button class="v-step__button" @click="aiModalTourStop()">Finish</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </div>
    </b-modal>

    <v-tour name="MasterPageTourName" :steps="MasterPageTourSteps" :options="MasterPageTourOptions" :callbacks="MasterPageTourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="stopTour()" class="v-step__button">Skip Tour</button>
                <button @click="sppTourNextSteps()" class="v-step__button">Next step</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="MasterPageGRTourName" :steps="MasterPageGRTourSteps" :options="MasterPageTourOptions" :callbacks="MasterPageGRTourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="stopTour()" class="v-step__button">Skip Tour</button>
                <button @click="sppTourNextSteps()" class="v-step__button">Next step</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="MasterPageCNTourName" :steps="MasterPageCNTourSteps" :options="MasterPageTourOptions" :callbacks="MasterPageCNTourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="stopTour()" class="v-step__button">Skip Tour</button>
                <button @click="MasterPageCNTourNextSteps()" class="v-step__button">Next step</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour name="MasterPageRFTourName" :steps="MasterPageRFTourSteps" :options="MasterPageTourOptions" :callbacks="MasterPageRFTourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="tour.stop" class="v-step__button">Skip Tour</button>
                <button @click="MasterPageRFTourNextSteps()" class="v-step__button">Next step</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div data-v-step="app02"></div>
    <div data-v-step="gr02"></div>
  </div>
</template>
<script>
import $ from 'jquery'
import DataSource from '../data/datasource'
import VueTour from 'vue-tour'
import Vue from 'vue'
import { lang } from '../locale/index'

require('vue-tour/dist/vue-tour.css')
import Cookies from 'js-cookie'
import moment from 'moment'
import K2Checkbox from '../uiComponents/k2Checkbox/k2Checkbox'
import K2Radio from '../uiComponents/k2Radio/k2Radio'
import K2Row from '../uiComponents/k2Row/k2Row'

Vue.use(VueTour)

const getCurrentDate = () => {
  const d = new Date()
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
}
const getCurrentDateTime = () => {
  const d = new Date()
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`
}

export default {
  name: 'StudentPaymentPlan',
  components: { K2Row, K2Radio, K2Checkbox },
  data() {
    return (window._v = {
      gstRate: 9,
      invoiceTimestamp: '',
      selectedRebateDesc: '',
      isSchoolFeeRebateDisabled: false,
      schoolFeesRebateOptions: [],
      japSchoolFeesRebateOptions: [
        {
          value: 'School fees rebate for May 2020',
          label: 'School fees rebate for May 2020',
        },
      ],
      intlSchoolFeesRebateOptions: [
        {
          value: 'School fees rebate for April 2020',
          label: 'School fees rebate for April 2020',
        },
        {
          value: 'Meal Rebate for May/June 2021',
          label: 'Meal Rebate for May/June 2021',
        },
      ],
      localSchoolFeesRebateOptions: [
        {
          value: 'School fees rebate for April 2020',
          label: 'School fees rebate for April 2020',
        },
        {
          value: 'School fees rebate for May 2020',
          label: 'School fees rebate for May 2020',
        },
      ],
      SchoolFeeRebateValue: '',
      inputInternalReceiptRemarks: '',
      inputInternalCNRemarks: '',
      inputInternalRefundRemarks: '',
      datePicker: {
        disabledDate(date) {
          return date > Number(new Date())
        },
      },
      reprintIndex: 0,
      btnInvRecDisabled: false,

      //reprint
      reprintHistoryListInt: [],
      reprintHistoryList: [
        {
          prop: 'att_Aut_CreatedOn_DateTimeConvert',
          label: lang('Created On'),
        },
        {
          prop: 'DocumentType',
          label: lang('Document Type'),
        },
      ],
      reprintPayeeName: '',
      reprintAddress: '',
      reprintStudentName: '',
      reprintStudentIDNumber: '',
      reprintCompanyName: '',
      reprintCompanyAddress: '',
      reprintLevel: '',
      reprintProgramme: '',
      reprintIDType: '',

      rePrintValue: {},
      textareaStudent: '',
      textareaAddress: '',
      //reprint

      //todo multilanguage
      multi: '',
      //todo multilanguage

      showTourDropdown: false,
      selectedleftOverReceiptTotal: 0,
      tempNewPayAmount: 0,
      getRowKeys(row) {
        return row.SPD_ID
      },

      familyNumber: '',
      parentListTableInt: [],
      parentListTable: [
        {
          prop: 'PAR_Father_FirstName',
          label: lang('Father') + ' ' + lang('Name'),
        },
        {
          prop: 'PAR_Father_Email',
          label: lang('Father') + ' ' + lang('Email'),
        },
        {
          prop: 'PAR_Mother_FirstName',
          label: lang('Mother') + ' ' + lang('Name'),
        },
        {
          prop: 'PAR_Mother_Email',
          label: lang('Mother') + ' ' + lang('Email'),
        },
      ],
      //todo Tour Guide: start
      TourOptions: [
        {
          value: 'pp',
          label: 'apply payment plan tour',
        },
        {
          value: 'sd',
          label: 'sibling/staff discount tour',
        },
        {
          value: 'items',
          label: 'add items tour',
        },
        {
          value: 'gi',
          label: 'generate invoice tour',
        },
        {
          value: 'gr',
          label: 'generate receipt tour',
        },
        {
          value: 'cn',
          label: 'generate credit note tour',
        },
        {
          value: 'rf',
          label: 'Refund Tour',
        },
      ],
      TourRefundFlag: [],
      TourGenerateCNFlag: [],
      studentInvoiceListAreaBorder: false,
      studentReceiptListAreaBorder: false,
      studentLeftOverPaymentListAreaBorder: false,
      studentCreditNoteListAreaBorder: false,
      studentRefundListAreaBorder: false,
      tourPageControl: '',

      MasterPageTourOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },

      MasterPageTourCallbacks: {
        onNextStep: this.sppTourNextSteps,
        onPreviousStep: this.sppTourPreviousSteps,
      },
      MasterPageGRTourCallbacks: {
        onNextStep: this.sppTourNextSteps,
        onPreviousStep: this.sppTourPreviousSteps,
      },
      MasterPageTourSteps: [
        {
          target: '[data-v-step="app01"]',
          content: `<div>Click invoice button</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      MasterPageGRTourSteps: [
        {
          target: '[data-v-step="gr01"]',
          content: `<div>Click receipt button</div>`,
          params: {
            placement: 'top',
          },
        },
      ],

      MasterPageCNTourSteps: [
        {
          target: '[data-v-step="gcn01"]',
          content: `<div>Click generate credit note button</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      MasterPageCNTourCallbacks: {
        onNextStep: this.MasterPageCNTourNextSteps,
        onPreviousStep: this.InvModalPPTourPreviousSteps,
      },

      CnModalTourSteps: [
        {
          target: '[data-v-step="cr01"]',
          content: `<div>Step 1 / 3 <br>Select at least 1 items in list above</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="cr02"]',
          content: `<div>Step 2 / 3 <br>enter remark</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="cr03"]',
          content: `<div>Step 2 / 3 <br>Click CN button</div>`,
          params: {
            placement: 'bottom',
          },
        },
      ],
      CnModalTourCallbacks: {
        onNextStep: this.CNModalTourNextSteps,
        onPreviousStep: this.CNModalTourPreviousSteps,
      },

      InvModalPPTourSteps: [
        {
          target: '[data-v-step="InvApp02"]',
          content: `<div>Step 2 <br> Click apply payment plan</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="InvApp03"]',
          content: 'OK',
          params: {
            placement: 'top',
          },
        },
      ],
      InvModalPPTourCallbacks: {
        onNextStep: this.InvModalPPTourNextSteps,
        onPreviousStep: this.InvModalPPTourPreviousSteps,
      },
      InvModalSDTourSteps: [
        {
          target: '[data-v-step="InvSd03"]',
          content: 'Click on Apply discount plan',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="InvSd04"]',
          content: 'OK',
          params: {
            placement: 'top',
          },
        },
      ],
      InvModalSDTourCallbacks: {
        onNextStep: this.InvModalSDTourNextSteps,
        onPreviousStep: this.InvModalSDTourPreviousSteps,
      },
      InvModalAITourSteps: [
        {
          target: '[data-v-step="InvAi01"]',
          content: 'Click on Add Item button',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="InvAi02"]',
          content: 'OK',
          params: {
            placement: 'top',
          },
        },
      ],
      InvModalAITourCallbacks: {
        onNextStep: this.InvModalAITourNextSteps,
        onPreviousStep: this.InvModalAITourPreviousSteps,
      },
      InvModalGITourSteps: [
        {
          target: '[data-v-step="InvGi01"]',
          content: 'If you need the invoice breakdown, please check here. *****Only eligible for course fees item*****',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="InvGi02"]',
          content: 'Please check at least 1 items in table below, you can adjust $0.01 up/down to overcome the rounding issue',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="InvGi03"]',
          content: 'Preview the items before generate invoice',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="InvGi04"]',
          content: 'Click on generate invoice',
          params: {
            placement: 'top',
          },
        },
      ],
      InvModalGITourCallbacks: {
        onNextStep: this.InvModalGITourNextSteps,
        onPreviousStep: this.InvModaGITourPreviousSteps,
      },
      ppModalTourSteps: [
        {
          target: '[data-v-step="ppBmodal01"]',
          content: 'Select payment plan',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="ppBmodal02"]',
          content: 'Check/View payment plan',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="ppBmodal03"]',
          content: 'Here you go!',
          params: {
            placement: 'bottom',
          },
        },
      ],

      grModalTourSteps: [
        {
          target: '[data-v-step="grmodal01"]',
          content: `<div>Step 1 / 7 <br> Select payment mode</div>`,
          params: {
            placement: 'right',
          },
        },
        {
          target: '[data-v-step="grmodal02"]',
          content: `<div>Step 2 / 7 <br> Please update your cheque detail here if available</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="grmodal03"]',
          content: `<div>Step 3 / 7 <br> Enter remark(Optional)</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="grmodal04"]',
          content: `<div>Step 4 / 7 <br> Select this checkbox, if you need to generate invoice together with your receipt.</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="grmodal05"]',
          content: `<div>Step 5 / 7 <br> Select items to generate/preview receipt and key in your pay amount according.</div>`,
          params: {
            placement: 'left',
          },
        },
        {
          target: '[data-v-step="grmodal06"]',
          content: `<div>Step 6 / 7 <br> Preview receipt</div>`,
          params: {
            placement: 'right',
          },
        },
        {
          target: '[data-v-step="grmodal07"]',
          content: `<div>Step 7 / 7 <br> Click on generate, OK </div>`,
          params: {
            placement: 'right',
          },
        },
      ],
      grModalTourCuztomizeSteps: [
        {
          target: '[data-v-step="grmodal03"]',
          content: `<div>Step 3 / 7 <br> Enter remark(Optional)</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="grmodal04"]',
          content: `<div>Step 4 / 7 <br> Select this checkbox, if you need to generate invoice together with your receipt.</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="grmodal05"]',
          content: `<div>Step 5 / 7 <br> Select items to generate/preview receipt and key in your pay amount according.</div>`,
          params: {
            placement: 'right',
          },
        },
        {
          target: '[data-v-step="grmodal06"]',
          content: `<div>Step 6 / 7 <br> Preview receipt</div>`,
          params: {
            placement: 'right',
          },
        },
        {
          target: '[data-v-step="grmodal07"]',
          content: `<div>Step 7 / 7 <br> Click on generate, OK </div>`,
          params: {
            placement: 'left',
          },
        },
      ],
      grModalTourCallbacks: {
        onNextStep: this.RecModalGRTourNextSteps,
        onPreviousStep: this.RecModalGRTourPreviousSteps,
      },

      sdModalTourSteps: [
        {
          target: '[data-v-step="sdmodal01"]',
          content: 'Check sibling discount eligibility, else you cant apply discount',
          params: {
            placement: 'right',
          },
        },
        {
          target: '[data-v-step="sdmodal02"]',
          content: 'Click here.',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="sdmodal03"]',
          content: 'Select rules',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="sdmodal04"]',
          content: 'Add Discount plan. Done!',
          params: {
            placement: 'top',
          },
        },
      ],

      aiModalTourSteps: [
        {
          target: '[data-v-step="aimodal01"]',
          content: 'Select items',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="aimodal02"]',
          content: 'Check payment date',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="aimodal03"]',
          content: 'Enter Amount',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="aimodal04"]',
          content: 'Select Payment Schedule',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="aimodal05"]',
          content: 'Select Payment Item Type',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="aimodal06"]',
          content: 'Click on Add button',
          params: {
            placement: 'right',
          },
        },
      ],
      aiModalTourCallbacks: {},
      ppModalTourCallbacks: {},
      sdModalTourCallbacks: {},
      grModalTourCuztomizeCallbacks: {
        onNextStep: this.RecModalGRTourCuztomizeNextSteps,
        onPreviousStep: this.RecModalGRTourCuztomizePreviousSteps,
      },

      MasterPageRFTourSteps: [
        {
          target: '[data-v-step="rfMaster01"]',
          content: 'Click on refund button',
          params: {
            placement: 'bottom',
          },
        },
      ],
      MasterPageRFTourCallbacks: {
        onNextStep: this.MasterPageRFTourNextSteps,
        onPreviousStep: this.MasterPageRFTourPreviousSteps,
      },
      rfModalTourSteps: [
        {
          target: '[data-v-step="rf01"]',
          content: 'Select at least 1 items below and check your refund amount',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="rf02"]',
          content: 'Remark(Mandatory)',
          params: {
            placement: 'left',
          },
        },
        {
          target: '[data-v-step="rf03"]',
          content: 'Click on refund button',
          params: {
            placement: 'bottom',
          },
        },
      ],
      rfModalTourCallbacks: {
        onNextStep: this.rfModalTourNextSteps,
        onPreviousStep: this.rfModalTourPreviousSteps,
      },
      //todo Tour Guide: end

      //For Sibling data-table
      siblingListTableInt: [],
      siblingListTableList: [
        {
          prop: 'Index_No',
          label: lang('Student') + ' ' + lang('NO'),
        },
        {
          prop: 'Full_Name',
          label: lang('First Name'),
        },
        {
          prop: 'Last_name',
          label: lang('Last Name'),
        },
        {
          prop: 'Regst_date_convert',
          label: lang('Registration Date'),
        },
        {
          prop: 'SiblingLevelName',
          label: lang('Level'),
        },
        {
          prop: 'Status',
          label: lang('Status'),
        },
        {
          prop: 'SCH_Name',
          label: lang('Center Name'),
        },
      ],
      siblingListAction: {
        label: lang('Details'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-more',
            },
            handler: row => {
              this.$router.push('studentCourse-List?id=' + row.Student_ID)
            },
            label: lang('More'),
          },
        ],
      },

      //start:InvoiceOverPaymentItemInt
      invoiceOverPaymentResponse: [],
      InvoiceOverPaymentItemInt: [],
      InvoiceOverPaymentItemList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'paymentDate',
          label: lang('Payment Date'),
        },
        {
          prop: 'SPPD_PaymentAmount',
          label: lang('Amount'),
        },
        {
          prop: 'SPPD_TotalValue',
          label: lang('Total Amount'),
        },
      ],
      //End:InvoiceOverPaymentItemInt

      //student info
      leftOverListCount: '',
      receiptListCount: '',
      countLeftOverTotalAmount: '',
      countReceiptTotalAmount: '',
      ReceiptList: [],

      inputStudentName: '-',
      inputCreatedBy: '',
      inputCreationDate: '',
      inputStudentStatus: '',
      inputStudentLevel: '',
      inputIntake: '',
      inputFromDate: '',
      inputToDate: '',
      inputStudentNO: '-',
      inputPayeeName: '-',
      inputMealPreferences: '-',
      sponsor_type: '',
      studentDetail: [],
      inputStudentClassBatch: '',
      //

      //Email
      invoiceNoForEmailReminder: '',
      emailReminderList: [],
      inputEmailTo: '',
      inputEmailSubject: '',
      inputEmailMessage: '',
      inputInvoiceReminderDueDate: '',
      reminderInvDueDate: '', //temporary holder for invoice due date
      //Email End

      //temp
      lblPaymentReminder: '',
      readonly: '',
      tempList: '',
      btnDisabled: true,
      courseStatus: false,
      leftOverTemp: [],
      leftOverTempResp: [],
      overPaymentItemsCount: 0,
      isInvoiceLineItemDisabled: false,
      //Preview OR Generate
      overPaymentFlag: '',
      leftOverActionFlag: '',

      //For Credit Note
      cnInvoiceName: '',
      inputCNRemark: '',
      isChecked: true,
      //

      //get invoice name for receipt generation
      receiptInvoiceName: '',

      //For Reinvoice
      customizeReInvoiceResponce: [],
      isSelectable: false,
      reInvoiceName: '',
      Re_InvoiceName: '',
      //

      viewTransactionFlag: '',
      generateReceiptFlag: '',
      generateCNFlag: '',
      reinvoiceFlag: '',

      transactionObj: [],
      //Receipt
      payValue: '',
      inputNewPayAmount: '',
      respTempReceipt: [],
      customizeReceiptResponse: [],

      studentReceiptGenerationListInt: [],
      studentReceiptGenerationList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'paymentDate',
          label: lang('Payment Date'),
        },
        {
          prop: 'SPPD_PaymentAmount',
          label: lang('Amount'),
        },
        {
          prop: 'SPPD_GstValue',
          label: lang('GST Value'),
        },
        {
          prop: 'SPPD_TotalValue',
          label: lang('Total Amount'),
        },
      ],

      //Invoice
      inputInvoiceDate: '',
      respTempInvoice: [],
      customizeInvoiceResponse: [],
      studentInvoiceGenerationListInt: [],
      studentInvoiceGenerationList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'paymentDate',
          label: lang('Payment Date'),
        },
      ],
      //Invoice End

      studentReceiptLeftOverPaymentListInt: [],
      studentReceiptLeftOverPaymentList: [
        {
          prop: 'Item_Description',
          label: lang('Item Description'),
        },
        {
          prop: 'GST_Applicable',
          label: lang('GST Applicable'),
        },
        {
          prop: 'gstValue',
          label: lang('GST Value'),
        },
        {
          prop: 'itemAmount',
          label: lang('Amount'),
        },
        {
          prop: 'totalValue',
          label: lang('Total Amount'),
        },
      ],

      studentReceiptGenerationByTransactionHistoryListInt: [],
      studentReceiptGenerationByTransactionHistoryList: [
        {
          prop: 'DocumentStatus',
          label: lang('Docs Status'),
        },
        {
          prop: 'DocumentDate',
          label: lang('Docs Date'),
        },
        {
          prop: 'DocumentTime',
          label: lang('Docs Time'),
        },
        {
          prop: 'TotalIncGst',
          label: lang('Total(IncludedGst)'),
        },
      ],
      //End:Receipt

      PaymentListInt: [],
      PaymentList: [
        {
          prop: 'IH_Invoice_Name',
          label: lang('Invoice Name'),
        },
        {
          prop: 'invoiceDate',
          label: lang('Invoice Date'),
        },
        {
          prop: 'invoiceAmount',
          label: lang('Invoice Amount'),
        },
        {
          prop: 'outstandingAmount',
          label: lang('Outstanding Amount'),
        },
        {
          prop: 'invoiceDueDate',
          label: lang('Invoice Due Date'),
        },
        {
          prop: 'invoiceRemarks',
          label: lang('Remarks'),
        },
      ],

      itemTransDetailsInt: [],
      itemTransDetailsList: [
        {
          prop: 'DocumentDate',
          label: lang('Date'),
        },
        {
          prop: 'DocumentType',
          label: lang('Transaction Type'),
        },
        {
          prop: 'DocumentNo',
          label: lang('Document Number'),
        },
        {
          prop: 'DocumentStatus',
          label: lang('Document Status'),
        },
        {
          prop: 'TotalIncGst',
          label: lang('Total (Incl. GST)'),
        },
        {
          prop: 'DocumentCreatedBy',
          label: lang('Created By'),
        },
      ],

      itemPaymentPlanDetailsInt: [],
      itemPaymentPlanDetailsList: [
        {
          prop: 'PPD_PaymentSchedule',
          label: lang('Payment Schedule'),
        },
        {
          prop: 'Timeline',
          label: lang('Timeline'),
        },
        {
          prop: 'PPD_PaymentItemType',
          label: lang('Item Type'),
        },
        {
          prop: 'PPD_Payee_Name',
          label: lang('Item Name'),
        },
        {
          prop: 'PPD_Amount',
          label: lang('Amount'),
        },
        {
          prop: 'PPD_CalCategory',
          label: lang('Calculation category'),
        },
      ],

      invoiceDetailsListInt: [],
      invoiceDetailsList: [
        {
          prop: 'ID_Item_Description',
          label: lang('Item Description'),
        },
        {
          prop: 'ID_Item_Amount',
          label: lang('Amount'),
        },
      ],

      ReInvoiceListInt: [],
      ReInvoiceList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'paymentDate',
          label: lang('Payment Date'),
        },
        {
          prop: 'SPPD_PaymentAmount',
          label: lang('Amount'),
        },
        {
          prop: 'SPPD_GstValueEdited',
          label: lang('GST Value'),
        },
        //   {
        //   prop: "SPPD_GstValue",
        //   label: lang("GST Value")
        // },
        {
          prop: 'SPPD_TotalValue',
          label: lang('Total Amount'),
        },
      ],

      isRebateReInvoiceListInt: [],
      isRebateReInvoiceList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'SPPD_PaymentAmount',
          label: lang('Amount'),
        },
        {
          prop: 'SPPD_GstValue',
          label: lang('Gst'),
        },
        {
          prop: 'SPPD_TotalValue',
          label: lang('Total Amount'),
        },
        {
          prop: 'isRebate',
          label: lang('Rebate'),
        },
      ],

      inputPaymentDueDate: '',
      inputReceiptDate: '',
      inputChequeNoBankName: '',
      inputRemarks: '',
      ddlPaymentMode: '',
      viewSPPDPayerName: '',
      ddlAddItem: '',
      inputAddItemPaymentDate: '',
      ddlAddItemCurrency: '',
      inputAddItemAmount: '',
      ddlAddItemPaymentSchedule: '',
      ddlAddItemPaymentItemType: '',
      inputAddItemDescription: '',
      inputAddItemFromDate: '',
      inputAddItemToDate: '',
      ddlAddItemRecurring: '',
      inputAddItemDirect: '',
      disabledRecurring: true,
      isRecurringRequired: false,
      isInputAddItemDirect: false,
      disableOneTime: true,
      ddlPaymentPlan: null,
      inputStaffDiscount: '',
      inputPaymentPlanStartDate: '',
      inputStaffName: '',
      ddlPaymentPlanRuleApplyProRateFees: '',
      ddlPaymentPlanRuleApplySiblings: '',
      ddlPaymentPlanRuleApplyPostRateFees: '',
      ddlPaymentPlanRuleApplyStaff: '',
      cbProRateFees: '',
      cbPostRateFees: '',
      cbSiblingDiscount: '',
      cbStaffDiscount: '',
      disabledCbProRateFees: true,
      disabledCbPostRateFees: true,
      disabledCbSiblingDiscount: true,
      disabledCbStaffDiscount: true,
      disablePaymentPlanRuleProRateFees: true,
      disablePaymentPlanRulePostRateFees: true,
      disablePaymentPlanRuleApplySiblings: true,
      disablePaymentPlanRuleApplyStaff: true,
      inputEligible: 'Eligible',
      inputNotEligible: 'Not Eligible',
      isProRateFeesEligible: false,
      isProRateFeesNotEligible: false,
      isPostRateFeesEligible: false,
      isPostRateFeesNotEligible: false,
      isSiblingDiscountEligible: false,
      isSiblingDiscountNotEligible: false,
      isStaffDiscountEligible: false,
      isStaffDiscountNotEligible: false,
      isDdlProRateFeesRequired: false,
      isDdlStaffDiscRequired: false,
      isDdlSiblingDiscRequired: false,

      inputPaymentPlanLevelStartDate: '',

      inputPaymentPlanRuleProRateAmount: '',
      isInputPaymentPlanRuleProRateAmount: false,
      inputPaymentPlanLevelEndDate: '',

      siblingList: '',
      inputPaymentPlanRuleSiblingsAmount: '',
      isInputPaymentPlanRuleSiblingsAmount: false,
      inputViewPaymentPlanCreationDate: '',
      inputViewPaymentPlanCreationBy: '',
      inputViewPaymentPlanLevel: '',
      inputViewPaymentPlanFeeSchemeName: '',
      inputViewPaymentPlanValidityStart: '',
      inputViewPaymentPlanValidityEnd: '',
      inputViewPaymentPlanTaxApplicable: '',
      inputViewPaymentPlanTax: '',
      inputViewPaymentPlanCenter: '',
      inputViewPaymentPlanCurrency: '',
      inputViewPaymentPlanStatus: '',

      inputPaymentPlanRuleStaffAmount: '',
      isInputPaymentPlanRuleStaffAmount: false,

      //test start --to remove
      inputSchoolName: '',
      schoolAddress1: '',
      //test end --to remove

      siblingListInfo: [],
      paymentModeList: [],
      spdSelection: [],
      addItemList: [],
      addItemCurrencyList: [],
      addItemPaymentScheduleList: [],
      addItemPaymentItemTypeList: [],
      addItemRecurringList: [],
      paymentPlanList: [],
      paymentPlanRuleApplyProRateFeesList: [],
      paymentPlanRuleApplySiblingsList: [],
      paymentPlanRuleApplyPostRateFeesList: [],
      ddlPaymentPlanRuleApplyStaffList: [],
      addSubsidyItemList: [],

      //start CN
      allowCN: '',
      inputCnInvoiceName: '',
      inputCnInvoiceDate: '',
      inputCnPaymentDueDate: '',
      inputCnInvoiceStatus: '',
      inputCnStudentNo: '',
      inputCnStudentName: '',
      taCnRemarks: '',
      //end CN

      cbPrintMonthlyBreakdown: '',
      breakdownFlag: '',

      PaymentListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },

            handler: row => {
              this.status = row.SPPD_Status

              if (this.status == 'Active') {
                this.deleteSPDID = row.PK_SPD_ID
                this.paymentPlanDetailID = row.SPPD_FK_Payment_Plan_Detail_ID
                this.studentCourseID = row.SPPD_FK_Student_Course_ID

                this.deletePaymentItem()
              } else {
                this.$notify.error({
                  title: lang('Message'),
                  message: lang('Payment item cannot be deleted'),
                })
              }
            },
            label: lang('Delete'),
          },
        ],
      },

      studentInvoiceItemListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },

            handler: row => {
              this.status = row.SPPD_Status

              if (this.status == 'Active') {
                this.deleteSPDID = row.PK_SPD_ID
                this.paymentPlanDetailID = row.SPPD_FK_Payment_Plan_Detail_ID
                this.studentCourseID = row.SPPD_FK_Student_Course_ID

                this.deletePaymentItem()
              } else {
                this.$notify.error({
                  title: lang('Message'),
                  message: lang('Payment item cannot be deleted'),
                })
              }
            },
            label: lang('Delete'),
          },
        ],
      },

      studentReceiptItemListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },

            handler: row => {
              this.status = row.SPPD_Status

              if (this.status == 'Active') {
                this.deleteSPDID = row.PK_SPD_ID
                this.paymentPlanDetailID = row.SPPD_FK_Payment_Plan_Detail_ID
                this.studentCourseID = row.SPPD_FK_Student_Course_ID

                this.deletePaymentItem()
              } else {
                this.$notify.error({
                  title: lang('Message'),
                  message: lang('Payment item cannot be deleted'),
                })
              }
            },
            label: lang('Delete'),
          },
        ],
      },

      PaymentListFilters: [
        {
          value: '',
          prop: 'SPPD_PayerName',
        },
        {
          value: '',
          prop: 'SPPD_Status',
        },
        {
          value: '',
          prop: 'SPPD_PaymentDates',
        },
        {
          value: '',
          prop: 'SPPD_PaymentAmount',
        },
        {
          value: '',
          prop: 'totalIncludeGst',
        },
        {
          value: '',
          prop: 'RecTotal',
        },
        {
          value: [],
          prop: ['SPPD_PayerName', 'SPPD_Status', 'SPPD_PaymentDates', 'SPPD_PaymentAmount', 'totalIncludeGst', 'RecTotal'],
        },
      ],
      filters: [
        {
          value: '',
          prop: 'SPPD_PayerName',
        },
        {
          value: '',
          prop: 'SPPD_Status',
        },
        {
          value: '',
          prop: 'SPPD_PaymentDates',
        },
        {
          value: '',
          prop: 'SPPD_PaymentAmount',
        },
        {
          value: '',
          prop: 'totalIncludeGst',
        },
        {
          value: '',
          prop: 'RecTotal',
        },
      ],

      refundListInt: [],
      refundList: [
        {
          prop: 'RD_Item_Description',
          label: lang('Item Description'),
        },
        {
          prop: 'itemAmount',
          label: lang('Amount'),
        },
        {
          prop: 'gstValueEdited',
          label: lang('GST'),
        },
        {
          prop: 'totalAmount',
          label: lang('Total'),
        },
      ],
      tempRefundList: [],
      inputRefundNewPayAmount: '',
      tempRefundResp: [],
      refundInvoiceName: '',
      inputRefundRemarks: '',

      //adhoc receipt generation
      adhocPaymentDueDateResponse: [],
      adhocPaymentDueDate: '',
      requiredInvoice: '',
      //adhoc receipt generation
      siblingItemsCount: '',
      siblingConfirmationFlag: '',

      studentSubsidy: '',
      isSubsidyDiscountEligible: false,
      ddlAddSubsidyItem: '',
      inputAddSubsidyItemPaymentDate: '',
      ddlAddSubsidyItemCurrency: '',
      inputAddSubsidyItemAmount: '',
      ddlAddSubsidyItemPaymentSchedule: '',
      ddlAddSubsidyItemPaymentItemType: '',
      inputAddSubsidyItemDescription: '',
      inputAddSubsidyItemFromDate: '',
      inputAddSubsidyItemToDate: '',
      ddlAddSubsidyItemRecurring: '',
      disabledSubsidyRecurring: true,
      isSubsidyRecurringRequired: false,
      disableSubsidyOneTime: true,
      studentSubsidyList: '',
      allSubsidyList: [],

      //todo only for audit
      AuditDisabled: false,
      //todo only for audit

      //todo refund - covi19
      isRefundRebate: 'N',
      refundRebateobj: [],
      studentRefundRebateListInt: [],
      studentRefundRebateList: [
        {
          prop: 'SPPD_PayerName',
          label: lang('Name'),
        },
        {
          prop: 'SPPD_PaymentAmount',
          label: lang('Amount'),
        },
        {
          prop: 'SPPD_GstValue',
          label: lang('Gst'),
        },
        {
          prop: 'SPPD_TotalValue',
          label: lang('Total Amount'),
        },
        {
          prop: 'isRebate',
          label: lang('Rebate'),
        },
      ],
      customizeRefundRebateResponse: [],
      spdRebateSelection: [],
      isRebateRefundEligible: false,
      isEligibleForFullRefundCN: false,

      isRebateReInvoiceResponce: [],
      isSchoolFeesItemCount: 0,
      schoolRebateFlag: false,
      isAllowRebateTagFlag: false,
      studentSchoolFeeRebateInt: [],
      studentRebateTagListInt: [],
      studentRebateTagList: [{}],
      //todo refund - covi19

      //todo get currentRebateTag InvoiceID when click on "showTransaction"
      currentRebateTagInvoiceID: '',
      //todo get currentRebateTag InvoiceID when click on "showTransaction"
      isIntlSchoolInt: [],
      showTransactionObj: [],
      isCorporateFinance: false,
      showRebateDropdown: false,
      FrequentPayments: '',
      Cda: '',
      SubsidyDesc: '',

      //todo 31th July 2020 reminder enhancement
      showReminderSendButton: false,

      schUniversity: '',
      isJPNSchool: false,
      isBhutanSchool: false,
      refundGstRate: '9%',
      showRefundGstOptions: true,
      showReceiptGstOptions: false,
      reInvoiceGSTRate: '9%',
      showCalculateFPS: false,
      receiptGSTRate: '9%',
    })
  },

  async created() {
    await this.BindStudentInfo()
    await this.BindStudentSibling()
    await this.BindParentInfo()
    await this.checkJPNSchool()
    await this.getPaymentList()
    await this.BindPaymentModeDropdown()
    await this.BindPaymentTermPrintBreakdown()
    await this.hideMiddletonRebateDropdown()

    const d = new Date()
    this.inputReceiptDate = getCurrentDateTime()
    this.inputAddItemPaymentDate = getCurrentDate()
    this.inputAddSubsidyItemPaymentDate = getCurrentDate()

    await this.BindAddItemDropdown()
    await this.BindApplyPaymentPlanDropdown()
    await this.BindCheckboxEligibility()
    await this.getApplyPaymentPlanStartDate()

    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
      this.btnInvRecDisabled = true
    }
    //todo: for external auditor only

    await this.checkIsCorporateFinance()

    //todo: block
    this.schUniversity = Cookies.get('userUniversitySession')
    //    console.log('this.schUniversity',this.schUniversity);
  },

  async mounted() {
    $(function () {
      $('.disabledKeyboardInput').on('keydown', function (e) {
        e.preventDefault()
      })
    })
  },

  methods: {
    checkBefore27thJulyDate(value) {
      var currentInvDate = new Date(value)
      var JulyDate = new Date('2020-07-27T00:00:00')
      return currentInvDate < JulyDate
      // return
    },
    //todo for multi language
    lang,
    //todo for multi language

    closeModal() {
      this.$refs.generateReceiptModal.hide()
      this.$refs.generateInvoiceModal.hide()
      this.$refs.viewRefundModal.hide()
    },

    closePaymentPlanModal() {
      this.$refs.newApplyPaymentPlanShowModal.hide()
    },

    async changeSelection(val) {
      this.spdSelection = val
    },

    async rebateSelection(val) {
      this.spdRebateSelection = val
    },

    adjustmentMin(value) {
      let tempTotalValue = Math.floor(value * 100) / 100 - parseFloat(0.01)
      let newTotalValue = tempTotalValue.toFixed(2)
      return parseFloat(newTotalValue)
    },

    adjustmentMax(value) {
      let tempTotalValue = Math.ceil(value * 100) / 100 + parseFloat(0.01)
      let newTotalValue = tempTotalValue.toFixed(2)
      return parseFloat(newTotalValue)
    },

    updateTotalClick(gstValue, currentAmount, rowData) {
      console.log('updateTotalClick', gstValue, currentAmount, rowData)
      let gst = parseFloat(gstValue)
      let amount = parseFloat(currentAmount)
      let total = 0.0

      total = gst + amount

      this.studentInvoiceGenerationListInt.forEach(m => {
        if (m.PK_SPD_ID == rowData.PK_SPD_ID) {
          m.SPPD_TotalValue = total.toFixed(2)
        }
      })
    },
    updateAmountClick(gstValue, currentAmount, rowData) {
      let gst = parseFloat(gstValue)
      let amount = parseFloat(currentAmount)
      let total = 0.0

      total = gst + amount

      this.studentInvoiceGenerationListInt.forEach(m => {
        if (m.PK_SPD_ID == rowData.PK_SPD_ID) {
          m.SPPD_TotalValue = total.toFixed(2)
        }
      })
    },
    async overPaymentClick(value) {
      if (value == 'Yes') {
        this.$vs.loading()

        const receiptResp = await DataSource.shared.generateReceipt(
          JSON.stringify(this.overPaymentSPDList),
          this.studentID,
          this.studentCourseID,
          this.overPaymentFlag,
        )

        if (receiptResp.code === '88') {
          window.location.replace('/')
        } else if (receiptResp.code === '99' || receiptResp.code === '2') {
          this.$notify.error({
            title: 'Error',
            message: 'Failed to preview receipt!',
          })
        } else {
          this.$refs.showOverPaymentConfirmationModal.hide()
          this.displayPdf(receiptResp.code)

          if (this.overPaymentFlag == 'Generate') {
            await this.getStudentReceiptGenerationList()
            await this.getPaymentList()
            await this.getleftOverPaymentReceipt()
            this.$refs.generateReceiptModal.hide()
            this.$refs.showGenerateReceiptByHistoryModal.hide()
            this.ddlPaymentMode = ''
            this.inputRemarks = ''
            this.inputChequeNoBankName = ''
            this.inputReceiptDate = getCurrentDateTime()
          }
          // this.clearSelect();
        }
      } else {
        this.$refs.showOverPaymentConfirmationModal.hide()
      }

      this.$vs.loading.close()
    },

    //Start: To disabled el-table-column "selectable"
    canSelectRow(row, index) {
      if (row.SPPD_IsAutoOverpay === 'Y') {
        this.isInvoiceLineItemDisabled = false
      } else {
        this.isInvoiceLineItemDisabled = true
      }
      return this.isInvoiceLineItemDisabled
    },
    //End: To disabled el-table-column "selectable"

    async BindStudentInfo() {
      try {
        const resp = await DataSource.shared.getStudent(this.$route.query.sid, '', '', '', '')
        this.studentID = this.$route.query.sid
        this.studentDetail = resp.Table
        this.studentDetail.forEach(m => {
          this.inputStudentName = m.Full_Name + ' ' + m.Last_name
          this.inputStudentNO = m.Index_No
          this.inputStudentStatus = m.Status
          this.sponsor_type = m.sponsor_type
          this.inputCreationDate = m.Created_On_convert
          this.familyNumber = m.PAR_Family_Number
          if (m.St_Meal_Preferences) {
            this.inputMealPreferences = m.St_Meal_Preferences
          } else {
            this.inputMealPreferences = 'N/A'
          }
          //a==0 ? "zero" : "not zero"
          m.St_FrequentPayments ? (this.FrequentPayments = m.St_FrequentPayments) : (this.FrequentPayments = 'N/A')
          m.St_Cda ? (this.Cda = m.St_Cda) : (this.Cda = 'N/A')

          const phrase = m.St_Subsidy_Desc
          const stripped = phrase.replace(/,,,/g, ' , ')

          m.St_Subsidy_Desc ? (this.SubsidyDesc = stripped) : (this.SubsidyDesc = 'N/A')

          this.studentSubsidy = m.St_Subsidy
        })

        const PayeeResp = await DataSource.shared.getPayee(this.inputStudentNO)
        if (this.sponsor_type === 'Father') {
          this.inputPayeeName = PayeeResp.PAR_Father_FirstName + ' ' + PayeeResp.PAR_Father_LastName
        } else if (this.sponsor_type === 'Mother') {
          this.inputPayeeName = PayeeResp.PAR_Mother_FirstName + ' ' + PayeeResp.PAR_Mother_LastName
        } else if (this.sponsor_type === 'Father Company') {
          this.inputPayeeName = PayeeResp.PAR_Father_CompanyName
        } else if (this.sponsor_type === 'Mother Company') {
          this.inputPayeeName = PayeeResp.PAR_Mother_CompanyName
        } else {
          this.inputPayeeName = ''
        }
      } catch (e) {
        this.results = e
      }
    },

    async clearSelect() {
      this.inputInternalReceiptRemarks = ''
      this.inputInternalCNRemarks = ''
      this.inputInternalRefundRemarks = ''
      this.inputRemarks = ''
      this.ddlPaymentMode = ''
      this.inputReceiptDate = getCurrentDateTime()
      this.inputChequeNoBankName = ''
      this.reInvoiceName = ''
      this.inputInvoiceDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear()
      this.Re_InvoiceName = ''
    },

    async BindPaymentModeDropdown() {
      try {
        let jsonString = '"Pay Type":"Pay Type"'
        jsonString = '{' + jsonString + '}'

        const response = await DataSource.shared.getStudentDropDownList(jsonString)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.paymentModeListResponse = response.Table
            this.paymentModeListResponse.forEach(m => {
              if (m.OGPname.trim() === 'Pay Type') {
                this.paymentModeList.push(m)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindPaymentTermPrintBreakdown() {
      try {
        const response = await DataSource.shared.getPaymentPlanLevelStartDate(this.studentCourseID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            var SCH_TermsOfPayment = 0
            var SCH_ToPrintSpecial = ''
            this.paymentDueDateResponse = response.Table
            this.paymentDueDateResponse.forEach(m => {
              SCH_TermsOfPayment = m.SCH_TermsOfPayment
              SCH_ToPrintSpecial = m.SCH_ToPrintSpecial
            })

            let addDaysPaymentDue
            if (SCH_TermsOfPayment || parseInt(SCH_TermsOfPayment) === 0) {
              addDaysPaymentDue = new Date(new Date().setDate(new Date().getDate() + parseInt(SCH_TermsOfPayment)))
            } else {
              addDaysPaymentDue = new Date(new Date().setDate(new Date().getDate() + 15))
            }
            // this.inputPaymentDueDate = addDaysPaymentDue.getDate() + '/' + (addDaysPaymentDue.getMonth() + 1) + '/' + addDaysPaymentDue.getFullYear();
            this.inputPaymentDueDate =
              addDaysPaymentDue.getDate().toString().padStart(2, 0) +
              '/' +
              (addDaysPaymentDue.getMonth() + 1).toString().padStart(2, 0) +
              '/' +
              addDaysPaymentDue.getFullYear()

            if (SCH_ToPrintSpecial !== 'No') {
              this.cbPrintMonthlyBreakdown = true
            } else {
              this.cbPrintMonthlyBreakdown = false
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindAddItemDropdown() {
      try {
        let jsonString = '"Payment Item Names":"Payment Item Names"'
        jsonString = jsonString + ',"Currency List":"Currency List"'
        jsonString = jsonString + ',"Payment Schedule":"Payment Schedule"'
        jsonString = jsonString + ',"Payment Item Type":"Payment Item Type"'
        jsonString = jsonString + ',"Recurring":"Recurring"'
        jsonString = jsonString + ',"Subsidies":"Subsidies"'

        jsonString = '{' + jsonString + '}'

        const response = await DataSource.shared.getStudentDropDownList(jsonString)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.addItemListResponse = response.Table
            this.addItemListResponse.forEach(m => {
              if (m.OGPname.trim() === 'Payment Item Names') {
                this.addItemList.push(m)
              } else if (m.OGPname.trim() === 'Currency List') {
                this.addItemCurrencyList.push(m)
              } else if (m.OGPname.trim() === 'Payment Schedule') {
                this.addItemPaymentScheduleList.push(m)
              } else if (m.OGPname.trim() === 'Payment Item Type') {
                this.addItemPaymentItemTypeList.push(m)
              } else if (m.OGPname.trim() === 'Recurring') {
                this.addItemRecurringList.push(m)
              } else if (m.OGPname.trim() === 'Subsidies') {
                this.allSubsidyList.push(m)
              }
            })

            const currencyResponse = await DataSource.shared.getCurrencyValueDropdownlist()
            currencyResponse.Table.forEach(m => {
              this.ddlAddItemCurrency = m.SCH_Currency
              this.ddlAddSubsidyItemCurrency = m.SCH_Currency
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindApplyPaymentPlanDropdown() {
      try {
        const paymentPlanResponse = await DataSource.shared.getPaymentPlanMasterList(this.studentCourseID)
        if (paymentPlanResponse) {
          if (paymentPlanResponse.code === '88') {
            window.location.replace('/')
          } else {
            this.paymentPlanListResponse = paymentPlanResponse.Table

            this.paymentPlanListResponse?.forEach(m => {
              this.paymentPlanList.push(m)
            })
          }
        }

        let jsonString = '"Pro-Rate Discount":"Pro-Rate Discount"'
        jsonString = jsonString + ',"Sibling Discount":"Sibling Discount"'
        jsonString = jsonString + ',"Post-Rated Discounts":"Post-Rated Discounts"'
        jsonString = '{' + jsonString + '}'

        const ruleResponse = await DataSource.shared.getPaymentPlanRules(this.studentCourseID, jsonString)
        if (ruleResponse) {
          this.paymentPlanRuleResponse = ruleResponse.Table
          this.paymentPlanRuleResponse.forEach(m => {
            if (m.PPR_Category.trim() === 'Pro-Rate Discount') {
              this.paymentPlanRuleApplyProRateFeesList.push(m)
            } else if (m.PPR_Category.trim() === 'Sibling Discount') {
              this.paymentPlanRuleApplySiblingsList.push(m)
            } else if (m.PPR_Category.trim() === 'Post-Rated Discounts') {
              this.paymentPlanRuleApplyPostRateFeesList.push(m)
            }
          })
        }

        const staffRuleResponse = await DataSource.shared.getPaymentPlanStaffRules(this.studentID)
        if (staffRuleResponse) {
          this.ddlPaymentPlanRuleApplyStaffList = staffRuleResponse.Table
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindCheckboxEligibility() {
      try {
        const proRateFeeEligibleResponse = await DataSource.shared.checkRateFeeEligible(this.studentID, this.studentCourseID, 'pro')
        if (proRateFeeEligibleResponse) {
          if (proRateFeeEligibleResponse.code === '88') {
            window.location.replace('/')
          } else if (proRateFeeEligibleResponse.code === '1') {
            this.disabledCbProRateFees = false
            this.isProRateFeesEligible = true
            this.isProRateFeesNotEligible = false

            const levelResponse = await DataSource.shared.getPaymentPlanLevelStartDate(this.studentCourseID)

            if (levelResponse) {
              this.paymentPlanLevelResponse = levelResponse.Table
              this.paymentPlanLevelResponse.forEach(m => {
                this.inputPaymentPlanLevelStartDate = m.SCRS_From_Date_convert + ' (Week ' + m.noOfWeek + ')'
              })
            }
          } else if (proRateFeeEligibleResponse.code === '2') {
            this.disabledCbProRateFees = true
            this.isProRateFeesEligible = false
            this.isProRateFeesNotEligible = true
            this.inputPaymentPlanLevelStartDate = ''
          }
        }

        const postRateFeeEligibleResponse = await DataSource.shared.checkRateFeeEligible(this.studentID, this.studentCourseID, 'post')
        if (postRateFeeEligibleResponse) {
          if (postRateFeeEligibleResponse.code === '88') {
            window.location.replace('/')
          } else if (postRateFeeEligibleResponse.code === '1') {
            this.disabledCbPostRateFees = false
            this.isPostRateFeesEligible = true
            this.isPostRateFeesNotEligible = false
          } else if (postRateFeeEligibleResponse.code === '2') {
            this.disabledCbPostRateFees = true
            this.isPostRateFeesEligible = false
            this.isPostRateFeesNotEligible = true
          }
        }

        const siblingDiscEligibleResponse = await DataSource.shared.checkSiblingDiscountEligible(this.studentID)
        if (siblingDiscEligibleResponse) {
          if (siblingDiscEligibleResponse.code === '88') {
            window.location.replace('/')
          } else if (siblingDiscEligibleResponse.code === '1') {
            this.disabledCbSiblingDiscount = false
            this.isSiblingDiscountEligible = true
            this.isSiblingDiscountNotEligible = false

            const siblingListResponse = await DataSource.shared.getSiblingList(this.studentID)
            if (siblingListResponse.Table.length > 0) {
              this.siblingListInfo = siblingListResponse.Table
              this.siblingList = true
            }
          } else if (siblingDiscEligibleResponse.code === '2') {
            this.disabledCbSiblingDiscount = true
            this.isSiblingDiscountEligible = false
            this.isSiblingDiscountNotEligible = true
          }
        }

        const staffDiscEligibleResponse = await DataSource.shared.checkStaffDiscountEligible(this.studentID)
        if (staffDiscEligibleResponse) {
          if (staffDiscEligibleResponse.code === '88') {
            window.location.replace('/')
          } else if (staffDiscEligibleResponse.code === '1') {
            this.disabledCbStaffDiscount = false
            this.isStaffDiscountEligible = true
            this.isStaffDiscountNotEligible = false
          } else if (staffDiscEligibleResponse.code === '2') {
            this.disabledCbStaffDiscount = true
            this.isStaffDiscountEligible = false
            this.isStaffDiscountNotEligible = true
          }
        }

        if (this.studentSubsidy) {
          //got subsidy value
          this.isSubsidyDiscountEligible = true
        } else {
          this.isSubsidyDiscountEligible = false
        }
      } catch (e) {
        this.results = e
      }
    },

    async cbProRateFeesClick() {
      if (this.cbProRateFees == true) {
        this.disablePaymentPlanRuleProRateFees = false
        this.isDdlProRateFeesRequired = true
      } else {
        this.disablePaymentPlanRuleProRateFees = true
        this.isDdlProRateFeesRequired = false
        this.isInputPaymentPlanRuleProRateAmount = false
        this.inputPaymentPlanRuleProRateAmount = ''
        this.ddlPaymentPlanRuleApplyProRateFees = ''
      }
    },

    async cbPostRateFeesClick() {
      if (this.cbPostRateFees == true) {
        this.disablePaymentPlanRulePostRateFees = false
      } else {
        this.disablePaymentPlanRulePostRateFees = true
        this.ddlPaymentPlanRuleApplyPostRateFees = ''
      }
    },

    async cbSiblingDiscountClick() {
      if (this.cbSiblingDiscount == true) {
        this.disablePaymentPlanRuleApplySiblings = false
        this.isDdlSiblingDiscRequired = true
      } else {
        this.disablePaymentPlanRuleApplySiblings = true
        this.isDdlSiblingDiscRequired = false
        this.isInputPaymentPlanRuleSiblingsAmount = false
        this.inputPaymentPlanRuleSiblingsAmount = ''
        this.ddlPaymentPlanRuleApplySiblings = ''
      }
    },

    async cbStaffDiscountClick() {
      if (this.cbStaffDiscount == true) {
        this.disablePaymentPlanRuleApplyStaff = false
        this.isDdlStaffDiscRequired = true
      } else {
        this.disablePaymentPlanRuleApplyStaff = true
        this.isDdlStaffDiscRequired = false
        this.isInputPaymentPlanRuleStaffAmount = false
        this.ddlPaymentPlanRuleApplyStaff = ''
        this.inputStaffName = ''
      }
    },

    async BindStudentSibling() {
      try {
        const response = await DataSource.shared.getSibling('', this.$route.query.sid)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (response.Table.length > 0) {
              this.siblingListTableInt = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindParentInfo() {
      try {
        if (this.familyNumber) {
          const resp = await DataSource.shared.getParentList(this.familyNumber, '', '')
          this.parentListTableInt = resp.Table
        } else {
          this.parentListTableInt = []
        }
      } catch (e) {
        this.results = e
      }
    },

    async onchangePaymentPlanRuleProRateFees() {
      const response = await DataSource.shared.getPaymentPlanRuleDetails(this.ddlPaymentPlanRuleApplyProRateFees)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99' || response.code === '2') {
          this.isInputPaymentPlanRuleProRateAmount = false
          this.inputPaymentPlanRuleProRateAmount = ''
        } else {
          this.isInputPaymentPlanRuleProRateAmount = true
          this.paymentPlanRateResponse = response.Table
          this.paymentPlanRateResponse.forEach(m => {
            if (m.PPR_Unit == 'Amount') {
              if (this.isJPNSchool) {
                this.inputPaymentPlanRuleProRateAmount = '(¥ ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
              } else {
                this.inputPaymentPlanRuleProRateAmount = '($ ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
              }
            } else if (m.PPR_Unit == 'Percentage') {
              this.inputPaymentPlanRuleProRateAmount = '(% ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
            }
          })
        }
      }
    },

    async onchangePaymentPlanRuleSiblings() {
      const response = await DataSource.shared.getPaymentPlanRuleDetails(this.ddlPaymentPlanRuleApplySiblings)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99' || response.code === '2') {
          this.isInputPaymentPlanRuleSiblingsAmount = false
          this.inputPaymentPlanRuleSiblingsAmount = ''
        } else {
          this.isInputPaymentPlanRuleSiblingsAmount = true
          this.paymentPlanRateResponse = response.Table
          this.paymentPlanRateResponse.forEach(m => {
            if (m.PPR_Unit == 'Amount') {
              if (this.isJPNSchool) {
                this.inputPaymentPlanRuleSiblingsAmount = '(¥ ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
              } else {
                this.inputPaymentPlanRuleSiblingsAmount = '($ ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
              }
            } else if (m.PPR_Unit == 'Percentage') {
              this.inputPaymentPlanRuleSiblingsAmount = '(% ' + m.PPR_Value + ' - ' + m.SCH_Currency + ')'
            }
          })
        }
      }
    },

    async onchangePaymentPlanRuleStaff() {
      const curRes = await DataSource.shared.getPaymentPlanLevelStartDate(this.studentCourseID)
      curRes.Table.forEach(e => {
        this.currency = e.SCH_Currency
      })

      const response = await DataSource.shared.getUserDetails(this.ddlPaymentPlanRuleApplyStaff)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          this.isInputPaymentPlanRuleStaffAmount = false
          this.inputPaymentPlanRuleStaffAmount = ''
        } else {
          this.isInputPaymentPlanRuleStaffAmount = true
          this.paymentPlanStaffRateResponse = response.Table
          this.paymentPlanStaffRateResponse.forEach(m => {
            if (m.CONPerSalesCommisionUnit.toUpperCase() == 'AMOUNT') {
              if (this.isJPNSchool) {
                this.inputPaymentPlanRuleStaffAmount = '(¥ ' + m.CONPerSalesCommision + ' - ' + this.currency + ')'
              } else {
                this.inputPaymentPlanRuleStaffAmount = '($ ' + m.CONPerSalesCommision + ' - ' + this.currency + ')'
              }
            } else {
              this.inputPaymentPlanRuleStaffAmount = '(% ' + m.CONPerSalesCommision + ' - ' + this.currency + ')'
            }
          })
        }
      }

      const staffNameFilter = this.ddlPaymentPlanRuleApplyStaffList.filter(d => {
        return d.staffContactID === this.ddlPaymentPlanRuleApplyStaff
      })
      this.inputStaffName = staffNameFilter[0].staffName
    },

    async getApplyPaymentPlanStartDate() {
      const response = await DataSource.shared.getStudentCourseSemesterInfo('', this.studentCourseID)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          this.inputPaymentPlanStartDate = ''
        } else {
          this.paymentPlanStartDateResponse = response.Table
          this.paymentPlanStartDateResponse.forEach(m => {
            this.inputPaymentPlanStartDate = m.SMT_From_Date_convert
            this.inputStudentClassBatch = m.ClassName + '-' + m.Batch
          })
        }
      }
    },

    async getPaymentList() {
      this.$vs.loading()
      try {
        this.studentCourseID = this.$route.query.scid
        this.studentID = this.$route.query.sid
        this.courseStatus = this.$route.query.crsStatus

        //todo: To disabled the generate invoice and receipt button if course status = 'closed'

        if (
          this.$route.query.crsStatus === 'Closed' ||
          this.$route.query.crsStatus === 'Withdrawn' ||
          this.$route.query.crsStatus === 'Graduated' ||
          this.$route.query.crsStatus === 'Void'
        ) {
          this.btnInvRecDisabled = true
          this.btnDisabled = false
        } else {
          this.btnDisabled = false
          this.btnInvRecDisabled = false
        }

        const response = await DataSource.shared.getPaymentList(this.studentCourseID, this.studentID)
        if (response) {
          switch (response.code) {
            case '2':
              this.btnDisabled = true
              this.$notify.error({
                title: 'No Record Found',
                message: 'No Student Payment Record',
              })
              break
            case '88':
              this.btnDisabled = true
              this.$router.push('/')
              break
            case '99':
              this.btnDisabled = true
              // this.$notify.error({
              //     title: 'Error',
              //     message: 'Error'
              // });
              break

            default:
              response.Table.forEach(m => {
                if (!m.IH_Invoice_Name) {
                  m.IH_Invoice_Name = '-'
                }
                if (!m.invoiceDate) {
                  m.invoiceDate = '-'
                }
                if (!m.invoiceAmount) {
                  m.invoiceAmount = '-'
                } else {
                  this.isJPNSchool ? (m.invoiceAmount = '¥' + m.invoiceAmount) : (m.invoiceAmount = '$' + m.invoiceAmount)
                }
                if (!m.invoiceRemarks) {
                  m.invoiceRemarks = ''
                }
              })

              this.PaymentListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async deletePaymentItem() {
      if (this.AuditDisabled) {
        return
      }
      this.$vs.loading()
      try {
        const response = await DataSource.shared.deletePaymentItem(this.deleteSPDID, this.paymentPlanDetailID, this.studentCourseID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99' || response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'Delete Payment Item Error!',
            })
          } else {
            //For main screen- refresh list
            const responsePaymentList = await DataSource.shared.getPaymentList(this.studentCourseID, this.studentID)
            this.PaymentListInt = responsePaymentList.Table

            //For receipt b-modal - refresh list
            await this.getStudentReceiptGenerationList()

            //For invoice b-modal - refresh list
            await this.getStudentInvoiceGenerationList()

            this.clearSelect()

            this.$notify({
              title: 'Success',
              message: 'Successfully Deleted!',
              type: 'success',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    addItemClick() {
      this.$refs.newAddItemShowModal.show()
    },
    async autoApplyPlanClick() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.autoApplyPlan(this.studentCourseID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99' || response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'Auto Apply Plan Error!',
            })
          } else {
            await this.getStudentReceiptGenerationList()
            await this.getStudentInvoiceGenerationList()
            this.$vs.loading.close()
            this.$notify({
              title: 'Success',
              message: 'Successfully Added!',
              type: 'success',
            })
            this.$refs.newApplyPaymentPlanShowModal.hide()
            this.showGenerateInvoice()
          }
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async calculateFPSClick() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.calculateFPS(this.studentCourseID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99' || response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'Calculate FPS Error!',
            })
          } else {
            await this.getStudentReceiptGenerationList()
            await this.getStudentInvoiceGenerationList()
            this.$vs.loading.close()
            this.$notify({
              title: 'Success',
              message: 'Successfully Added!',
              type: 'success',
            })
            this.$refs.newApplyPaymentPlanShowModal.hide()
            this.showGenerateInvoice()
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    closeAddItemModalClick() {
      this.$refs.newAddItemShowModal.hide()
    },

    onlyNumber($event, inputValue) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      // Allow the minus sign (-) if the user enters it first
      if (keyCode === 45 && (inputValue === '' || inputValue === null)) {
        // code 45 is "-"
        return
      } else if (keyCode === 46 && !inputValue.includes('.') && inputValue !== '') {
        // code 46 is "."
        if (inputValue.includes('-') && inputValue.length === 1) {
          $event.preventDefault()
        } else {
          return
        }
      } else if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault()
      }
    },

    onlyNumberJPN($event, inputValue) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      // Allow the minus sign (-) if the user enters it first
      if (keyCode === 45 && (inputValue === '' || inputValue === null)) {
        // code 45 is "-"
        return
      } else if (keyCode === 46 && !inputValue.includes('.') && inputValue !== '') {
        // code 46 is "."
        if (inputValue.includes('-') && inputValue.length === 1) {
          $event.preventDefault()
        } else if (keyCode === 46) {
          $event.preventDefault()
        } else {
          return
        }
      } else if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault()
      }
    },

    async onchangeAddItemPaymentSchedule() {
      if (this.ddlAddItemPaymentSchedule === 'Recurring') {
        this.disabledRecurring = false
        this.isRecurringRequired = true
        this.disableOneTime = true
      } else {
        this.disabledRecurring = true
        this.isRecurringRequired = false
        this.disableOneTime = false
      }
    },

    async onchangeAddItem() {
      if (this.ddlAddItem === 'Others') {
        this.isInputAddItemDirect = true
      } else {
        this.isInputAddItemDirect = false
      }
    },

    async saveItemClick() {
      try {
        let btnAddItemObject = []
        btnAddItemObject.SPPD_FK_Student_Course_ID = this.studentCourseID

        if (this.ddlAddItem === 'Others') {
          btnAddItemObject.SPPD_PayerName = this.inputAddItemDirect
        } else {
          btnAddItemObject.SPPD_PayerName = this.ddlAddItem
        }
        btnAddItemObject.SPPD_PaymentSchedule = this.ddlAddItemPaymentSchedule
        btnAddItemObject.SPPD_PaymentItemType = this.ddlAddItemPaymentItemType
        btnAddItemObject.SPPD_Currency = this.ddlAddItemCurrency
        btnAddItemObject.SPPD_PaymentAmount = this.inputAddItemAmount
        btnAddItemObject.SPPD_PaymentDate = this.inputAddItemPaymentDate
        btnAddItemObject.noOfRecurring = this.ddlAddItemRecurring
        btnAddItemObject.itemDescription = this.inputAddItemDescription
        btnAddItemObject.itemFromDate = this.inputAddItemFromDate
        btnAddItemObject.itemToDate = this.inputAddItemToDate

        if (
          !this.ddlAddItem ||
          !this.inputAddItemAmount ||
          !this.inputAddItemPaymentDate ||
          !this.ddlAddItemCurrency ||
          !this.ddlAddItemPaymentSchedule ||
          !this.ddlAddItemPaymentItemType ||
          (this.ddlAddItemPaymentSchedule === 'Recurring' && !this.ddlAddItemRecurring) ||
          (this.ddlAddItem === 'Others' && !this.inputAddItemDirect)
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields',
          })
        }
        else {
          const response = await DataSource.shared.saveItem(btnAddItemObject)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99' || response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Save Item Error!',
              })
            } else {
              //main screen
              await this.getPaymentList()

              //To refresh receipt preview and generate b-modal
              await this.getStudentReceiptGenerationList()

              //To refresh invoice preview and generate b-modal
              await this.getStudentInvoiceGenerationList()

              //To refresh reinvoice b-modal
              if (this.Re_InvoiceName) {
                await this.getReInvoice(this.Re_InvoiceName)
              }

              this.$notify({
                title: 'Success',
                message: 'Successfully Added!',
                type: 'success',
              })
              this.$refs.newAddItemShowModal.hide()
              this.clearAddItemField()
              // this.clearSelect();
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async clearAddItemField() {
      this.ddlAddItem = ''
      this.isInputAddItemDirect = false
      this.disabledRecurring = true
      this.isRecurringRequired = false
      this.disableOneTime = true
      const currencyResponse = await DataSource.shared.getCurrencyValueDropdownlist()
      currencyResponse.Table.forEach(m => {
        this.ddlAddItemCurrency = m.SCH_Currency
      })

      this.inputAddItemPaymentDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear()

      this.inputAddItemDirect = ''
      this.inputAddItemAmount = ''
      this.ddlAddItemPaymentSchedule = ''
      this.ddlAddItemRecurring = ''
      this.inputAddItemFromDate = ''
      this.ddlAddItemPaymentItemType = ''
      this.inputAddItemDescription = ''
      this.inputAddItemToDate = ''
    },

    applyPaymentPlanClick() {
      this.$refs.newApplyPaymentPlanShowModal.show()
    },

    showDiscountPlanClick() {
      this.$refs.newApplyDiscountPlanShowModal.show()
    },

    showSubsidyDiscountClick() {
      try {
        this.addSubsidyItemList = []
        if (this.studentSubsidy) {
          this.studentSubsidyList = this.studentSubsidy.split(',')
          this.studentSubsidyList.forEach(m => {
            this.allSubsidyList.forEach(n => {
              if (m == n.OPTid) {
                this.addSubsidyItemList.push(n.OPTvalue)
              }
            })
          })
        }
      } catch (e) {
        this.results = e
      }

      this.$refs.showSubsidyDiscountModal.show() //todo: JS
    },

    closeSubsidyDiscountModalClick() {
      this.$refs.showSubsidyDiscountModal.hide() //todo: JS
    },

    async onchangeAddSubsidyItemPaymentSchedule() {
      if (this.ddlAddSubsidyItemPaymentSchedule === 'Recurring') {
        this.disabledSubsidyRecurring = false
        this.isSubsidyRecurringRequired = true
        this.disableSubsidyOneTime = true
      } else {
        this.disabledSubsidyRecurring = true
        this.isSubsidyRecurringRequired = false
        this.disableSubsidyOneTime = false
      }
    },

    async saveSubsidyItemClick() {
      try {
        let btnAddSubsidyItemObject = []
        btnAddSubsidyItemObject.SPPD_FK_Student_Course_ID = this.studentCourseID

        if (this.ddlAddSubsidyItem === 'Others') {
          btnAddSubsidyItemObject.SPPD_PayerName = this.inputAddSubsidyItemDirect
        } else {
          btnAddSubsidyItemObject.SPPD_PayerName = this.ddlAddSubsidyItem
        }
        btnAddSubsidyItemObject.SPPD_PaymentSchedule = this.ddlAddSubsidyItemPaymentSchedule
        btnAddSubsidyItemObject.SPPD_PaymentItemType = this.ddlAddSubsidyItemPaymentItemType
        btnAddSubsidyItemObject.SPPD_Currency = this.ddlAddSubsidyItemCurrency
        btnAddSubsidyItemObject.SPPD_PaymentAmount = this.inputAddSubsidyItemAmount
        btnAddSubsidyItemObject.SPPD_PaymentDate = this.inputAddSubsidyItemPaymentDate
        btnAddSubsidyItemObject.noOfRecurring = this.ddlAddSubsidyItemRecurring
        btnAddSubsidyItemObject.itemDescription = this.inputAddSubsidyItemDescription
        btnAddSubsidyItemObject.itemFromDate = this.inputAddSubsidyItemFromDate
        btnAddSubsidyItemObject.itemToDate = this.inputAddSubsidyItemToDate

        if (
          !this.ddlAddSubsidyItem ||
          !this.inputAddSubsidyItemAmount ||
          !this.inputAddSubsidyItemPaymentDate ||
          !this.ddlAddSubsidyItemCurrency ||
          !this.ddlAddSubsidyItemPaymentSchedule ||
          !this.ddlAddSubsidyItemPaymentItemType ||
          (this.ddlAddSubsidyItemPaymentSchedule === 'Recurring' && !this.ddlAddSubsidyItemRecurring) ||
          (this.ddlAddSubsidyItem === 'Others' && !this.inputAddSubsidyItemDirect)
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields',
          })
        } else if (this.inputAddSubsidyItemAmount > 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Subsidy amount need to be negative!',
          })
        } else {
          const response = await DataSource.shared.saveItem(btnAddSubsidyItemObject)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99' || response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Save Item Error!',
              })
            } else {
              //main screen
              await this.getPaymentList()

              //To refresh receipt preview and generate b-modal
              await this.getStudentReceiptGenerationList()

              //To refresh invoice preview and generate b-modal
              await this.getStudentInvoiceGenerationList()

              //To refresh reinvoice b-modal
              if (this.Re_InvoiceName) {
                await this.getReInvoice(this.Re_InvoiceName)
              }

              this.$notify({
                title: 'Success',
                message: 'Successfully Added!',
                type: 'success',
              })
              this.$refs.showSubsidyDiscountModal.hide()
              this.clearAddSubsidyItemField()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async clearAddSubsidyItemField() {
      this.ddlAddSubsidyItem = ''

      this.disableSubsidyOneTime = true
      const currencyResponse = await DataSource.shared.getCurrencyValueDropdownlist()
      currencyResponse.Table.forEach(m => {
        this.ddlAddSubsidyItemCurrency = m.SCH_Currency
      })

      this.inputAddSubsidyItemPaymentDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear()

      this.inputAddSubsidyItemDirect = ''
      this.inputAddSubsidyItemAmount = ''
      this.ddlAddSubsidyItemPaymentSchedule = ''
      this.ddlAddSubsidyItemRecurring = ''
      this.inputAddSubsidyItemFromDate = ''
      this.ddlAddSubsidyItemPaymentItemType = ''
      this.inputAddSubsidyItemDescription = ''
      this.inputAddSubsidyItemToDate = ''
    },

    async viewPaymentPlan() {
      if (this.ddlPaymentPlan != '') {
        const response = await DataSource.shared.getPaymentPlanMasterDetails(this.ddlPaymentPlan)
        const paymentPlanDetailsRes = await DataSource.shared.getPaymentPlanMasterDetailsList(this.ddlPaymentPlan)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99' || response.code === '2') {
            this.$notify({
              title: 'Error',
              message: 'No record',
              type: 'error',
            })
          } else {
            this.paymentPlanDetailsResponse = response.Table
            this.paymentPlanDetailsResponse.forEach(m => {
              this.inputViewPaymentPlanCreationDate = m.createdOn
              this.inputViewPaymentPlanCreationBy = m.CONname
              this.inputViewPaymentPlanLevel = m.CRS_Course_Name
              this.inputViewPaymentPlanFeeSchemeName = m.PPM_Fee_Scheme_Name
              this.inputViewPaymentPlanValidityStart = m.validityStartDate
              this.inputViewPaymentPlanValidityEnd = m.validityEndDate
              this.inputViewPaymentPlanTaxApplicable = m.PPM_GST_Applicable
              this.inputViewPaymentPlanTax = m.FK_GST
              this.inputViewPaymentPlanCenter = m.SCH_Name
              this.inputViewPaymentPlanCurrency = m.PPM_Currency
              this.inputViewPaymentPlanStatus = m.PPM_Status
            })

            if (paymentPlanDetailsRes) {
              if (paymentPlanDetailsRes.code === '88') {
                window.location.replace('/')
              } else {
                this.itemPaymentPlanDetailsInt = paymentPlanDetailsRes.Table
              }
            }
          }
        }
        this.$refs.viewPaymentPlanShowModal.show()
      } else {
        this.$notify({
          title: 'Error',
          message: 'No payment plan selected',
          type: 'error',
        })
      }
    },

    async savePaymentPlanClick() {
      var btnAddPaymentPlanObject = {
        SPPD_FK_Student_Course_ID: this.studentCourseID,
        SPPD_FK_PaymentMaster_ID: this.ddlPaymentPlan,
        startDate: this.inputPaymentPlanStartDate,
        PK_PPR_ID: this.ddlPaymentPlanRuleApplyProRateFees,
        proRateFeesChecked: this.cbProRateFees,
        SPPD_PayerName: this.$refs.ddlPaymentPlanRuleApplyProRateFees.selected.label,
      }

      try {
        if (this.cbProRateFees !== true && !this.ddlPaymentPlan) {
          //if no select payment plan and no prorate
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields',
          })
        } else if (this.cbProRateFees === true && !this.ddlPaymentPlanRuleApplyProRateFees) {
          //if select prorate but no select rule
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields',
          })
        } else {
          const response = await DataSource.shared.savePaymentPlan(JSON.stringify(btnAddPaymentPlanObject))

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99' || response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Add Payment Plan Error!',
              })
            } else {
              await this.getStudentReceiptGenerationList()

              await this.getStudentInvoiceGenerationList()

              this.$notify({
                title: 'Success',
                message: 'Successfully Added!',
                type: 'success',
              })

              this.$refs.newApplyPaymentPlanShowModal.hide()
              this.clearAddPaymentPlanField()
              this.showGenerateInvoice()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    clearAddPaymentPlanField() {
      this.ddlPaymentPlan = ''

      //prorate
      this.cbProRateFees = ''
      this.disablePaymentPlanRuleProRateFees = true
      this.isDdlProRateFeesRequired = false
      this.isInputPaymentPlanRuleProRateAmount = false
      this.inputPaymentPlanRuleProRateAmount = ''
      this.ddlPaymentPlanRuleApplyProRateFees = ''

      //post rate
      this.cbPostRateFees = ''
      this.disablePaymentPlanRulePostRateFees = true
      this.ddlPaymentPlanRuleApplyPostRateFees = ''

      //siblings
      this.cbSiblingDiscount = ''
      this.disablePaymentPlanRuleApplySiblings = true
      this.isDdlSiblingDiscRequired = false
      this.isInputPaymentPlanRuleSiblingsAmount = false
      this.inputPaymentPlanRuleSiblingsAmount = ''
      this.ddlPaymentPlanRuleApplySiblings = ''

      //staff
      this.cbStaffDiscount = ''
      this.disablePaymentPlanRuleApplyStaff = true
      this.isDdlStaffDiscRequired = false
      this.isInputPaymentPlanRuleStaffAmount = false
      this.ddlPaymentPlanRuleApplyStaff = ''
      this.inputStaffName = ''

      //To refresh receipt preview and generate b-modal
      this.getStudentReceiptGenerationList()
    },

    async addDiscountPlanClick() {
      var btnAddDiscountObject = {
        SPPD_FK_Student_Course_ID: this.studentCourseID,
        PK_PPR_ID: this.ddlPaymentPlanRuleApplySiblings,
        conID: this.ddlPaymentPlanRuleApplyStaff,
        siblingDiscountChecked: this.cbSiblingDiscount,
        staffDiscountChecked: this.cbStaffDiscount,
        staffName: this.inputStaffName,
      }

      try {
        if (!this.cbSiblingDiscount && !this.cbStaffDiscount) {
          this.$notify.error({
            title: 'Error',
            message: 'No discount selected',
          })
        } else if ((this.cbSiblingDiscount && !this.ddlPaymentPlanRuleApplySiblings) || (this.cbStaffDiscount && !this.ddlPaymentPlanRuleApplyStaff)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields',
          })
        } else {
          const response = await DataSource.shared.checkStudentPaymentPlan(this.studentCourseID)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '1') {
              const saveDiscountResponse = await DataSource.shared.savePaymentPlanDiscount(JSON.stringify(btnAddDiscountObject))
              if (saveDiscountResponse) {
                if (saveDiscountResponse.code === '88') {
                  window.location.replace('/')
                } else if (saveDiscountResponse.code === '99') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Add Discount Error!',
                  })
                } else if (saveDiscountResponse.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Discount already added before',
                  })
                } else {
                  await this.getPaymentList()

                  await this.getStudentReceiptGenerationList()

                  await this.getStudentInvoiceGenerationList()

                  this.$notify({
                    title: 'Success',
                    message: 'Successfully Added!',
                    type: 'success',
                  })

                  this.$refs.newApplyDiscountPlanShowModal.hide()
                  this.clearAddPaymentPlanField()
                  this.showGenerateInvoice()
                }
              }
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Please add payment plan before add discount',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    displayPdf(base64string, documentNo) {
      var byteChar = atob(base64string)
      var byteNo = new Array(byteChar.length)
      for (var i = 0; i < byteChar.length; i++) {
        byteNo[i] = byteChar.charCodeAt(i)
      }

      var byteArray = new Uint8Array(byteNo)
      var file = new Blob([byteArray], { type: 'application/pdf;base64' })
      var fileUrl = URL.createObjectURL(file)
      // window.openBrowser(fileUrl);
      // window.open(fileUrl, "_blank", "width=500, height=500");
      // this.$router.push({ name: "DownloadPreview", params: { file: fileUrl } });
      let routeData = this.$router.resolve({
        path: '/DownloadPreview',
        query: {
          file: fileUrl,
          // documentNo: documentNo,
          // student: this.inputStudentName,
          fileName: `${documentNo}_${this.inputStudentName}.pdf`,
        },
      })
      window.open(routeData.href, '_blank')
    },

    //todo - For receipt generation
    async getStudentReceiptGenerationList() {
      this.$vs.loading()
      try {
        this.studentCourseID = this.$route.query.scid
        this.studentID = this.$route.query.sid

        const resp = await DataSource.shared.getActivePaymentNoTransactionHistoryList(this.studentCourseID, 'receipt')

        if (resp) {
          switch (resp.code) {
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              var countTotal = 0
              //pass to value for overpayment "confirmation" pop-up.
              this.receiptListCount = resp.Table.length
              //
              this.respTempReceipt = resp.Table
              this.respTempReceipt.forEach(m => {
                if (m.RecTotal == null) {
                  m.RecTotal = 0
                } else {
                  m.RecTotal = m.SPPD_TotalValue
                  countTotal += parseFloat(m.SPPD_TotalValue)
                }
                m.newPayAmount = m.SPPD_TotalValue
                m.IsCheck = false
                this.customizeReceiptResponse.push(m)
              })
              countTotal = countTotal.toFixed(2)
              this.countReceiptTotalAmount = countTotal
              this.studentReceiptGenerationListInt = this.customizeReceiptResponse
              this.customizeReceiptResponse = []
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async previewReceiptClick() {
      this.overPaymentFlag = 'Preview'
      try {
        if (!this.ddlPaymentMode) {
          alert('Please select payment mode.')
        } else {
          let SPD_List = []
          let countOverPaymentItems = 0
          let selectedItemCount = 0
          let countTotalPaidAmount = 0
          let countTotalNewPayAmount = 0

          let countNegativeItem = 0
          let countNegativeValue = 0

          this.spdSelection.forEach(item => {
            selectedItemCount++
            countTotalPaidAmount += parseFloat(item.SPPD_TotalValue)
            countTotalNewPayAmount += parseFloat(item.newPayAmount)

            if (parseFloat(item.SPPD_TotalValue) < 0) {
              countNegativeItem++
              countNegativeValue += parseFloat(item.SPPD_TotalValue)
            }

            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              paymentMode: this.ddlPaymentMode,
              remarks: this.inputRemarks,
              receiptDate: this.inputReceiptDate,
              RD_Cheque_No: this.inputChequeNoBankName,
              RD_Item_Description: item.SPPD_PayerName,
              RD_GST_Applicable: item.SPPD_PaymentItemType,
              newAmount: item.newPayAmount,
              RD_Item_Amount: item.SPPD_PaymentAmount,
              RD_GSTValue: item.SPPD_GstValue,
              internalRemarks: this.inputInternalReceiptRemarks,
              IH_Invoice_Name: '',
            }
            //Todo: overpayment confirmation checking START
            if (parseFloat(item.SPPD_TotalValue) < parseFloat(item.newPayAmount)) {
              countOverPaymentItems++
            }
            //Todo: overpayment confirmation checking END
            SPD_List.push(spdDetail)
          })

          this.overPaymentSPDList = SPD_List
          countTotalPaidAmount = countTotalPaidAmount.toFixed(2)
          countTotalNewPayAmount = countTotalNewPayAmount.toFixed(2)

          if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else if (countNegativeItem > 0 && parseFloat(countNegativeValue) + parseFloat(countTotalPaidAmount) < 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please check your overpayment items!!',
            })
          } else if (countTotalPaidAmount < countTotalNewPayAmount) {
            if (this.receiptListCount === selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else if (this.receiptListCount > selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            }
          } else {
            if (countOverPaymentItems > 0) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else {
              this.$vs.loading()
              //to preview receipt
              const receiptResp = await DataSource.shared.generateReceipt(JSON.stringify(SPD_List), this.studentID, this.studentCourseID, 'Preview')

              if (receiptResp.code === '88') {
                window.location.replace('/')
              } else if (receiptResp.code === '99' || receiptResp.code === '2') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Failed to preview receipt!',
                })
              } else {
                this.displayPdf(receiptResp.code)
                // this.clearSelect();
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async generateReceiptClick(value) {
      this.overPaymentFlag = 'Generate'
      try {
        if (!this.ddlPaymentMode) {
          alert('Please select payment mode.')
        } else {
          let SPD_List = []
          let countOverPaymentItems = 0
          let selectedItemCount = 0
          let countTotalPaidAmount = 0
          let countTotalNewPayAmount = 0

          let countNegativeItem = 0
          let countNegativeValue = 0

          this.spdSelection.forEach(item => {
            //to assign invoiceName='' for adhoc receipt without invoice generated
            if (value === 'AdhocReceipt') {
              this.receiptInvoiceName = ''
            }
            selectedItemCount++
            countTotalPaidAmount += parseFloat(item.SPPD_TotalValue)
            countTotalNewPayAmount += parseFloat(item.newPayAmount)

            if (parseFloat(item.SPPD_TotalValue) < 0) {
              countNegativeItem++
              countNegativeValue += parseFloat(item.SPPD_TotalValue)
            }

            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              paymentMode: this.ddlPaymentMode,
              receiptDate: this.inputReceiptDate,
              remarks: this.inputRemarks,
              RD_Cheque_No: this.inputChequeNoBankName,
              RD_Item_Description: item.SPPD_PayerName,
              RD_GST_Applicable: item.SPPD_PaymentItemType,
              newAmount: item.newPayAmount,
              RD_Item_Amount: item.SPPD_PaymentAmount,
              RD_GSTValue: item.SPPD_GstValue,
              IH_Invoice_Name: this.receiptInvoiceName,
              internalRemarks: this.inputInternalReceiptRemarks,
            }
            //Todo: overpayment confirmation checking START
            if (parseFloat(item.SPPD_TotalValue) < parseFloat(item.newPayAmount)) {
              countOverPaymentItems++
            }
            //Todo: overpayment confirmation checking END
            SPD_List.push(spdDetail)
          })

          this.overPaymentSPDList = SPD_List
          countTotalPaidAmount = countTotalPaidAmount.toFixed(2)
          countTotalNewPayAmount = countTotalNewPayAmount.toFixed(2)

          if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else if (countNegativeItem > 0 && parseFloat(countNegativeValue) + parseFloat(countTotalPaidAmount) < 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please check your overpayment items!!',
            })
          } else if (countTotalPaidAmount < countTotalNewPayAmount) {
            if (this.receiptListCount === selectedItemCount || this.receiptListCount > selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            }
          } else {
            if (countOverPaymentItems > 0) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else {
              if (value === 'AdhocReceipt' && this.requiredInvoice == true) {
                const dueDateResp = await DataSource.shared.getPaymentPlanLevelStartDate(this.studentCourseID)
                if (dueDateResp) {
                  if (dueDateResp.code === '88') {
                    window.location.replace('/')
                  } else if (dueDateResp.code === '99') {
                    console.log('99')
                  } else {
                    //payment terms(get how many day)
                    var SCH_TermsOfPayment = 0

                    this.adhocPaymentDueDateResponse = dueDateResp.Table
                    this.adhocPaymentDueDateResponse.forEach(m => {
                      SCH_TermsOfPayment = m.SCH_TermsOfPayment
                    })
                    let addDaysPaymentDue
                    if (SCH_TermsOfPayment || parseInt(SCH_TermsOfPayment) === 0) {
                      addDaysPaymentDue = new Date(new Date().setDate(new Date().getDate() + parseInt(SCH_TermsOfPayment)))
                    } else {
                      addDaysPaymentDue = new Date(new Date().setDate(new Date().getDate() + 15))
                    }
                    this.adhocPaymentDueDate = addDaysPaymentDue.getDate() + '/' + (addDaysPaymentDue.getMonth() + 1) + '/' + addDaysPaymentDue.getFullYear()
                  }
                }

                let adhocSPD_List = []
                this.spdSelection.forEach(item => {
                  let adhocSpdDetail = {
                    PK_SPD_ID: item.PK_SPD_ID,
                    SPPD_Status: item.SPPD_Status,
                    SPPD_PayerName: item.SPPD_PayerName,
                    SPPD_FK_Payment_Plan_Detail_ID: item.SPPD_FK_Payment_Plan_Detail_ID,
                    SPPD_FK_PaymentMaster_ID: item.SPPD_FK_PaymentMaster_ID,
                    SPPD_PaymentAmount: item.SPPD_PaymentAmount,
                    SPPD_PaymentItemType: item.SPPD_PaymentItemType,
                    SPPD_GstValue: item.SPPD_GstValue,
                    inputPaymentDueDate: this.adhocPaymentDueDate,
                    IH_Invoice_Name: this.receiptInvoiceName,
                    breakdownFlag: 'N',
                    AdhocReceipt: 'Yes',
                  }
                  adhocSPD_List.push(adhocSpdDetail)
                })

                //to generate invoice
                this.$vs.loading()
                const invoiceResponse = await DataSource.shared.generateInvoice(
                  JSON.stringify(adhocSPD_List),
                  this.studentID,
                  this.studentCourseID,
                  this.adhocPaymentDueDate,
                  this.inputRemarks,
                  'Generate',
                  '',
                  this.isRefundRebate,
                  '',
                )

                if (invoiceResponse.code === '88') {
                  window.location.replace('/')
                } else if (invoiceResponse.code === '99' || invoiceResponse.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Failed to generate invoice!',
                  })
                } else if (invoiceResponse.code === '4') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Total refund amount is highest than the item in the invoice!',
                  })
                } else {
                  this.$notify({
                    title: 'Success',
                    message: 'Adhoc Invoice generated successful!',
                    type: 'success',
                  })

                  //to get receipt detail
                  let ListToGetInvoiceName = []
                  SPD_List.forEach(m => {
                    m.IH_Invoice_Name = invoiceResponse.code

                    ListToGetInvoiceName.push(m)
                  })
                  const receiptResponse = await DataSource.shared.generateReceipt(JSON.stringify(SPD_List), this.studentID, this.studentCourseID, 'Generate')

                  if (receiptResponse.code === '88') {
                    window.location.replace('/')
                  } else if (receiptResponse.code === '99' || receiptResponse.code === '2') {
                    this.$notify.error({
                      title: 'Error',
                      message: 'Failed to generate receipt!',
                    })
                  } else {
                    this.displayPdf(receiptResponse.code)
                    await this.getStudentReceiptGenerationList()
                    await this.getPaymentList()
                    await this.getleftOverPaymentReceipt()
                    this.$refs.generateReceiptModal.hide()
                    this.ddlPaymentMode = ''
                    this.inputRemarks = ''
                    this.inputInternalReceiptRemarks = ''
                    this.inputChequeNoBankName = ''
                    this.requiredInvoice = false
                    this.inputReceiptDate = getCurrentDateTime()
                    this.clearSelect()
                  }
                }
              } else {
                //to get receipt detail
                this.$vs.loading()
                const receiptResponse = await DataSource.shared.generateReceipt(JSON.stringify(SPD_List), this.studentID, this.studentCourseID, 'Generate')

                if (receiptResponse.code === '88') {
                  window.location.replace('/')
                } else if (receiptResponse.code === '99' || receiptResponse.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Failed to generate receipt!',
                  })
                } else {
                  this.displayPdf(receiptResponse.code)
                  await this.clearSelect()
                  await this.getStudentReceiptGenerationList()
                  await this.getPaymentList()
                  await this.getleftOverPaymentReceipt()
                  this.$refs.generateReceiptModal.hide()
                  this.ddlPaymentMode = ''
                  this.inputRemarks = ''
                  this.inputInternalReceiptRemarks = ''
                  this.inputChequeNoBankName = ''
                  this.inputReceiptDate = getCurrentDateTime()
                }
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async previewLeftOverReceiptClick() {
      try {
        this.overPaymentFlag = 'Preview'
        if (!this.ddlPaymentMode) {
          alert('Please select payment mode.')
        } else {
          let SPD_List = []
          let countOverPaymentItems = 0
          let selectedItemCount = 0
          let countTotalPaidAmount = 0
          let countTotalNewPayAmount = 0
          this.spdSelection.forEach(item => {
            selectedItemCount++
            countTotalPaidAmount += parseFloat(item.totalValue)
            countTotalNewPayAmount += parseFloat(item.newPayAmount)
            let spdDetail = {
              paymentMode: this.ddlPaymentMode,
              remarks: this.inputRemarks,
              receiptDate: this.inputReceiptDate,
              RD_Cheque_No: this.inputChequeNoBankName,

              //left Over Payment
              RD_GST_Applicable: item.GST_Applicable,
              RD_Item_Description: item.Item_Description,
              PK_SPD_ID: item.SPD_ID,
              RD_GSTValue: item.gstValue,
              RD_Item_Amount: item.itemAmount,
              totalValue: item.totalValue,
              newAmount: item.newPayAmount,
              IH_Invoice_Name: this.receiptInvoiceName === '-' ? '' : this.receiptInvoiceName,
              internalRemarks: this.inputInternalReceiptRemarks,
            }
            //Todo: overpayment confirmation checking START
            if (parseFloat(item.totalValue) < parseFloat(item.newPayAmount)) {
              countOverPaymentItems++
            }
            //Todo: overpayment confirmation checking END
            SPD_List.push(spdDetail)
          })

          this.overPaymentSPDList = SPD_List
          countTotalPaidAmount = countTotalPaidAmount.toFixed(2)
          countTotalNewPayAmount = countTotalNewPayAmount.toFixed(2)

          if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else if (countTotalPaidAmount < countTotalNewPayAmount) {
            if (this.leftOverListCount === selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else if (this.leftOverListCount > selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            }
          } else {
            if (countOverPaymentItems > 0) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else {
              this.$vs.loading()
              //to preview receipt
              const receiptResp = await DataSource.shared.generateReceipt(
                JSON.stringify(SPD_List),
                this.studentID,
                this.studentCourseID,
                'Preview',
                this.showReceiptGstOptions && this.receiptGSTRate.replace('%', ''),
              )

              if (receiptResp.code === '88') {
                window.location.replace('/')
              } else if (receiptResp.code === '99' || receiptResp.code === '2') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Failed to preview receipt!',
                })
              } else if (receiptResp.code === '3') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Receipt/CN already generated!',
                })
                await this.getPaymentList()
              } else {
                this.displayPdf(receiptResp.code)
                // this.clearSelect();
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async generateLeftOverReceiptClick() {
      try {
        this.overPaymentFlag = 'Generate'
        if (!this.ddlPaymentMode) {
          alert('Please select payment mode.')
        } else {
          let SPD_List = []
          let countOverPaymentItems = 0
          let selectedItemCount = 0
          let countTotalPaidAmount = 0
          let countTotalNewPayAmount = 0
          this.spdSelection.forEach(item => {
            selectedItemCount++
            countTotalPaidAmount += parseFloat(item.totalValue)
            countTotalNewPayAmount += parseFloat(item.newPayAmount)
            let spdDetail = {
              paymentMode: this.ddlPaymentMode,
              remarks: this.inputRemarks,
              receiptDate: this.inputReceiptDate,
              RD_Cheque_No: this.inputChequeNoBankName,
              //left Over Payment
              RD_GST_Applicable: item.GST_Applicable,
              RD_Item_Description: item.Item_Description,
              PK_SPD_ID: item.SPD_ID,
              RD_GSTValue: item.gstValue,
              RD_Item_Amount: item.itemAmount,
              totalValue: item.totalValue,
              newAmount: item.newPayAmount,
              IH_Invoice_Name: this.receiptInvoiceName === '-' ? '' : this.receiptInvoiceName,
              internalRemarks: this.inputInternalReceiptRemarks,
            }
            //Todo: overpayment confirmation checking START
            if (parseFloat(item.totalValue) < parseFloat(item.newPayAmount)) {
              countOverPaymentItems++
            }
            //Todo: overpayment confirmation checking END
            SPD_List.push(spdDetail)
          })
          this.overPaymentSPDList = SPD_List
          countTotalPaidAmount = countTotalPaidAmount.toFixed(2)
          countTotalNewPayAmount = countTotalNewPayAmount.toFixed(2)

          if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else if (countTotalPaidAmount < countTotalNewPayAmount) {
            if (this.leftOverListCount === selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else if (this.leftOverListCount > selectedItemCount) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            }
          } else {
            //
            if (countOverPaymentItems > 0) {
              this.overPaymentItemsCount = countOverPaymentItems
              this.$refs.showOverPaymentConfirmationModal.show()
            } else {
              this.$vs.loading()
              //to get receipt detail
              const receiptResponse = await DataSource.shared.generateReceipt(
                JSON.stringify(SPD_List),
                this.studentID,
                this.studentCourseID,
                'Generate',
                this.showReceiptGstOptions && this.receiptGSTRate.replace('%', ''),
              )

              if (receiptResponse.code === '88') {
                window.location.replace('/')
              } else if (receiptResponse.code === '99' || receiptResponse.code === '2') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Failed to generate receipt!',
                })
              } else if (receiptResponse.code === '3') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Receipt/CN already generated!',
                })
                await this.getPaymentList()
              } else {
                this.displayPdf(receiptResponse.code)
                await this.getStudentReceiptGenerationList()
                await this.getPaymentList()
                await this.getleftOverPaymentReceipt()
                await this.clearSelect()
                this.$refs.showGenerateReceiptByHistoryModal.hide()
                this.ddlPaymentMode = ''
                this.inputRemarks = ''
                this.inputInternalReceiptRemarks = ''
                this.inputChequeNoBankName = ''
                this.inputReceiptDate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear()
              }
            }
            //
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    //todo: for CN generation
    async generateCNClick(isFullRefundCN) {
      try {
        var cnremark = document.getElementById('cnRemarks').value.replace(/^\s+|\s+$/g, '')
        if (this.taCnRemarks.length < 1 || cnremark === '') {
          alert('Remark required')
        } else {
          let SPD_List = []
          this.studentReceiptLeftOverPaymentListInt.forEach(item => {
            let spdDetail = {
              //left Over Payment
              ID_GST_Applicable: item.GST_Applicable,
              ID_Item_Description: item.Item_Description,
              SPD_ID: item.SPD_ID,
              ID_GSTValue: item.gstValue,
              ID_Item_Amount: item.itemAmount,
              InvHeaderID: this.InvHeaderID,
              IH_Invoice_Name: this.cnInvoiceName,
              studentCourseID: this.studentCourseID,
              studentID: this.studentID,
              cnRemarks: this.taCnRemarks,
              newAmount: item.newPayAmount,
              cnInternalRemarks: this.inputInternalCNRemarks,
            }
            SPD_List.push(spdDetail)
          })

          this.$vs.loading()
          const response = await DataSource.shared.generateCN(JSON.stringify(SPD_List), isFullRefundCN)

          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99' || response.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'Failed to generate credit note!',
            })
          } else if (response.code === '3') {
            this.$notify.error({
              title: 'Error',
              message: 'Receipt/CN already generated!',
            })
            await this.getPaymentList()
          } else if (response.code === '4') {
            this.$notify.error({
              title: 'Error',
              message: 'Cannot do FullCN as the receipt still active!',
            })
          } else {
            this.displayPdf(response.code)
            await this.getPaymentList()
            this.$refs.creditNoteModal.hide()
            this.$refs.viewTransactionShowModal.hide()
            this.taCnRemarks = ''
            this.cnInternalRemarks = ''
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    //todo - For invoice generation
    async getStudentInvoiceGenerationList() {
      this.$vs.loading()
      try {
        this.studentCourseID = this.$route.query.scid
        this.studentID = this.$route.query.sid

        const resp = await DataSource.shared.getActivePaymentNoTransactionHistoryList(this.studentCourseID, 'invoice')

        if (resp) {
          switch (resp.code) {
            case '2':
              this.$notify.error({
                title: 'No Record Found',
                message: 'No Student Payment Record',
              })
              break
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              this.respTempInvoice = resp.Table
              this.respTempInvoice.forEach(m => {
                //todo isRefundRebate
                if (m.isRebate === 'Y') {
                  this.customizeRefundRebateResponse.push(m)
                  this.isRebateRefundEligible = true
                } else {
                  if (m.RecTotal == null) {
                    m.RecTotal = 0
                  } else {
                    m.RecTotal = m.SPPD_TotalValue
                  }
                  //InvoiceOverPaymentItemInt
                  if (m.SPPD_IsAutoOverpay == 'Y') {
                    this.invoiceOverPaymentResponse.push(m)
                  } else {
                    m.IsCheck = false
                    this.$set(m, 'newGSTAmount', m.SPPD_GstValue)
                    this.$set(m, 'newAmount', m.SPPD_PaymentAmount)
                    this.customizeInvoiceResponse.push(m)
                  }
                }
              })
              this.studentInvoiceGenerationListInt = this.customizeInvoiceResponse
              this.studentRefundRebateListInt = this.customizeRefundRebateResponse
              this.InvoiceOverPaymentItemInt = this.invoiceOverPaymentResponse
              this.customizeInvoiceResponse = []
              this.customizeRefundRebateResponse = []
              this.invoiceOverPaymentResponse = []
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    checkPaymentBreakdownEligible() {
      if (this.cbPrintMonthlyBreakdown) {
        let breakdownCounter = 0
        this.spdSelection.forEach(m => {
          if (m.PPD_CalCategory === 'Course Fees') {
            breakdownCounter++
          }
        })

        if (breakdownCounter === 0) {
          this.cbPrintMonthlyBreakdown = true
          this.breakdownFlag = 'N'
          this.$notify.error({
            title: 'Message',
            message: 'Please select at least 1 course fees item!',
          })
        } else {
          this.breakdownFlag = 'Y'
        }
      }
      return this.breakdownFlag
    },

    //todo check Rebate Refund Eligible
    checkRebateEligible(type, value) {
      try {
        if (this.isRebateRefundEligible) {
          if (this.spdRebateSelection.length < 1) {
            this.$confirm('There are rebate/refund items which not yet utilize. Continue?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
              center: true,
            })
              .then(() => {
                // this.$message({
                //     type: 'OK',
                //     message: 'OKOK'
                // });
                if (type === 'previewInv') {
                  this.previewInvoiceClick(value)
                } else if (type === 'generateInv') {
                  this.generateInvoiceClick(value)
                }
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Canceled',
                })
              })
          } else {
            this.$confirm('Rebate/refund items selected. Continue?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
              center: true,
            })
              .then(() => {
                // this.$message({
                //     type: 'OK',
                //     message: 'OKOK'
                // });
                if (type === 'previewInv') {
                  this.previewInvoiceClick(value)
                } else if (type === 'generateInv') {
                  this.generateInvoiceClick(value)
                }
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Canceled',
                })
              })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    //todo check Rebate Refund Eligible
    async invoiceClickController(type, value) {
      if (this.isRebateRefundEligible) {
        this.checkRebateEligible(type, value)
      } else {
        if (type === 'previewInv') {
          this.previewInvoiceClick(value)
        } else if (type === 'generateInv') {
          this.generateInvoiceClick(value)
        }
      }
    },

    async previewInvoiceClick(value) {
      try {
        //todo gather Rebate Refund detail, if eligible set isRefundRebateFlag to Y else N
        let Rebate_List = []
        if (this.spdRebateSelection.length > 0) {
          this.isRefundRebate = 'Y'
          this.spdRebateSelection.forEach(n => {
            let RebateDetail = {
              PK_Invoice_ID: n.PK_Invoice_ID,
              SPPD_PaymentAmount: n.SPPD_PaymentAmount,
              SPPD_GstValue: n.SPPD_GstValue,
              PK_Invoice_Detail_ID: n.PK_Invoice_Detail_ID,
              PK_SPD_ID: n.PK_SPD_ID,
              SPPD_PayerName: n.SPPD_PayerName,
              SPPD_PaymentItemType: n.SPPD_PaymentItemType,
              SPPD_TotalValue: n.SPPD_TotalValue,
              invoiceRefundNo: n.invoiceRefundNo,
              isRebate: 'Y',
            }
            Rebate_List.push(RebateDetail)
          })
        } else {
          this.isRefundRebate = 'N'
        }
        //todo gather Rebate Refund detail

        let SPD_List = []
        let InvoiceType = ''
        let gstRate = this.gstRate

        if (value == 'reinvoice') {
          InvoiceType = 'PreviewReInvoice'
          gstRate = this.reInvoiceGSTRate.replace('%', '')
          this.spdSelection.forEach(item => {
            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              SPPD_Status: item.SPPD_Status,
              SPPD_PayerName: item.SPPD_PayerName,
              SPPD_FK_Payment_Plan_Detail_ID: item.SPPD_FK_Payment_Plan_Detail_ID,
              SPPD_FK_PaymentMaster_ID: item.SPPD_FK_PaymentMaster_ID,
              SPPD_PaymentItemType: item.SPPD_PaymentItemType,
              SPPD_GstValue: item.SPPD_GstValueEdited,
              // SPPD_GstValue: item.SPPD_GstValue,
              SPPD_PaymentAmount: item.SPPD_PaymentAmount,
              // SPPD_NewPaymentAmount: item.newPayAmount,
              inputPaymentDueDate: this.inputPaymentDueDate,
              printBreakdownChecked: this.cbPrintMonthlyBreakdown,
              breakdownFlag: this.breakdownFlag,
              AdhocReceipt: 'No',
              SPPD_TotalValue: item.SPPD_TotalValue,
            }
            SPD_List.push(spdDetail)
            this.reInvoiceName = item.invoiceName
          })
        } else {
          //check breakdown
          if (this.cbPrintMonthlyBreakdown) {
            var breakdownflag = await this.checkPaymentBreakdownEligible()

            if (breakdownflag == 'N') {
              this.breakdownFlag = 'N'
              return
            } else {
              this.breakdownFlag = 'Y'
            }
          } else {
            this.breakdownFlag = 'N'
          }
          //check breakdown

          InvoiceType = 'Preview'
          // let countSiblingKeyWord = 0;
          this.siblingItemsCount = 0
          this.spdSelection.forEach(item => {
            if (item.SPPD_PayerName.toLowerCase().includes('sibling')) {
              // countSiblingKeyWord++;
              this.siblingItemsCount++
            }

            // if(item.SPPD_PayerName.toUpperCase().includes('SIBLING')){
            //     countSiblingKeyWord++;
            // }
            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              SPPD_Status: item.SPPD_Status,
              SPPD_PayerName: item.SPPD_PayerName,
              SPPD_FK_Payment_Plan_Detail_ID: item.SPPD_FK_Payment_Plan_Detail_ID,
              SPPD_FK_PaymentMaster_ID: item.SPPD_FK_PaymentMaster_ID,
              SPPD_PaymentAmount: item.newAmount,
              SPPD_PaymentItemType: item.SPPD_PaymentItemType,
              SPPD_GstValue: item.newGSTAmount,

              inputPaymentDueDate: this.inputPaymentDueDate,
              printBreakdownChecked: this.cbPrintMonthlyBreakdown,
              breakdownFlag: this.breakdownFlag,
              AdhocReceipt: 'No',
              SPPD_TotalValue: item.SPPD_TotalValue,
            }
            SPD_List.push(spdDetail)
          })
        }

        this.siblingSPDList = SPD_List
        this.siblingInvoiceType = InvoiceType

        //to prompt item closed
        var bool = false
        var payerName = ''
        SPD_List.forEach(m => {
          if (m.SPPD_Status === 'Closed') {
            bool = true
            payerName += m.SPPD_PayerName
            payerName += ', '
          }
        })
        payerName = payerName.substring(0, payerName.length - 2)

        if (bool) {
          this.$notify.error({
            title: 'Error',
            message: payerName + ' is closed, invoice cannot be preview!',
          })
        } else {
          if (this.inputPaymentDueDate === '') {
            this.$notify.error({
              title: 'Error',
              message: 'Please select payment due date',
            })
          } else if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else {
            //todo: blocked negative amount
            var countTotalAmount = 0
            SPD_List.forEach(m => {
              countTotalAmount += parseFloat(m.SPPD_TotalValue)
            })
            //todo Rebate refund add On
            var countTotalRebateAmount = 0
            Rebate_List.forEach(n => {
              countTotalRebateAmount += parseFloat(n.SPPD_TotalValue)
            })

            //todo: blocked negative amount

            if (parseFloat(countTotalAmount.toFixed(2) < 0 || parseFloat(countTotalAmount.toFixed(2)) - parseFloat(countTotalRebateAmount)) < 0) {
              this.$notify.error({
                title: 'Error',
                message: 'Cannot preview invoice due negative $ amount.',
              })
            } else {
              if (this.siblingItemsCount > 0) {
                this.$refs.showSiblingConfirmationModal.show()
              } else {
                this.$vs.loading()
                //to preview invoice
                const invoiceResponse = await DataSource.shared.generateInvoice(
                  JSON.stringify(SPD_List),
                  this.studentID,
                  this.studentCourseID,
                  this.inputPaymentDueDate,
                  this.inputRemarks,
                  InvoiceType,
                  this.reInvoiceName,
                  this.isRefundRebate,
                  JSON.stringify(Rebate_List),
                  gstRate,
                )

                if (invoiceResponse.code === '88') {
                  window.location.replace('/')
                } else if (invoiceResponse.code === '99' || invoiceResponse.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Failed to preview invoice!',
                  })
                } else if (invoiceResponse.code === '4') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Total refund amount is highest than the item in the invoice!',
                  })
                } else if (invoiceResponse.code === '5') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Cannot preview invoice due negative $ amount',
                  })
                } else {
                  this.displayPdf(invoiceResponse.code)
                  // await this.clearSelect();
                }
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async generateInvoiceClick(value) {
      console.log(this.inputStudentNO)
      try {
        //todo gather Rebate Refund detail, if eligible set isRefundRebateFlag to Y else N
        let Rebate_List = []
        if (this.spdRebateSelection.length > 0) {
          this.isRefundRebate = 'Y'
          this.spdRebateSelection.forEach(n => {
            let RebateDetail = {
              PK_Invoice_ID: n.PK_Invoice_ID,
              SPPD_PaymentAmount: n.SPPD_PaymentAmount,
              SPPD_GstValue: n.SPPD_GstValue,
              PK_Invoice_Detail_ID: n.PK_Invoice_Detail_ID,
              PK_SPD_ID: n.PK_SPD_ID,
              SPPD_PayerName: n.SPPD_PayerName,
              SPPD_PaymentItemType: n.SPPD_PaymentItemType,
              SPPD_TotalValue: n.SPPD_TotalValue,
              invoiceRefundNo: n.invoiceRefundNo,
              isRebate: 'Y',
            }
            Rebate_List.push(RebateDetail)
          })
        } else {
          this.isRefundRebate = 'N'
        }
        //todo gather Rebate Refund detail

        let SPD_List = []
        let InvoiceType = ''
        let gstRate = this.gstRate
        if (value == 'reinvoice') {
          InvoiceType = value
          gstRate = this.reInvoiceGSTRate.replace('%', '')
          this.spdSelection.forEach(item => {
            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              SPPD_Status: item.SPPD_Status,
              SPPD_PayerName: item.SPPD_PayerName,
              SPPD_FK_Payment_Plan_Detail_ID: item.SPPD_FK_Payment_Plan_Detail_ID,
              SPPD_FK_PaymentMaster_ID: item.SPPD_FK_PaymentMaster_ID,
              SPPD_PaymentItemType: item.SPPD_PaymentItemType,
              SPPD_GstValue: item.SPPD_GstValueEdited,
              SPPD_PaymentAmount: item.SPPD_PaymentAmount,
              printBreakdownChecked: this.cbPrintMonthlyBreakdown,
              inputPaymentDueDate: this.inputPaymentDueDate,
              // SPPD_NewPaymentAmount: item.newPayAmount,
              breakdownFlag: this.breakdownFlag,
              AdhocReceipt: 'No',
              SPPD_TotalValue: item.SPPD_TotalValue,
            }
            SPD_List.push(spdDetail)
            this.reInvoiceName = item.invoiceName
          })
        } else {
          //check breakdown
          if (this.cbPrintMonthlyBreakdown) {
            var breakdownflag = await this.checkPaymentBreakdownEligible()

            if (breakdownflag == 'N') {
              this.breakdownFlag = 'N'
              return
            } else {
              this.breakdownFlag = 'Y'
            }
          } else {
            this.breakdownFlag = 'N'
          }
          //check breakdown

          InvoiceType = 'Generate'
          this.siblingItemsCount = 0

          this.spdSelection.forEach(item => {
            if (item.SPPD_PayerName.toLowerCase().includes('sibling')) {
              // countSiblingKeyWord++;
              this.siblingItemsCount++
            }

            let spdDetail = {
              PK_SPD_ID: item.PK_SPD_ID,
              SPPD_Status: item.SPPD_Status,
              SPPD_PayerName: item.SPPD_PayerName,
              SPPD_FK_Payment_Plan_Detail_ID: item.SPPD_FK_Payment_Plan_Detail_ID,
              SPPD_FK_PaymentMaster_ID: item.SPPD_FK_PaymentMaster_ID,
              SPPD_PaymentAmount: item.newAmount,
              SPPD_PaymentItemType: item.SPPD_PaymentItemType,
              SPPD_GstValue: item.newGSTAmount,
              inputPaymentDueDate: this.inputPaymentDueDate,
              printBreakdownChecked: this.cbPrintMonthlyBreakdown,
              breakdownFlag: this.breakdownFlag,
              AdhocReceipt: 'No',
              SPPD_TotalValue: item.SPPD_TotalValue,
            }
            SPD_List.push(spdDetail)
          })
        }

        this.siblingSPDList = SPD_List
        this.siblingInvoiceType = InvoiceType

        //to prompt item closed
        var bool = false
        var payerName = ''
        SPD_List.forEach(m => {
          if (m.SPPD_Status === 'Closed') {
            bool = true
            payerName += m.SPPD_PayerName
            payerName += ', '
          }
        })
        payerName = payerName.substring(0, payerName.length - 2)

        if (bool) {
          this.$notify.error({
            title: 'Error',
            message: payerName + ' is closed, invoice cannot be generated!',
          })
        } else {
          if (this.inputPaymentDueDate === '') {
            this.$notify.error({
              title: 'Error',
              message: 'Please select payment due date',
            })
          } else if (this.spdSelection.length === 0) {
            this.$notify.error({
              title: 'Error',
              message: 'Please select at least 1 payment item',
            })
          } else if (this.studentDetail !== undefined && (this.inputStudentNO === '' || this.inputStudentNO === '-' || this.inputStudentNO === undefined)) {
            console.log(this.studentID)
            this.$notify.error({
              title: 'Error',
              message: 'Student No is empty',
            })
          } else {
            var countTotalAmount = 0
            if (value === 'reinvoice') {
              // SPD_List.forEach(m => {
              //     if (m.SPPD_NewPaymentAmount > 0) {
              //         amountPositiveCount += 1;
              //     }
              // });
              SPD_List.forEach(m => {
                countTotalAmount += parseFloat(m.SPPD_NewPaymentAmount)
              })
            } else {
              // SPD_List.forEach(m => {
              //     if (m.SPPD_PaymentAmount > 0) {
              //         amountPositiveCount += 1;
              //     }
              // });

              //todo: blocked negative amount
              SPD_List.forEach(m => {
                countTotalAmount += parseFloat(m.SPPD_TotalValue)
              })
              //todo Rebate refund add On
              var countTotalRebateAmount = 0
              Rebate_List.forEach(n => {
                countTotalRebateAmount += parseFloat(n.SPPD_TotalValue)
              })

              //todo: blocked negative amount
            }

            if (parseFloat(countTotalAmount).toFixed(2) < 0 || parseFloat(countTotalAmount.toFixed(2)) - parseFloat(countTotalRebateAmount) < 0) {
              this.$notify.error({
                title: 'Error',
                message: 'Cannot generate invoice due negative $ amount. Please try again.',
              })
            } else {
              if (this.siblingItemsCount > 0) {
                this.$refs.showSiblingConfirmationModal.show()

                // || (this.siblingItemsCount === 0)
                // if ((this.siblingConfirmationFlag && this.siblingItemsCount > 0)) {
                // }
              } else {
                //to generate invoice
                this.$vs.loading()
                const invoiceResponse = await DataSource.shared.generateInvoice(
                  JSON.stringify(SPD_List),
                  this.studentID,
                  this.studentCourseID,
                  this.inputPaymentDueDate,
                  this.inputRemarks,
                  InvoiceType,
                  this.reInvoiceName,
                  this.isRefundRebate,
                  JSON.stringify(Rebate_List),
                  gstRate,
                )

                if (invoiceResponse.code === '88') {
                  window.location.replace('/')
                } else if (invoiceResponse.code === '99' || invoiceResponse.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Failed to generate invoice!',
                  })
                } else if (invoiceResponse.code === '4') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Total refund amount is highest than the item in the invoice!',
                  })
                } else if (invoiceResponse.code === '5') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Cannot generate invoice due negative $ amount',
                  })
                } else {
                  this.displayPdf(invoiceResponse.code)
                  await this.getPaymentList()
                  await this.getStudentInvoiceGenerationList()
                  this.$refs.generateInvoiceModal.hide()
                  this.$refs.showReInvoiceModal.hide()
                  await this.clearSelect()
                  this.cbPrintMonthlyBreakdown = false
                  this.$refs.showReInvoiceModal.hide()
                }
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    validatePaymentMode() {
      if (this.ddlPaymentMode == 'CASH') {
        this.inputChequeNoBankName = ''
      }
    },

    async getleftOverPaymentReceipt(objValue) {
      try {
        let obj_List = []
        if (objValue.recNameList) {
          this.tempList = objValue.recNameList.split(',')
          this.tempList.forEach(m => {
            let objDetail = {
              receiptName: m,
            }
            obj_List.push(objDetail)
          })
        } else {
          let objDetail = {
            receiptName: '',
          }
          obj_List.push(objDetail)
        }

        const resp = await DataSource.shared.getLeftOverPaymentReceipt(
          JSON.stringify(obj_List),
          this.studentID,
          objValue.IH_Invoice_Name == '-' ? '' : objValue.IH_Invoice_Name,
          this.studentCourseID,
          this.leftOverActionFlag,
        )

        if (resp) {
          switch (resp.code) {
            // case "2":
            //     console.log('no record found');
            //     break;
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              var countTotal = 0
              this.leftOverTemp = resp.Table
              this.leftOverListCount = resp.Table.length

              this.leftOverTemp.forEach(m => {
                m.newPayAmount = m.totalValue
                countTotal += parseFloat(m.totalValue)
                this.leftOverTempResp.push(m)
              })
              countTotal = countTotal.toFixed(2)
              this.countLeftOverTotalAmount = countTotal
              let zeroGST = this.leftOverTempResp?.find(d => d.gstValue === 0)
              this.showReceiptGstOptions = !!zeroGST
              this.studentReceiptLeftOverPaymentListInt = this.leftOverTempResp
              this.leftOverTempResp = []
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    // todo: CALL b-modal link only
    async showTransaction(value) {
      this.showTransactionObj = value
      // await this.checkIsCorporateFinance();
      await this.getReceiptWithTransactionHistory(value)
      this.$refs.viewTransactionShowModal.show()
    },

    //todo isAllowRebateTagFlag 4th June 2020
    async getStudentSchoolFeeRebate(checkRebateExist, rebateDesc) {
      try {
        const resp = await DataSource.shared.getStudentSchoolFeeRebate(this.studentID, checkRebateExist, rebateDesc)

        if (resp) {
          if (resp.code === '2') {
            console.log('2')
            this.isAllowRebateTagFlag = false
          } else if (resp.code === '99') {
            console.log('99')
            this.isAllowRebateTagFlag = false
          } else {
            this.studentRebateTagListInt = resp.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async tagRebateSchoolFeesToInvoice(RebatePKInvoiceID) {
      try {
        this.currentRebateTagInvoiceID = ''
        let currentTagInvoiceID = []
        this.studentReceiptGenerationByTransactionHistoryListInt.forEach(n => {
          if (n.allowRebateTagFlag === 'Y' && n.DocumentType === 'Invoice') {
            currentTagInvoiceID.push(n.InvRecID)
            this.currentRebateTagInvoiceID = currentTagInvoiceID
          }
        })
        const resp = await DataSource.shared.tagRebateSchoolFeesToInvoice(this.currentRebateTagInvoiceID[0], RebatePKInvoiceID)

        if (resp) {
          if (resp.code === '2') {
            this.$notify.error({
              title: 'Error2',
              message: 'Error2',
            })
          } else if (resp.code === '99') {
            this.$notify.error({
              title: 'Error99',
              message: 'Error99',
            })
          } else if (resp.code === '3') {
            this.$notify.error({
              title: 'Error3',
              message: 'Rebate amount is more than invoice item amount',
            })
          } else {
            this.$notify.success({
              title: 'success',
              message: 'success',
            })
            //this.isAllowRebateTagFlag = false;
            await this.getReceiptWithTransactionHistory(this.showTransactionObj)
            await this.getPaymentList()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async tagRebateController(value, RebatePKInvoiceID) {
      let msg = 'You are going to tag ' + value + '. Continue?'
      this.$confirm(msg, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.tagRebateSchoolFeesToInvoice(RebatePKInvoiceID)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled',
          })
        })
    },
    //todo isAllowRebateTagFlag

    async showRefund(value) {
      this.spdSelection = []
      this.schoolFeesRebateOptions = []
      this.isSchoolFeeRebateDisabled = false
      await this.hideMiddletonRebateDropdown()
      await this.checkIsIntlSchool()
      await this.getRefund(value)
      this.$refs.viewRefundModal.show()
    },

    async getRefund(objValue) {
      try {
        //get refund invoice name
        this.refundInvoiceName = objValue.IH_Invoice_Name
        //
        let obj_List = []

        if (objValue.recNameList) {
          //assign '-' to ''
          let emptyInvoiceValue = ''
          if (this.refundInvoiceName == '-') {
            emptyInvoiceValue = ''
          } else {
            emptyInvoiceValue = this.refundInvoiceName
          }
          //assign '-' to ''
          this.tempRefundList = objValue.recNameList.split(',')
          this.tempRefundList.forEach(m => {
            let objDetail = {
              receiptName: m,
              invoiceName: emptyInvoiceValue,
            }
            obj_List.push(objDetail)
          })
        } else {
          let objDetail = {
            receiptName: '',
            invoiceName: '',
          }
          obj_List.push(objDetail)
        }

        const resp = await DataSource.shared.getItemTotalReceipt(JSON.stringify(obj_List))

        if (resp) {
          switch (resp.code) {
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              this.tempRefundResp = resp.Table

              let SPList = []
              let schoolFeesItemCount = 0
              this.tempRefundResp.forEach(m => {
                //todo check whhether got school items or not(For rebate)
                if (m.RD_Item_Description.includes('School Fee')) {
                  schoolFeesItemCount++
                }
                //    console.log('schoolFeesItemCount',schoolFeesItemCount);
                //todo check whhether got school items or not

                let spdDetail = {
                  FK_RD_SPD_ID: m.FK_RD_SPD_ID,
                  RD_GST_Applicable: m.RD_GST_Applicable,
                  RD_Item_Description: m.RD_Item_Description,
                  newRefundAmount: m.totalAmount,
                  totalAmount: m.totalAmount,
                  itemAmount: m.itemAmount,
                  gstValue: m.gstValue,
                  IH_Currency: m.RH_Receipt_Currency,
                }
                SPList.push(spdDetail)
              })
              this.isSchoolFeesItemCount = schoolFeesItemCount
              SPList.map(d => (d.gstValueEdited = d.gstValue))
              this.refundListInt = SPList
              this.handleRefundGSTChange()
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async refundClickController(refundType) {
      if (this.SchoolFeeRebateValue) {
        //todo pop up dialog box
        this.$confirm('You selected School Fees Rebate. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        })
          .then(() => {
            const resp = DataSource.shared.getStudentSchoolFeeRebate(this.studentID, 'Y', this.SchoolFeeRebateValue)

            resp.then(resp => {
              if (resp) {
                if (resp.code == '99') {
                  console.log('99')
                } else if (resp.code == '88') {
                  console.log('88')
                } else if (resp.code == '2') {
                  this.onchangeRebateSelection()
                  if (this.schoolRebateFlag === true) {
                    this.generateRefundClick(refundType)
                  } else {
                    this.onchangeRebateSelection()
                  }
                } else {
                  this.$notify.error({
                    title: 'Error',
                    message: 'You already has this rebate before! ',
                  })
                }
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Canceled',
            })
          })
      } else {
        await this.generateRefundClick(refundType)
      }
    },

    async generateRefundClick(refundType) {
      try {
        //    console.log(this.spdSelection.length,this.SchoolFeeRebateValue,this.SchoolFeeRebateValue.includes("School fee"));
        if (this.spdSelection.length === 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 refund item',
          })
        } else if (!this.inputRefundRemarks && !this.isSchoolFeeRebateDisabled) {
          this.$notify.error({
            title: 'Error',
            message: 'Please input parent remark!',
          })
        } else {
          this.$vs.loading()
          let refundInvName = ''

          if (this.refundInvoiceName === '-') {
            refundInvName = ''
          } else {
            refundInvName = this.refundInvoiceName
          }

          let Obj_List = []
          this.spdSelection.forEach(m => {
            let refundItemDesc = ''
            if (this.selectedRebateDesc) {
              refundItemDesc = this.selectedRebateDesc
            } else {
              refundItemDesc = m.RD_Item_Description
            }

            let spdDetail = {
              IH_Invoice_Name: refundInvName,
              studentID: this.studentID,
              SPD_ID: m.FK_RD_SPD_ID,
              refundAmount: m.newRefundAmount,
              totalAmount: m.totalAmount,
              itemAmount: m.itemAmount,
              gstAmount: m.gstValueEdited,
              //refundDate:m.refundDate,
              // refundDate:"06/08/2019",
              refundRemarks: this.inputRefundRemarks,
              refundInternalRemarks: this.inputInternalRefundRemarks,
              ID_Item_Description: refundItemDesc,
              ID_GST_Applicable: m.RD_GST_Applicable,
              RH_Receipt_Currency: m.RH_Receipt_Currency,
            }

            Obj_List.push(spdDetail)
          })
          const resp = await DataSource.shared.generateRefund(JSON.stringify(Obj_List), refundType, this.refundGstRate.replace('%', ''))
          // const resp = '';
          if (resp) {
            switch (resp.code) {
              case '3':
                this.$notify.error({
                  title: 'Error',
                  message: 'Refund amount is higher than the actual item remaining amount!',
                  type: 'Error',
                })
                break
              case '88':
                this.$router.push('/')
                break
              case '99':
                this.$notify.error({
                  title: 'Error',
                  message: 'Failed to refund',
                })
                break

              default:
                if (refundType === 'preview') {
                  this.displayPdf(resp.code)
                } else {
                  this.inputRefundRemarks = ''
                  this.inputInternalRefundRemarks = ''
                  this.SchoolFeeRebateValue = ''
                  this.selectedRebateDesc = ''
                  await this.getPaymentList()
                  this.$notify({
                    title: 'Success',
                    message: 'Refund Success!',
                    type: 'success',
                  })
                  this.$refs.viewRefundModal.hide()
                  this.spdSelection = []
                  this.schoolFeesRebateOptions = []
                }

                break
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async getTransactionDocumentPdf(objValue) {
      try {
        const resp = await DataSource.shared.getTransactionDocumentPdf(objValue.DocumentType, objValue.InvRecID)

        if (resp.code === '88') {
          window.location.replace('/')
        } else if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Failed to preview!',
          })
        } else {
          this.displayPdf(resp.code, objValue.DocumentNo)
          this.clearSelect()
        }
      } catch (e) {
        this.results = e
      }
    },

    async getReceiptWithTransactionHistory(objValue) {
      try {
        this.$vs.loading()

        let obj_List = []
        if (objValue.recNameList) {
          this.tempList = objValue.recNameList.split(',')
          this.tempList.forEach(m => {
            let objDetail = {
              receiptName: m,
            }
            obj_List.push(objDetail)
          })
        } else {
          let objDetail = {
            receiptName: '',
          }
          obj_List.push(objDetail)
        }

        let invoiceName = objValue.IH_Invoice_Name
        //For credit note
        this.cnInvoiceName = objValue.IH_Invoice_Name
        this.receiptInvoiceName = objValue.IH_Invoice_Name

        const resp = await DataSource.shared.getReceiptWithTransactionHistory(JSON.stringify(obj_List), this.studentID, invoiceName)

        if (resp) {
          switch (resp.code) {
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              if (this.leftOverActionFlag === 'cn') {
                //todo for future multiple FullRefundCN items
                let countFullRefundCNitems = 0
                //todo for future multiple FullRefundCN items
                resp.Table.forEach(m => {
                  if (m.IH_IsRebate === 'Y' && m.IH_IsRebateUtilized === 'Y') {
                    countFullRefundCNitems++
                  }
                })
                if (countFullRefundCNitems > 0) {
                  this.isEligibleForFullRefundCN = true
                } else {
                  this.isEligibleForFullRefundCN = false
                }
              }

              resp.Table?.forEach(d => {
                d.TotalIncGst = Number(d.TotalIncGst).toFixed(2)
              })

              this.studentReceiptGenerationByTransactionHistoryListInt = resp.Table
              this.invoiceTimestamp = resp.Table[0].InvRecDate

              //todo to check whether getTransaction history flag(3rd June 2020)
              resp.Table.forEach(n => {
                if (n.allowRebateTagFlag === 'Y' && this.isCorporateFinance === true) {
                  this.isAllowRebateTagFlag = true
                } else {
                  this.isAllowRebateTagFlag = false
                }
              })

              if (this.isAllowRebateTagFlag === true) {
                await this.getStudentSchoolFeeRebate('N', '')
              }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async getReInvoice(objValue) {
      try {
        this.studentCourseID = this.$route.query.scid //
        this.studentID = this.$route.query.sid

        if (objValue.IH_Invoice_Name) {
          const resp = await DataSource.shared.getReInvoice(this.studentID, this.studentCourseID, objValue.IH_Invoice_Name)
          if (resp) {
            switch (resp.code) {
              case '88':
                this.$router.push('/')
                break
              case '99':
                this.$notify.error({
                  title: 'Error',
                  message: 'Error',
                })
                break

              default:
                this.tempReInvoiceResp = resp.Table
                this.tempReInvoiceResp.forEach(m => {
                  m.newPayAmount = m.SPPD_TotalValue
                  if (m.isRebate === 'Y') {
                    this.isRebateReInvoiceResponce.push(m)
                    this.isRebateRefundEligible = true
                  } else {
                    this.customizeReInvoiceResponce.push(m)
                    this.isRebateRefundEligible = false
                  }
                })
                this.customizeReInvoiceResponce.map(d => (d.SPPD_GstValueEdited = d.SPPD_GstValue))
                this.ReInvoiceListInt = this.customizeReInvoiceResponce
                this.isRebateReInvoiceListInt = this.isRebateReInvoiceResponce
                this.customizeReInvoiceResponce = []
                this.isRebateReInvoiceResponce = []
                this.handleReInvoiceGSTChange()
            }
          }
        } else {
          const resp = await DataSource.shared.getReInvoice(this.studentID, this.studentCourseID, this.Re_InvoiceName)
          if (resp) {
            switch (resp.code) {
              case '88':
                this.$router.push('/')
                break
              case '99':
                this.$notify.error({
                  title: 'Error',
                  message: 'Error',
                })
                break

              default:
                this.tempReInvoiceResp = resp.Table
                this.tempReInvoiceResp.forEach(m => {
                  m.newPayAmount = m.SPPD_TotalValue
                  if (m.isRebate === 'Y') {
                    this.isRebateReInvoiceResponce.push(m)
                    this.isRebateRefundEligible = true
                  } else {
                    this.customizeReInvoiceResponce.push(m)
                    this.isRebateRefundEligible = false
                  }
                })
                this.ReInvoiceListInt = this.customizeReInvoiceResponce
                this.isRebateReInvoiceListInt = this.isRebateReInvoiceResponce
                this.customizeReInvoiceResponce = []
                this.isRebateReInvoiceResponce = []
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async showGenerateReceiptByHistory(value) {
      try {
        this.leftOverActionFlag = 'receipt'
        await this.getReceiptWithTransactionHistory(value)
        await this.getleftOverPaymentReceipt(value)
        await this.clearSelect()
        this.spdSelection = []
        this.selectedleftOverReceiptTotal = ''
        this.$refs.showGenerateReceiptByHistoryModal.show()
      } catch (e) {
        this.results = e
      }
    },

    async showGenerateCreditNote(value) {
      this.spdSelection = []
      this.leftOverActionFlag = 'cn'
      await this.getReceiptWithTransactionHistory(value)
      await this.getleftOverPaymentReceipt(value)
      //this.$refs.ReceiptGenerationByTransactionHistoryTable.toggleRowSelection(this.studentReceiptLeftOverPaymentListInt[0]);
      this.$refs.creditNoteModal.show()
    },

    async showReInvoice(value) {
      await this.getReInvoice(value)
      this.Re_InvoiceName = value.IH_Invoice_Name
      this.spdRebateSelection = []
      this.spdSelection = []
      this.$refs.showReInvoiceModal.show()
    },

    // todo: generate receipt
    async showGenerateReceipt() {
      try {
        await this.getStudentReceiptGenerationList()
        this.spdSelection = []
        this.$refs.generateReceiptModal.show()
        await this.clearSelect()
      } catch (e) {
        this.results = e
      }
    },

    //todo: call preview/generate invoice b-modal
    async showGenerateInvoice() {
      try {
        await this.getStudentInvoiceGenerationList()
        this.spdSelection = []
        this.spdRebateSelection = []
        this.$refs.generateInvoiceModal.show()
        $(function () {
          $('.disabledKeyboardInput').on('keydown', function (e) {
            e.preventDefault()
          })
        })
        await this.clearSelect()
      } catch (e) {
        this.results = e
      }
    },

    showPaymentReminder(reminderValue, invoiceValue, InvRecDate) {
      this.getReminderEmail(reminderValue, invoiceValue)
      this.showReminderSendButton = this.checkBefore27thJulyDate(InvRecDate)
      //console.log(this.showReminderSendButton,InvRecDate);
      this.$refs.showPaymentReminderModal.show()
    },

    async getReminderEmail(reminderValue, invoiceValue) {
      try {
        this.lblPaymentReminder = reminderValue
        let noOfReminder = ''
        if (reminderValue == '1st') {
          noOfReminder = 1
        } else if (reminderValue == '2nd') {
          noOfReminder = 2
        } else if (reminderValue == '3rd') {
          noOfReminder = 3
        }
        //pass invoice number value for email "sendEmailReminderClick"
        this.invoiceNoForEmailReminder = invoiceValue
        //End:pass invoice number value for email "sendEmailReminderClick"
        const resp = await DataSource.shared.getReminderEmail(noOfReminder, invoiceValue, this.studentCourseID, this.studentID)
        if (resp) {
          switch (resp.code) {
            case '2':
              console.log('no record found')
              break
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              this.emailReminderList = resp.Table

              this.emailReminderList.forEach(m => {
                this.inputEmailTo = m.toEmail
                this.inputEmailSubject = m.emailSubject
                this.reminderInvDueDate = m.invoiceDueDate
                this.inputEmailMessage = m.emailMessage.replace('<invoiceDueDate>', this.reminderInvDueDate)
                this.inputInvoiceReminderDueDate = this.reminderInvDueDate
              })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async sendEmailReminderClick() {
      try {
        if (this.lblPaymentReminder == '1st') {
          //first reminder need date pop up as they can change the date
          if (this.inputInvoiceReminderDueDate) {
            // popup confirmation
            this.$confirm('Reminder due date will be ' + this.inputInvoiceReminderDueDate + '. Please click OK to continue.', 'Message', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
            }).then(async () => {
              const resp = await DataSource.shared.sendReminderEmail(
                this.inputEmailTo,
                this.inputEmailSubject,
                encodeURI(JSON.stringify(this.inputEmailMessage)),
                this.invoiceNoForEmailReminder,
              )

              switch (resp.code) {
                case '2':
                  this.$notify.error({
                    title: 'Error',
                    message: 'Send email error, please contact administrator',
                  })
                  break
                case '88':
                  this.$router.push('/')
                  break
                case '99':
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error',
                  })
                  break

                default:
                  this.$notify({
                    title: 'Success',
                    message: 'Successfully Sent!',
                    type: 'success',
                  })
                  this.$refs.showPaymentReminderModal.hide()
                  break
              }
            })
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Please select payment reminder due date',
            })
          }
        } //for 2nd and 3rd reminder no date change pop up needed
        else {
          const resp = await DataSource.shared.sendReminderEmail(
            this.inputEmailTo,
            this.inputEmailSubject,
            encodeURI(JSON.stringify(this.inputEmailMessage)),
            this.invoiceNoForEmailReminder,
          )

          switch (resp.code) {
            case '2':
              this.$notify.error({
                title: 'Error',
                message: 'Send email error, please contact administrator',
              })
              break
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'Error',
              })
              break

            default:
              this.$notify({
                title: 'Success',
                message: 'Successfully Sent!',
                type: 'success',
              })
              this.$refs.showPaymentReminderModal.hide()
              break
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    splitReceiptList(value) {
      try {
        var splitList = []

        splitList = value

        return splitList.split(',')
      } catch (e) {
        this.results = e
      }
    },

    async SiblingConfirmationClick(value) {
      try {
        this.siblingConfirmationFlag = true

        //todo gather Rebate Refund detail, if eligible set isRefundRebateFlag to Y else N
        let Rebate_List = []
        if (this.spdRebateSelection.length > 0) {
          this.isRefundRebate = 'Y'
          this.spdRebateSelection.forEach(n => {
            let RebateDetail = {
              PK_Invoice_ID: n.PK_Invoice_ID,
              SPPD_PaymentAmount: n.SPPD_PaymentAmount,
              SPPD_GstValue: n.SPPD_GstValue,
              PK_Invoice_Detail_ID: n.PK_Invoice_Detail_ID,
              PK_SPD_ID: n.PK_SPD_ID,
              SPPD_PayerName: n.SPPD_PayerName,
              SPPD_PaymentItemType: n.SPPD_PaymentItemType,
              SPPD_TotalValue: n.SPPD_TotalValue,
              invoiceRefundNo: n.invoiceRefundNo,
              isRebate: 'Y',
            }
            Rebate_List.push(RebateDetail)
          })
        } else {
          this.isRefundRebate = 'N'
        }
        //todo gather Rebate Refund detail

        this.$vs.loading()
        //to preview invoice
        const invoiceResponse = await DataSource.shared.generateInvoice(
          JSON.stringify(this.siblingSPDList),
          this.studentID,
          this.studentCourseID,
          this.inputPaymentDueDate,
          this.inputRemarks,
          this.siblingInvoiceType,
          this.reInvoiceName,
          this.isRefundRebate,
          JSON.stringify(Rebate_List),
        )

        if (invoiceResponse.code === '88') {
          window.location.replace('/')
        } else if (invoiceResponse.code === '99' || invoiceResponse.code === '2') {
          this.$notify.error({
            title: 'Error',
            message: 'Failed to preview invoice!',
          })
        } else {
          this.displayPdf(invoiceResponse.code)

          if (this.siblingInvoiceType === 'Generate') {
            await this.getPaymentList()
            await this.getStudentInvoiceGenerationList()
            this.$refs.generateInvoiceModal.hide()
            this.$refs.showReInvoiceModal.hide()
            await this.clearSelect()
            this.cbPrintMonthlyBreakdown = false
          }
          // await this.clearSelect();
          this.$vs.loading.close()
        }

        // if(value==='Yes'){
        //     //cont
        // }
        // else{
        this.$refs.showSiblingConfirmationModal.hide()
        // }
        return value
      } catch (e) {
        this.results = e
      }
    },

    //Vue Tour :Start
    //todo:Apply payment plan Tour guide:start
    studentPaymentPlanTourStart(value) {
      this.tourPageControl = value
      if (value == 'pp') {
        this.$tours['MasterPageTourName'].start()
      } else if (value == 'sd') {
        if (this.isSiblingDiscountEligible) {
          this.$tours['MasterPageTourName'].start()
        } else {
          alert('No sibling/staff discount!!')
        }
      } else if (value == 'items') {
        this.$tours['MasterPageTourName'].start()
      } else if (value == 'gi') {
        this.$tours['MasterPageTourName'].start()
      } else if (value == 'gr') {
        this.$tours['MasterPageGRTourName'].start()
      } else if (value == 'cn') {
        this.TourGenerateCNFlag = []
        let list = []
        let CNFlagCount = 0
        this.PaymentListInt.forEach(m => {
          if (m.generateCNFlag == 'Yes') {
            list.push(m)
            CNFlagCount++
          }
        })

        this.TourGenerateCNFlag = list[0]

        if (CNFlagCount < 1) {
          alert('No credit note available')
        } else {
          this.$tours['MasterPageCNTourName'].start()
        }
      } else if (value == 'rf') {
        this.TourRefundFlag = []
        let list = []
        let RefundFlagCount = 0
        this.PaymentListInt.forEach(m => {
          if (m.refundFlag == 'Yes') {
            list.push(m)
            RefundFlagCount++
          }
        })

        this.TourRefundFlag = list[0]

        if (RefundFlagCount < 1) {
          alert('No refund available')
        } else {
          this.$tours['MasterPageRFTourName'].start()
        }
      }
    },
    sppTourPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1
      this.tourCallBackStepsFunc(finalSteps)
    },
    sppTourNextSteps(currentStep) {
      try {
        if (this.tourPageControl == 'pp') {
          setTimeout(() => {
            this.$tours['MasterPageTourName'].stop()
          }, 500)
          this.showGenerateInvoice()
          setTimeout(() => {
            this.$tours['InvModalPPTourName'].start()
          }, 500)
        } else if (this.tourPageControl == 'sd') {
          setTimeout(() => {
            this.$tours['MasterPageTourName'].stop()
          }, 500)
          this.showGenerateInvoice()
          setTimeout(() => {
            this.$tours['InvModalSDTourName'].start()
          }, 500)
        } else if (this.tourPageControl == 'items') {
          setTimeout(() => {
            this.$tours['MasterPageTourName'].stop()
          }, 500)
          this.showGenerateInvoice()
          setTimeout(() => {
            this.$tours['InvModalAITourName'].start()
          }, 500)
        } else if (this.tourPageControl == 'gi') {
          this.studentInvoiceListAreaBorder = false
          setTimeout(() => {
            this.$tours['MasterPageTourName'].stop()
          }, 500)
          this.showGenerateInvoice()
          setTimeout(() => {
            if (this.studentInvoiceGenerationListInt.length > 0) {
              this.$tours['InvModalGITourName'].start()
            } else {
              alert('Not invoice items to generate!,please add items/payment plan')
              this.$refs.generateInvoiceModal.hide()
            }
          }, 500)
        } else if (this.tourPageControl == 'gr') {
          this.studentReceiptListAreaBorder = false
          setTimeout(() => {
            this.$tours['MasterPageGRTourName'].stop()
          }, 500)
          this.showGenerateReceipt()
          setTimeout(() => {
            this.$tours['grModalTourName'].start()
            this.ddlPaymentMode = ''
          }, 500)
        } else if (this.tourPageControl == 'cn') {
          setTimeout(() => {
            this.getleftOverPaymentReceipt(objValue)
            this.$tours['MasterPageCNTourName'].start()
          }, 500)
        } else if (this.tourPageControl == 'rf') {
          setTimeout(() => {
            this.showRefund(objValue)
            this.$tours['MasterPageRFTourName'].start()
          }, 500)
        }
      } catch (e) {
        this.results = e
      }
    },
    InvModalPPTourPreviousSteps(currentStep) {
      setTimeout(() => {}, 500)
      // let finalSteps = currentStep - 1;
      // this.tourCallBackStepsFunc(finalSteps);
    },
    InvModalPPTourNextSteps(currentStep) {
      let finalSteps = currentStep + 1
      if (currentStep == 0) {
        setTimeout(() => {
          this.$tours['InvModalPPTourName'].stop()
        }, 500)
        this.$refs.generateInvoiceModal.hide()
        this.applyPaymentPlanClick()
        setTimeout(() => {
          this.$tours['ppModalTourName'].start()
        }, 500)
      }
    },
    InvModalSDTourPreviousSteps(currentStep) {
      setTimeout(() => {}, 500)
    },
    InvModalSDTourNextSteps(currentStep) {
      let finalSteps = currentStep + 1
      if (currentStep == 0) {
        setTimeout(() => {
          this.$tours['InvModalSDTourName'].stop()
        }, 500)
        this.$refs.generateInvoiceModal.hide()
        this.showDiscountPlanClick()
        setTimeout(() => {
          this.$tours['sdModalTourName'].start()
        }, 500)
      }
    },
    InvModalAITourPreviousSteps(currentStep) {
      setTimeout(() => {}, 500)
    },
    InvModalAITourNextSteps(currentStep) {
      let finalSteps = currentStep + 1
      if (currentStep == 0) {
        setTimeout(() => {
          this.$tours['InvModalAITourName'].stop()
        }, 500)
        this.$refs.generateInvoiceModal.hide()
        this.addItemClick()
        setTimeout(() => {
          this.$tours['aiModalTourName'].start()
        }, 500)
      }
    },
    InvModaGITourPreviousSteps(currentStep) {
      if (currentStep == 0) {
        this.studentInvoiceListAreaBorder = true
      } else {
        this.studentInvoiceListAreaBorder = false
      }
    },
    InvModalGITourNextSteps(currentStep) {
      if (currentStep == 0) {
        this.studentInvoiceListAreaBorder = true
      } else {
        this.studentInvoiceListAreaBorder = false
      }
    },
    RecModalGRTourNextSteps(currentStep) {
      let ddlPaymentModeValue = this.ddlPaymentMode
      if (ddlPaymentModeValue == 'CASH') {
        setTimeout(() => {
          this.$tours['grModalTourName'].stop()
          this.$tours['grModalTourCuztomizeName'].start()
        }, 500)
        if (currentStep == 2) {
          this.studentReceiptListAreaBorder = true
        } else {
          this.studentReceiptListAreaBorder = false
        }
      } else {
        if (currentStep == 3) {
          this.studentReceiptListAreaBorder = true
        } else {
          this.studentReceiptListAreaBorder = false
        }
      }
    },
    RecModalGRTourPreviousSteps(currentStep) {
      if (currentStep == 4) {
        this.studentReceiptListAreaBorder = false
      } else if (currentStep == 5) {
        this.studentReceiptListAreaBorder = true
      } else {
        this.studentReceiptListAreaBorder = false
      }
    },
    RecModalGRTourCuztomizePreviousSteps(currentStep) {
      if (currentStep == 2) {
        this.studentReceiptListAreaBorder = false
      } else if (currentStep == 3) {
        this.studentReceiptListAreaBorder = true
      } else {
        this.studentReceiptListAreaBorder = false
      }
    },
    RecModalGRTourCuztomizeNextSteps(currentStep) {
      if (currentStep == 1) {
        this.studentReceiptListAreaBorder = true
      } else {
        this.studentReceiptListAreaBorder = false
      }
    },
    MasterPageCNTourNextSteps() {
      setTimeout(() => {
        this.$tours['MasterPageCNTourName'].stop()
      }, 500)
      setTimeout(() => {
        this.showGenerateCreditNote(this.TourGenerateCNFlag)
      }, 500)
      setTimeout(() => {
        this.$tours['cnModalTourName'].start()
        this.studentCreditNoteListAreaBorder = true
      }, 1500)
    },
    MasterPageRFTourNextSteps() {
      setTimeout(() => {
        this.$tours['MasterPageRFTourName'].stop()
      }, 500)
      setTimeout(() => {
        this.showRefund(this.TourRefundFlag)
      }, 500)
      setTimeout(() => {
        this.$tours['rfModalTourName'].start()
        this.studentRefundListAreaBorder = true
      }, 1500)
    },
    MasterPageRFTourPreviousSteps() {},
    rfModalTourNextSteps(currentStep) {
      this.studentRefundListAreaBorder = false
    },
    rfModalTourPreviousSteps(currentStep) {
      if (currentStep == 1) {
        this.studentRefundListAreaBorder = true
      } else {
        this.studentRefundListAreaBorder = false
      }
    },
    CNModalTourNextSteps(currentStep) {
      this.studentCreditNoteListAreaBorder = false
    },
    CNModalTourPreviousSteps(currentStep) {
      if (currentStep == 1) {
        this.studentCreditNoteListAreaBorder = true
      } else {
        this.studentCreditNoteListAreaBorder = false
      }
    },
    tourCallBackStepsFunc(finalSteps) {},
    backToMasterPageTour() {
      this.$refs.generateInvoiceModal.hide()
      this.$refs.generateReceiptModal.hide()
      this.$refs.viewRefundModal.hide()
      if (this.tourPageControl == 'gr') {
        setTimeout(() => {
          this.$tours['grModalTourName'].stop()
          this.$tours['MasterPageGRTourName'].start()
        }, 500)
      } else if (this.tourPageControl == 'rf') {
        setTimeout(() => {
          this.$tours['rfModalTourName'].stop()
          this.$tours['MasterPageRFTourName'].start()
        }, 500)
      } else {
        setTimeout(() => {
          this.$tours['InvModalPPTourName'].stop()
          this.$tours['MasterPageTourName'].start()
        }, 500)
      }
    },
    backToInvModalPPTour() {
      this.$refs.newApplyPaymentPlanShowModal.hide()
      this.$refs.generateInvoiceModal.show()
      setTimeout(() => {
        this.$tours['ppModalTourName'].stop()
        this.$tours['InvModalPPTourName'].start()
      }, 500)
    },
    backToInvModalSDTour() {
      this.$refs.newApplyDiscountPlanShowModal.hide()
      this.$refs.generateInvoiceModal.show()
      setTimeout(() => {
        this.$tours['sdModalTourName'].stop()
        this.$tours['InvModalSDTourName'].start()
      }, 500)
    },
    backToInvModalAITour() {
      setTimeout(() => {
        this.$refs.newAddItemShowModal.hide()
        this.$refs.generateInvoiceModal.show()
      }, 500)

      setTimeout(() => {
        this.$tours['aiModalTourName'].stop()
        this.$tours['InvModalAITourName'].start()
      }, 500)
    },
    backToMasterCNPageTour() {
      this.studentCreditNoteListAreaBorder = false
      setTimeout(() => {
        this.$tours['cnModalTourName'].stop()
      }, 500)

      setTimeout(() => {
        this.$refs.creditNoteModal.hide()
        this.$tours['MasterPageCNTourName'].start()
      }, 600)
    },
    sdModalTourStop() {
      setTimeout(() => {
        this.$tours['sdModalTourName'].stop()
        // this.$refs.generateInvoiceModal.show();
      }, 500)
      this.$refs.newApplyDiscountPlanShowModal.hide()
    },
    ppModalTourStop() {
      setTimeout(() => {
        this.$tours['ppModalTourName'].stop()
        // this.$refs.generateInvoiceModal.show();
      }, 500)
      this.$refs.newApplyPaymentPlanShowModal.hide()
    },
    aiModalTourStop() {
      setTimeout(() => {
        this.$tours['aiModalTourName'].stop()
      }, 500)
      this.$refs.newAddItemShowModal.hide()
    },
    giModalTourStop() {
      setTimeout(() => {
        this.$tours['InvModalGITourName'].stop()
      }, 500)
      this.$refs.generateInvoiceModal.hide()
    },
    grModalTourStop() {
      setTimeout(() => {
        this.$tours['grModalTourName'].stop()
      }, 500)
      this.$refs.generateReceiptModal.hide()
    },
    cnModalTourStop() {
      setTimeout(() => {
        this.$tours['cnModalTourName'].stop()
      }, 500)
      this.$refs.creditNoteModal.hide()
    },
    rfModalTourStop() {
      setTimeout(() => {
        this.$tours['rfModalTourName'].stop()
      }, 500)
      this.$refs.viewRefundModal.hide()
    },
    stopTour() {
      if (this.tourPageControl == 'gr') {
        this.$tours['MasterPageGRTourName'].stop()
      } else {
        this.$tours['MasterPageTourName'].stop()
        this.$tours['MasterPageCNTourName'].stop()
      }
    },
    //todo:Apply payment plan Tour guide:end
    //Vue Tour :End

    async countReceiptTotalValue(rows) {
      try {
        this.spdSelection = rows
        let total = 0.0
        this.spdSelection.forEach(v => {
          total += parseFloat(v.newPayAmount)
        })
        this.selectedleftOverReceiptTotal = parseFloat(total).toFixed(2)
      } catch (e) {
        this.results = e
      }
    },
    async changeReceiptPayAmount(value) {
      try {
        let total = 0.0
        this.spdSelection.forEach(n => {
          total += parseFloat(n.newPayAmount)
        })
        this.selectedleftOverReceiptTotal = parseFloat(total).toFixed(2)
      } catch (e) {
        this.results = e
      }
    },
    async reverseReceiptTotalCount(value) {
      try {
        let totalBeforeCalculation = 0.0
        totalBeforeCalculation = parseFloat(value).toFixed(2)
        let checkedLength = this.spdSelection.length
        let i = 1

        //todo: sort checkbox selection list
        this.spdSelection = this.spdSelection.slice().sort(function (a, b) {
          return a.totalValue - b.totalValue
        })

        this.spdSelection = this.spdSelection.map(n => {
          totalBeforeCalculation -= parseFloat(n.totalValue).toFixed(2)

          n.newPayAmount = parseFloat(n.totalValue).toFixed(2)

          if (checkedLength == i && totalBeforeCalculation !== 0) {
            n.newPayAmount = parseFloat(n.totalValue) + parseFloat(totalBeforeCalculation)
            n.newPayAmount = parseFloat(n.newPayAmount).toFixed(2) //to fix the trailing decimal issue
            Vue.set(n, parseFloat(n.newPayAmount), parseFloat(n.newPayAmount))
          }
          i++
          return n
        })
      } catch (e) {
        this.results = e
      }
    },

    async showReprint(value) {
      this.rePrintValue = value
      this.reprintHistoryListInt = []
      try {
        this.$vs.loading()
        const resp = await DataSource.shared.getStudentDtlPaymentGateway('', this.studentID, '', '', this.rePrintValue.DocumentType)
        if (resp) {
          if (resp.code == '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error',
            })
            this.reprintPayeeName = ''
            this.reprintAddress = ''
            this.reprintStudentName = ''
            this.reprintStudentIDNumber = ''
            this.reprintLevel = ''
            this.reprintProgramme = ''
          } else {
            let List = resp.Table[0]
            //todo: bind reprint overview items
            this.reprintPayeeName = List.PayeeName
            this.reprintAddress = List.ParentAddress1 + ',' + List.ParentAddressCityCountryPostal
            this.reprintStudentName = List.StudentName
            this.reprintStudentIDNumber = List.IDNumber
            this.reprintIDType = List.IDType
            this.reprintLevel = List.ClassName
            this.reprintProgramme = List.Batch
            await this.getReprintHistory(this.rePrintValue.InvRecID, this.rePrintValue.DocumentType)
          }
        }

        this.$refs.showReprintModal.show()
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    async rePrintClick() {
      try {
        let InvRecID = this.rePrintValue.InvRecID
        this.$vs.loading()
        if (this.rePrintValue.DocumentType == 'Invoice') {
          const resp = await DataSource.shared.reprintInvoice(InvRecID, this.studentID)
          if (resp) {
            if (resp.code == '3') {
              this.$notify.error({
                title: 'Reprint Not Allow',
                message: 'no changes on payee details/student info',
              })
            } else if (resp.code === '4') {
              this.$notify.error({
                title: 'Reprint Not Allow',
                message: 'Please check with IT administrator(old invoice before got audit table)',
              })
            } else {
              this.displayPdf(resp.code)
              this.$refs.showReprintModal.hide()
            }
          }
          this.$vs.loading.close()
        } else if (this.rePrintValue.DocumentType == 'Receipt') {
          const resp = await DataSource.shared.reprintReceipt(InvRecID, this.studentID)
          if (resp) {
            if (resp.code === '3') {
              this.$notify.error({
                title: 'Reprint Not Allow',
                message: 'no changes on payee details/student info',
              })
            } else if (resp.code === '4') {
              this.$notify.error({
                title: 'Reprint Not Allow',
                message: 'Please check with IT administrator(old receipt before got audit table)',
              })
            } else {
              this.displayPdf(resp.code)
              this.$refs.showReprintModal.hide()
            }
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },

    async getReprintHistory(InvRecID, type) {
      try {
        const resp = await DataSource.shared.getReprintHistoryList(InvRecID, type)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Error',
          })
        } else {
          this.reprintHistoryListInt = resp.Table
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },

    async getReprintDocument(InvRecID, auditID, type, documentNo) {
      try {
        this.$vs.loading()
        const resp = await DataSource.shared.getReprintDocumentHistory(InvRecID, auditID, type)

        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Error',
          })
        } else if (resp.code === '2') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot retrieve reprint file!',
          })
        } else {
          this.displayPdf(resp.code, documentNo)
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async onchangeRebateSelection() {
      if (this.SchoolFeeRebateValue) {
        //this is rebate droplist selected
        this.isSchoolFeeRebateDisabled = true
        this.selectedRebateDesc = this.SchoolFeeRebateValue
        this.inputRefundRemarks = this.SchoolFeeRebateValue
        this.schoolRebateFlag = true

        if (this.spdSelection.length == 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select 1 School Fees above!',
          })
          // this.resetRefundModal();
          this.schoolRebateFlag = false
        } else if (this.spdSelection.length !== 1) {
          this.$notify.error({
            title: 'Error',
            message: 'No School Fees items selected/ multiple items selected, cannot proceed!',
          })
          // this.resetRefundModal();

          this.schoolRebateFlag = false
        } else {
          //user select only 1 spd item

          if (this.spdSelection[0].RD_Item_Description.includes('School Fee')) {
            //valid can proceed for rebate generation
            this.schoolRebateFlag = true
          } else {
            //prompt error as the selection is not school fee
            this.$notify.error({
              title: 'Error',
              message: 'Not School Fees items. cannot proceed!',
            })
            //this.resetRefundModal();
            this.schoolRebateFlag = false
          }
        }
      } else {
        //normal refund as no rebate droplist selected
        this.inputRefundRemarks = ''
        this.isSchoolFeeRebateDisabled = false
        this.selectedRebateDesc = ''
        this.schoolRebateFlag = false

        if (this.spdSelection.length == 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
          // this.resetRefundModal();
          this.schoolRebateFlag = false
          this.isSchoolFeeRebateDisabled = false
        }
      }
    },

    //todo check isIntlSchool(For rebate/refund) and assign then assign the rebate dropdown at refund b-modal 5th June 2020
    async checkIsIntlSchool() {
      // UserSchool_Session
      this.schoolFeesRebateOptions = ''
      let schID = Cookies.get('schoolSession')

      const resp = await DataSource.shared.getSchoolInfoBySchoolID(schID)
      if (resp) {
        if (resp.code === '99') {
          console.log('99')
        } else if (resp.code === '88') {
          console.log('88')
        } else {
          this.isIntlSchoolInt = resp.Table
          let schoolType = resp.Table[0].SCH_StudentNoPrefix.replace(/[^a-zA-Z ]/g, '')
          this.showRefundGstOptions = schoolType === 'SG'
          this.isIntlSchoolInt.forEach(n => {
            if (n.SCH_SchoolType.includes('International') || schID === 'SCH201400000553') {
              //console.log('this.intlSchoolFeesRebateOptions',this.intlSchoolFeesRebateOptions);
              this.schoolFeesRebateOptions = this.intlSchoolFeesRebateOptions
            } else if (n.SCH_SchoolType.includes('Japanese')) {
              this.schoolFeesRebateOptions = this.japSchoolFeesRebateOptions
            } else {
              this.schoolFeesRebateOptions = this.localSchoolFeesRebateOptions
            }
          })
        }
      }
    },

    //todo check isCorporateFinance else hide the "tagSchoolRebate" button
    async checkIsCorporateFinance() {
      const resp = await DataSource.shared.getUserSch()
      if (resp) {
        switch (resp.code) {
          case '2':
            break
          case '88':
            break
          case '99':
            this.isCorporateFinance = false
            break
          default:
            resp.Table.forEach(n => {
              if (n.CONSchool === 'SCH20120000001') {
                this.isCorporateFinance = true
              }
            })
        }
      }
      return
    },
    //todo hide the rebate dropdown if isMiddletonSchool.
    async hideMiddletonRebateDropdown() {
      let schID = Cookies.get('schoolSession')
      //International	SCH201800000510	024	Middleton - Tampines
      //International	SCH201600000354	021	Middleton International School
      //International	SCH202100000591	026	Middleton West Coast
      if (schID === 'SCH201800000510' || schID === 'SCH201600000354' || schID === 'SCH202100000591') {
        this.showRebateDropdown = false
        this.showCalculateFPS = true
      } else {
        this.showRebateDropdown = true
        this.showCalculateFPS = false
      }
      // console.log('this.showRebateDropdown', this.showRebateDropdown);
    },
    //todo hide the rebate dropdown if isMiddletonSchool.

    //todo check whether the rebate already use or not.
    async validateIsRepeatedRebate() {
      const resp = await DataSource.shared.getStudentSchoolFeeRebate(this.studentID, 'Y', this.SchoolFeeRebateValue)
      if (resp) {
        if (resp.code === '99') {
          console.log('99')
        } else if (resp.code === '88') {
          console.log('88')
        } else if (resp.code === 2) {
          return 2
        } else {
          return false
        }
      }
    },

    //to replace the template reminder date with the selection date
    onClickReplaceInvoiceReminderDueDate() {
      //console.log('on change current date : ' +this.reminderInvDueDate);
      this.inputEmailMessage = this.inputEmailMessage.replace(this.reminderInvDueDate, this.inputInvoiceReminderDueDate)
      this.reminderInvDueDate = this.inputInvoiceReminderDueDate
    },

    async PrintReminder() {
      var divToPrint = document.getElementById('reminderTextArea')

      var newWin = window.open('', 'Print-Window')

      newWin.document.open()

      newWin.document.write('<html><body onload="window.print()"><p style="white-space: pre-line;">' + $(divToPrint)[0].innerHTML + '</p></body></html>')

      newWin.document.close()

      setTimeout(function () {
        newWin.close()
      }, 10)
    },

    async checkJPNSchool() {
      try {
        const resp = await DataSource.shared.getSchoolInfoBySchoolID(Cookies.get('schoolSession'))
        console.log('JPN SCHOOL', resp.Table)
        if (resp) {
          if (resp.code === '99') {
          } else if (resp.code === '88') {
          } else {
            //a==0 ? "zero" : "not zero"
            resp.Table[0].SCH_Country === 'Japan' ? (this.isJPNSchool = true) : (this.isJPNSchool = false)
            resp.Table[0].SCH_Country === 'Bhutan' ? (this.isBhutanSchool = true) : (this.isBhutanSchool = false)
            console.log('this.isJPNSchool', this.isJPNSchool)
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    handleRefundGSTChange(val) {
      this.refundListInt = this.refundListInt.map(d => {
        if (d.RD_GST_Applicable === 'Yes') {
          let editedValue = (d.itemAmount * Number(this.refundGstRate.substring(0, 1))) / 100
          d.gstValueEdited = Number(editedValue).toFixed(2)
        } else {
          d.gstValueEdited = d.gstValue
        }
        d.totalAmount = Number(Number(d.itemAmount) + Number(d.gstValueEdited)).toFixed(2)
        d.newRefundAmount = d.totalAmount
        return d
      })
      this.$forceUpdate()
    },
    handleRefundAmountChange(item) {
      let gstRate = this.refundGstRate.substring(0, 1) / 100
      const total = item.newRefundAmount
      const percentage = gstRate
      // Calculate the value of itemAmount
      const itemAmount = total / (1 + percentage)
      // Calculate gstValue
      // const gstValue = percentage * itemAmount;
      const gstValue = total - itemAmount

      item.itemAmount = Number(itemAmount).toFixed(2)
      item.gstValueEdited = Number(gstValue).toFixed(2)
      item.totalAmount = Number(total).toFixed(2)
    },
    handleReInvoiceGSTChange(val) {
      this.ReInvoiceListInt = this.ReInvoiceListInt.map(d => {
        let editedValue = (d.SPPD_PaymentAmount * Number(this.reInvoiceGSTRate.substring(0, 1))) / 100
        d.SPPD_GstValueEdited = Number(editedValue).toFixed(2)
        d.SPPD_TotalValue = Number(Number(d.SPPD_PaymentAmount) + Number(d.SPPD_GstValueEdited)).toFixed(2)
        d.newPayAmount = d.SPPD_TotalValue
        return d
      })
      this.$forceUpdate()
    },
    handleReInvoiceAmountChange(item) {
      let gstRate = this.reInvoiceGSTRate.substring(0, 1) / 100
      item.SPPD_PaymentAmount = Number(item.newPayAmount / (1 + gstRate)).toFixed(2)
      item.SPPD_GstValueEdited = Number(item.SPPD_PaymentAmount * gstRate).toFixed(2)
      item.SPPD_TotalValue = Number(item.newPayAmount).toFixed(2)
    },
  },

  watch: {
    inputReceiptDate() {
      const m = moment(this.inputReceiptDate, 'DD/MM/YYYY HH:mm')
      if (m.valueOf() <= Number(new Date(this.invoiceTimestamp))) {
        const newTs = Number(new Date(this.invoiceTimestamp)) + 60 * 1000
        const d = new Date(newTs)
        this.inputReceiptDate = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getMinutes()}`
      }
    },

    isJPNSchool(value) {
      if (value) {
        this.gstRate = 10
      }
    },

    gstRate(gst) {
      for (let i in this.studentInvoiceGenerationListInt) {
        const row = this.studentInvoiceGenerationListInt[i]
        if (row.SPPD_PaymentItemType === 'Taxable') {
          const gstAmt = row.SPPD_PaymentAmount * (gst / 100)
          this.studentInvoiceGenerationListInt[i].newGSTAmount = gstAmt.toFixed(2)
          this.studentInvoiceGenerationListInt[i].SPPD_GstValue = gstAmt.toFixed(2)
          this.studentInvoiceGenerationListInt[i].SPPD_TotalValue = (row.SPPD_PaymentAmount + gstAmt).toFixed(2)
        }
      }
      this.$forceUpdate()
    },
    spdSelection(value) {
      this.studentReceiptLeftOverPaymentListInt.forEach((item, index) => {
        const newPayAmountValue = item.newPayAmount
        const filteredItem = {}

        Object.keys(item).forEach(key => {
          if (!(!isNaN(parseInt(key[0])) && item[key] !== newPayAmountValue)) {
            filteredItem[key] = item[key]
          }
        })

        this.studentReceiptLeftOverPaymentListInt[index] = filteredItem
      })
    },
  },
}
</script>
<style scoped>
.el-date-editor {
  width: 100% !important;
}

.buttonArea {
  margin: 20px 0 0 0;
}

.requiredFieldsMsg {
  color: red;
  font-weight: bold;
}

.btn-primary {
  display: inline;
}

.buttonArea .btn-primary {
  margin: 0 0 0 20px;
}

.actionDiv {
  text-align: right;
}

.EligibleColor {
  color: green !important;
}

.NotEligibleColor {
  color: red !important;
}

.textArea {
  width: 100%;
  resize: none;
}

.divBorderClass {
  border-style: solid;
  border-color: red;
}

.el-pagination {
  display: none;
}

@media print {
  body * {
    visibility: hidden;
  }

  .print-container,
  .print-container * {
    visibility: visible;
  }
}
</style>

<style>
#viewTransactionModal .el-table .cell {
  float: left;
}
</style>
